import React, { useContext, useEffect, useState, useRef, createContext } from 'react';
import { xs_isMobile, xs_sessionToken } from '../../.';
import { getLabel } from '../../data/labels';
import { calcBonusMinMaxSystem, getBonusMultiple, getBonusSystem } from '../bonus-utils';
import { UserContext } from './UserConf';
import { LandingRequestedOpsContext } from '../landing/LandingRequestedOpsConf';
import { TicketPrinterContext } from '../printer/TicketPrinterContext';
import { checkAcceptance, getOddsCheckerData, getPurchaseResponse, getTaxes, playableInMultiple, reloadReservedTicket, reserveTicket, taxesEnabled, getTicketData, getStakeTaxed, getStakeTaxedTupleWithPrecision, checkForSelectionsUpdate, getBetBuilderOdd, getScheduledPurchaseTransaction, deleteReservation, deleteReservationBatch, getLogiSimulateSelections, getBetBuilderReducedOdds} from '../purchase-service';
import {generateFrontendTransactionId, saveFrontendTransactionId, getPendingFrontendTransactionId, PURCHASE_RETRY, retryCheckPurchaseTicket, removeFrontendTransactionId } from '../retry-service';
import { PvrContext } from '../pvr/PvrConf';
import { ShopContext } from '../shop/ShopConf';
import { setBetslipEventsNumber } from '../sport-utils';
import { getConfiguration } from '../utils/configuration';
import { getCurrencyValue } from '../utils/getCurrencyValue';
import { getDataAndSelectionsFromBetslipTicketDTO } from '../utils/getDataAndSelectionsFromBetslipTicketDTO';
import { getPrintableAmount } from '../utils/getPrintableAmount';
import { truncateDoubleTo } from '../utils/truncateDoubleTo';
import { getDateFromTimestamp } from '../utils/getDateFromTimestamp';
import { compare2Dates } from '../utils/compare2Dates';
import { setAdditionalUkTuples } from '../utils/setAdditionalUkTuples';
import { isUKCombinationMaskEnabled } from '../utils/isUKCombinationMaskEnabled';
import { additionalUkTuplesRules } from '../utils/setAdditionalUkTuples';
import { getAggregationAndBetFromBetIdAndSportId } from '../utils/getAggregationAndBetFromBetIdAndSportId';
import { formatDate } from '../utils/formatDate';
import { getFormattedFullTimestamp } from '../utils/getFormattedFullTimestamp';
import { convertToDecimalWithPrecision } from '../utils/convertToDecimalWithPrecision';
import { roundForCurrency } from '../utils/roundForCurrency';
import { addInhibitKeysListener } from '../utils/addInhibitKeysListener';
import { removeInhibitKeysListener } from '../utils/removeInhibitKeysListener';
import { BonusContext } from './BonusConf';
import { calculateSysData } from './comb';
import { ControlPanelContext } from '../control-panel-context/ControlPanelConf';
import { specialIncreasedBets } from '../utils/specialIncreasedBets';
import { getEnv } from '../env';
import $ from 'jquery';
import { humanPurchaseTokenCheckpoint } from '../turnstile-utils';
import { isPromoToggleable } from '../promo-betslip-utils';
import { isBetsson } from '../utils/isBetsson';
import { calculateBetBuilderOdd } from '../utils/calculateBetBuilderOdd';
import { xs_clearVipSystemData, xs_getVipSystemData, xs_setVipSystemData } from '../util/LocalStorage';

export const BetslipContext = createContext(null);
const onBetslipSelectionsChange = window.appConfig?.HANDLERS?.['onBetslipSelectionsChange'];

window.cvee = function(){ console.log('Cavy <3 ti vogliamo bene, ma non possiamo lasciartelo fare')}

function areDrawsEquals(selA, selB){
	return selA.scomSogei === selB.scomSogei &&
		   selA.handicap == selB.handicap &&
		   selA.draw === selB.draw;
}

function calculateAndStoreBetBuilderOdds(selection, betBuilderMarket, accountNum){
	const conf = getConfiguration();
	let odd = 0;
	if(betBuilderMarket.subMarketsSet.length > 1){
		if(conf.bbc.type === 'ITALIA'){
			odd = calculateBetBuilderOdd(betBuilderMarket.subMarketsSet); 
			if(conf.bbc.bcko){
				//controllo se l'utente e' whitelistato
				let enabledUser = true;
				if(conf.bbc.accwl){
					enabledUser = Object.keys(conf.bbc.accwl).length === 0 || !accountNum || conf.bbc.accwl[accountNum];
				}
				if(enabledUser){
					// calcolo della riduzione quote dal backend
					betBuilderMarket.nonReducedOdd = odd; // dichiaro la quota totale non ridotta
					addBodyShadow();
					const result = getBetBuilderReducedOdds(selection);
					removeBodyShadow();
					if(result?.code === 0) {
						// riassegno tutti i valori calcolati dal backend agli oggetti
						// che puntano alla bet builder market.
						selection.betBuilderMarket = JSON.parse(result.object);
						betBuilderMarket = selection.betBuilderMarket;
						odd = betBuilderMarket.odd;
					}				
				}
			}  		
		}
		else {
			const requestSelection = {...selection};
			requestSelection.bets = betBuilderMarket.subMarketsSet;
			addBodyShadow();
    		const betBuilderOddContainer = getBetBuilderOdd(requestSelection);
    		removeBodyShadow();	 
    		if(betBuilderOddContainer && betBuilderOddContainer.code === 0){
    			odd = parseInt(betBuilderOddContainer.object);
    		}
		}
    							
	}
	betBuilderMarket.odd = odd;

}

function createStringForSystemCalc(selection, bet) {
    let idAvv = `${selection.pal}_${selection.avv}`;
    if(bet.legabile){
    	idAvv = idAvv + `${bet.scomSogei}_${bet.handicap}_${bet.codDraw}`;
    }
	return [
        0, // codice manif
        idAvv, // ID AVV
        `${bet.scomSogei}_${bet.handicap}`, // ID_SCOM
        0, // codice sport
        bet.odd, // quota in centesimi 
        bet.scomSogei,
        `${bet.handicap};0`, // h1
        bet.descBet, 
        selection.descEvent, 
        bet.descDraw, 
        selection.pal, 
        selection.avv, 
        bet.scomSogei, 
        "false", 
        `${bet.handicap};0`, // h1
        0,
        "timestamp", //timestamp 
        "class_sp", 
        "M", 
        "0",
        (selection.banker ? "1" : "0")
    ].join('|');
}

function getAddAndBetStorageParams(){
    let addNBetStorageString = localStorage.getItem('xs_add_n_bet_params');
    let addNBetStorage = null;
    if(addNBetStorageString != null){
        addNBetStorage = JSON.parse(addNBetStorageString);
    }
    
    return addNBetStorage;
}

export function isLiveBetting(selections, container){
    let isLive = false;
    for(let i in selections){
        isLive = isLive || selections[i].isLive;
        if(container === 'singlebets'){
            return isLive;
        }
    }
    return isLive;
}

function closeBetslipIfNoSelectionsLeft(betslipData, couponId) {
    if (betslipData.coupons[couponId].selections.length === 0) {
        let closeBetslip = true;
        const coupons = Object.values(betslipData.coupons);
        for (let i = 0; i < coupons.length; i++) {
            if ((i + 1) !== couponId && coupons[i].selections.length > 0) {
                closeBetslip = false;
                break;
            }
        }
        if (closeBetslip) {
            window.dispatchEvent(new Event('close-betslip'));
        }
    }
}


// assegno un id fittizio ad ogni bet builder market assicurandomi che sia sempre lo stesso ogni volta che passi lo stesso set di selezioni
function assignBetBuilderMarketIds(selectionBBMap, ordinarySelectionList){
	const sortingArray = [];
	for(let ks in selectionBBMap){
		const duplicate = JSON.parse(JSON.stringify(selectionBBMap[ks]));
		duplicate.mapKey = ks;
		sortingArray.push(duplicate);
	}
	
	// ordino l'array di selezioni in base alla map key. Questo farà ordinamento alfabetico sulle stringhe pal_avv (che sono le chiavi di selectionMap). In questo modo
	// l'ordine sarà sempre lo stesso
	sortingArray.sort((a, b) => {
		if(a.mapKey < b.mapKey) { return -1; }
    	if(a.mapKey > b.mapKey) { return 1; }
    	return 0;
	});
	for(let k in sortingArray){
		const mapKey = sortingArray[k].mapKey;
		const bbm = selectionBBMap[mapKey].betBuilderMarket;
		bbm.scomSogei = "bb" + k; // è l'indice del vettore
		bbm.draw = 0;
		bbm.handicap = 0;
	}
	if(ordinarySelectionList){
		for(let ks in ordinarySelectionList){
			const selection = ordinarySelectionList[ks];
			const keyBB = selection.pal + "_" + selection.avv;
			//aggiorno gli id fittizi dei mercati betbuilder anche in questa struttura dati
			if(selectionBBMap?.[keyBB]){
				const bets = selection.bets;
				if(bets[0].isBetBuilderMarket){
					bets[0].scomSogei = selectionBBMap[keyBB].betBuilderMarket.scomSogei;
				}
			}
		}

	}
}

if(!window.setLastTicketPurchasedOnLS){
	window.setLastTicketPurchasedOnLS = function(protocol, ticketId, loadInCartOnRerender, playDirectly, stake, win){
		const obj = {
				protocol : protocol,
				id : ticketId,
				loadInCartOnRerender : loadInCartOnRerender,
				playDirectly : playDirectly,
				stake,
				win
		}
		localStorage.setItem('LAST_TICKET_PURCHASED', JSON.stringify(obj));
	}
}


if(!window.getLastTicketPurchasedOnLS){
	window.getLastTicketPurchasedOnLS = function(){
		const obj = localStorage.getItem('LAST_TICKET_PURCHASED');
		return obj? JSON.parse(obj) : null;
	}
}

function pushSuccessPurchaseNotification(amount, type, realPurchase, ticketId, isShop, ticketData){
	const notificationData = {amount : amount, type : type, realPurchase: realPurchase, ticketId : ticketId, ticketData : ticketData};
	if(typeof window.pushSuccessPurchaseNotification === 'function'){
		window.pushSuccessPurchaseNotification(notificationData);
	}
	if(!isShop){
		try {
			window.dispatchEvent(new CustomEvent('xs_purchaseSuccess', {detail: notificationData}));
		}
		catch(err) {
			console.log(err);
		}	
	}
	
}

function addBodyShadow() {
	if(window.cg_USER){
		$('body').addClass('pointerNone');
	}
	$('#xs-mobile').addClass('pointerNone');
	$('.pagina-sport').addClass('pointerNone');
	$('.xshop-body').addClass('pointerNone');
	$('#xs_mobile').addClass('pointerNone');
	$('#xsport-container').addClass('pointerNone');	
	$('#betslip-container').addClass('shadowBetting');
	$('#betslip-overlay .loader-cart').addClass('shadowBetting');
	$('#sidebar-dx').scrollTop(0);
	addInhibitKeysListener();
}
function removeBodyShadow() {
	$('body').removeClass('pointerNone');
	$('#xs-mobile').removeClass('pointerNone');
	$('#xsport-container').removeClass('pointerNone');
	$('.pagina-sport').removeClass('pointerNone');
	$('.xshop-body').removeClass('pointerNone');
	$('#xs_mobile').removeClass('pointerNone');
	$('#betslip-container').removeClass('shadowBetting');
	$('#betslip-overlay .loader-cart').removeClass('shadowBetting');
	removeInhibitKeysListener();
}

function addWageringShadow() {
	$('#xs-mobile').addClass('blurLoadWageringData');
	$('.pagina-sport').addClass('blurLoadWageringData');
	$('.xshop-body').addClass('blurLoadWageringData');
	$('#xs_mobile').addClass('blurLoadWageringData');
	$('#betslip-container').addClass('blurLoadWageringData');
}
function removeWageringShadow() {
	$('#xs-mobile').removeClass('blurLoadWageringData');
	$('.pagina-sport').removeClass('blurLoadWageringData');
	$('.xshop-body').removeClass('blurLoadWageringData');
	$('#xs_mobile').removeClass('blurLoadWageringData');
	$('#betslip-container').removeClass('blurLoadWageringData');;
}

window.addBodyShadow = addBodyShadow;
window.removeBodyShadow = removeBodyShadow;
window.addWageringShadow = addWageringShadow;
window.removeWageringShadow = removeWageringShadow;

function endBetslipTransaction(){
	removeBodyShadow();
	if(window.XSocket){
		window.XSocket.setFreeApp();
	}
}

function startBetslipTransaction(){
	addBodyShadow();
	if(window.XSocket){
		window.XSocket.setBusyApp();
	}
}

function BetslipConf(props) {
    const conf = getConfiguration();
    const frontendVersion = getEnv('REACT_APP_FRONTEND_VERSION');
	const isNewFrontend = frontendVersion === 'betclic' || frontendVersion === 'betway' || frontendVersion === 'starcasino';
	const SELECT_WAGERING_PROMO_ANYWAY = isNewFrontend || frontendVersion === 'skywind';
	const TICKET_PURCHASED_CUSTOM_POPUP = isNewFrontend && xs_isMobile;
    const isSecondScreen = window.location.href.includes('second-screen');
	const avoidSinglebets = props.apkPosLite || frontendVersion === 'skywind';
    useEffect(() => {
        if (isSecondScreen) {
            const bc = new BroadcastChannel('second-screen-betslip');
			bc.onmessage = (event) => {
                if (event.data.type === 'setBetslipData') {
					setSecondScreenBetslip(event.data.payload.isVirtual, event.data.payload.bonusData);
				}
			}
            return () => {
                bc.close();
            };
        }
    }, []);

	/** [contexts stable references]
	 * if a React Context is used into a state object function (no matter if a callback, a function like "purchase" and so on)
	 * its pointed value is the "snapshotted" one taken during the function declaration. 
	 * F.E. if contextA = { a:1}, and I declare a  function into betslipContext (that after all is an useState) that
	 * will use that context, then the context value will be always {a:1} even if in the rest of the application has been
	 * updated. To solve this, we need to use a stable reference which keep always the brand new context value.
	 * BTW, this issue is not affecting the self reference, betslipContext is updated in its state, f.e. in purchase function
	 *   */
    const ctxs = useRef({}).current;
    ctxs.controlPanelContext = useContext(ControlPanelContext);
	ctxs.bonusContext = useContext(BonusContext);
	ctxs.userContext = useContext(UserContext);
	ctxs.shopContext = useContext(ShopContext);
    ctxs.pvrContext = useContext(PvrContext);
    ctxs.ticketPrinterContext = useContext(TicketPrinterContext);
    ctxs.landingRequestedOpsContext = useContext(LandingRequestedOpsContext);
    
	const isMobile = xs_isMobile;
	const stakeTaxConfiguration = {
			enabled : false,
			percentage : 0,
			type : 'none'
	}
	if(conf.skta && conf.skta.showTax){
		stakeTaxConfiguration.enabled = true;
		stakeTaxConfiguration.type = "advice_for_online_distro";
		stakeTaxConfiguration.percentage = conf.skta.percentage;
	}
	else if(conf.cs.tb && conf.cs.tb != 0){
		stakeTaxConfiguration.enabled = true;
		stakeTaxConfiguration.type = "conf_for_purchase";
		stakeTaxConfiguration.percentage = conf.cs.tb;
	}

	const messageOnModalsEnabled = conf.mbv || props.xsportDesktop2; 
	
    const [betslipContext, setBetslipContext] = useState({
	    betslipData: null,
	    selectionMap : null,
	    selectionEventsMap:null,
	    betBuilderSelectionMap : null,
	    toggledSelection : false,
	    localStorageKey : null,
	    localStorageAcceptanceKey :"ACCEPTANCE_PEND_LS",
	    bonusData : null,
	    buttonPlayState : 'play',
	    loaderData : { type : "hideAll" },
	    cartMessage : null,
	    betInProgress : false,
	    transactionIdAcceptance : null,
	    transactionIdAcceptanceForProposal : null,
	    keepContainer : false,
	    reservations : null,
	    showedReservationBox : false,
	    scrollable : conf.bpd,
	    betOptionsSectionHasToBeShowed : false,
	    betOptionsData : null,
	    betOptionsSelection : {value:'REAL', type:null},
	    loadInProgress :false,
	    keypadShown : false,
	    user : null,
	    addAndBet :  false,
	    addAndBetAmount :  0,
	    addAndBetToken : null,
	    timeoutErrorAddAndBet : 1500,
	    settingsVisible : false,
        enableCustomAliases: conf.cal && localStorage.getItem('xs_custom_aliases_enabled') != null,
	    toGetBonusAdvise : null,
	    stakeTaxConfiguration : stakeTaxConfiguration,
	    betslipCollapsed : false,
	    isVirtual : false,
	    minimumBetAmount : null,
	    minimumBetAmountSystem : null,
	    minimumUnitAmount : null,
	    minimumCombAmount : null,
	    provProfileEnabled : null,
	    provDoubleProfileValue : null,
		secondScreenBetslipPurchaseRefreshTimeout: null,
		selectionsBeforeProposal : null,
		betBuilderMatch : null,
	    betslipMode : "BUY",
	    betslipPromo : {},
	    updateFullContext : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.betslipContext[ko] = val;
			}
			//update effectly
			setBetslipContext(prev => {
                return {...prev, ...updt};
            });
        },
	    
	    setBetslipMode : function(betslipMode){
	    	ctxs.betslipContext.updateFullContext({betslipMode});
	    },
	    	    
	    isBetBuilder : function(){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let isBetBuilder = false;
	    	for(let ks in coupon.selections){
	    		const selection = coupon.selections[ks];
	    		for(let km in selection.bets){
	    			isBetBuilder = isBetBuilder || selection.bets[km].isBetBuilderMarket;
	    		}
	    	}
	    	return coupon.betBuilderSelections != null && Object.keys(coupon.betBuilderSelections).length > 0 && isBetBuilder;
	    },

		isPrintingSystembetsDetailEnabled: function () {
			return !ctxs.betslipContext?.isVirtual && ctxs.shopContext?.enabled && ctxs.shopContext?.type == 'TERMINAL' && ctxs.shopContext?.operator?.printingSystembetsDetailEnabled;
		},
	    
	    calculateLocalStorageKey : function (){
	    	
	    	let localStorageKey = 'BETSLIP_LS';
	    	
	    	if(ctxs.betslipContext.isVirtual){
	    		localStorageKey = 'BETSLIP_PSV_LS';
	    	}
	    	else if(ctxs.betslipContext.betBuilderMatch){
	    		localStorageKey = 'BETSLIP_LS_BETBUILDER_' + ctxs.betslipContext.betBuilderMatch.pal + "_" + ctxs.betslipContext.betBuilderMatch.avv;
	    	}

	    	if(ctxs.betslipContext.localStorageKey !== localStorageKey){
				ctxs.betslipContext.updateFullContext({localStorageKey});
	    	}
	    },
	    
	    setProvSettings(provDoubleProfileValue){
			console.debug("setProvSettings");
	    	ctxs.betslipContext.provDoubleProfileValue = provDoubleProfileValue;
	    	const provProfileEnabled = provDoubleProfileValue !== null;
	    	ctxs.betslipContext.provProfileEnabled = provProfileEnabled;
			setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			provProfileEnabled : provProfileEnabled,
	    			provDoubleProfileValue : provDoubleProfileValue
	    		}
	    	});
	    },
	    
		toggleBetslipCollapsed : function(){
			const newValue = !ctxs.betslipContext.betslipCollapsed;
			ctxs.betslipContext.betslipCollapsed = newValue;
			setBetslipContext(function(prev){
	    		return {
	    			...prev,
					betslipCollapsed : newValue
	    		}
	    	});
		},
		isBetslipCollapsed : function (){
			return ctxs.betslipContext.betslipCollapsed;
		},

		setVirtual : function (isVirtual){
			const minimumBetAmount = isVirtual? conf.cs.vma.imv : conf.cs.imqf;
			const minimumBetAmountSystem = isVirtual? minimumBetAmount : conf.cs.imqfs;
		    const minimumUnitAmount = isVirtual? conf.cs.vma.imuv : conf.cs.imu;
		    const minimumCombAmount = isVirtual? conf.cs.vma.imcv : conf.cs.imcqf;
		    const defaultAmountByConfiguration = isVirtual? conf.cs.vma.amdv : conf.cs.amd;
			ctxs.betslipContext.updateFullContext({
				isVirtual : isVirtual,
	    		minimumBetAmount : minimumBetAmount,
	    		minimumUnitAmount : minimumUnitAmount,
	    		minimumCombAmount : minimumCombAmount,
	    		minimumBetAmountSystem:minimumBetAmountSystem,
	    		defaultAmountByConfiguration : defaultAmountByConfiguration
			});
		},
		
	    setUser : function(user){
	    	if(ctxs.betslipContext.betInProgress || ctxs.betslipContext.transactionIdAcceptanceForProposal != null){
	    		return;
	    	}
	    	ctxs.betslipContext.user = user;
	    	let addAndBet = false;
	    	let addAndBetAmount = 0;
	    	let addAndBetToken = null;
	    	if(user && user.logged){
	    		if(conf.anbe){
		    		const addAndBetStorageParam = getAddAndBetStorageParams();
		    		if(addAndBetStorageParam != null){
		    			if(addAndBetStorageParam.enabled){
		    				// check if the user is a new user (or a new login)
		    				if(user.sessionToken !== addAndBetStorageParam.userToken){
		    					// new token, it must be disabled
		    					ctxs.betslipContext.disableAddAndBet();
		    				}
		    				else{
		    	    			addAndBet = addAndBetStorageParam.enabled;
		    	    			addAndBetAmount = addAndBetStorageParam.amount;
		    	    			addAndBetToken = addAndBetStorageParam.userToken;
		    				}
		    			}
		    		}
	    		}
	    		if(user.generalFrontendJsonConfiguration?.oddVariation){
	    			const oddVariation = ctxs.betslipContext.user.generalFrontendJsonConfiguration.oddVariation;		
	    			ctxs.betslipContext.changeOddVariation(oddVariation, false);
	    		}
	            const lastTicket = window.getLastTicketPurchasedOnLS();
	            // checking also if it is a playDirectly operation: if yes, I reload the ticket and I will purchase it directly
	            if(lastTicket && lastTicket.loadInCartOnRerender && lastTicket.playDirectly){
	            	const protocolOk = (lastTicket.protocol === 'PSV' && ctxs.betslipContext.isVirtual) || (lastTicket.protocol === 'PSQF' && !ctxs.betslipContext.isVirtual);
	            	if(protocolOk){
	            		// void the reload ticket info
	            		window.setLastTicketPurchasedOnLS(lastTicket.protocol, lastTicket.id, false, false, lastTicket.stake, lastTicket.win);
	            		ctxs.betslipContext.reloadTicket(lastTicket.id, true);
	            	}
	            }
	            if(user.reservations && !ctxs.shopContext.enabled){
	            	ctxs.betslipContext.loadReservationsLocalStorage();	            
	            }
	            ctxs.betslipContext.loadBetOptionsIfEnabled();
	            if(conf.pbs){
            		ctxs.betslipContext.manageBetslipPromo();
            	}
	    	}
	    	ctxs.betslipContext.updateFullContext({
    			user,
    			addAndBet,
    			addAndBetAmount,
    			addAndBetToken
	    	});
	    },
	    
	    isBetslipSettingsVisible : function (){
	    	return ctxs.betslipContext.settingsVisible;
	    },
	    
	    setBonusData : function(bonusData){
	    	if(ctxs.betslipContext.betInProgress || ctxs.betslipContext.transactionIdAcceptanceForProposal != null){
	    		return;
	    	}
	    	let redoCalcs = false;
	    	if(bonusData){
	    		const oldSignature = ctxs.betslipContext.bonusData?.hashIntegrity || "";
	    		redoCalcs = oldSignature !== bonusData.hashIntegrity;
	    	}
	    	ctxs.betslipContext.updateFullContext({bonusData});
	    	if(redoCalcs){
	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    	}
	    },
	    
	    toggleBetslipSettings : function(){
	    	ctxs.betslipContext.updateFullContext({settingsVisible : !ctxs.betslipContext.settingsVisible});
	    },
	    
	    
	    changeCoupon : function(coupon){
            /*if (!isSecondScreen) {
                const bc = new BroadcastChannel('second-screen-betslip');
                bc.postMessage({
                    type: 'changeCoupon',
                    payload: coupon
                });
                bc.close();
            }*/
	    	ctxs.betslipContext.setLoaderData({type:'hideAll'});
			//ctxs.betslipContext.removeBetOptionsSection();
			ctxs.betslipContext.setBetInProgress(false);
    		if(ctxs.shopContext.enabled){
    			ctxs.shopContext.setFree();
    		}
			ctxs.betslipContext.betslipData.selectedCoupon = coupon + "";
			ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
			ctxs.betslipContext.restoreReservationBoxStatus();
			ctxs.betslipContext.loadBetOptionsIfEnabled();
	    },
	    
	    changeContainer : function(container){
	    	const systemPSVAvailable =  ctxs.betslipContext.systembetsOpeningIsAvailable();
	    	let enhancedOddsItaly = false;
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const selections = coupon.selections;
    		for(let ks in selections){
    			const selection = selections[ks];
    			for(let km in selection.bets){
	    			const bet = selection.bets[km];
	    			enhancedOddsItaly  = enhancedOddsItaly || bet.scomSogei < 0;
    			}
    		}
			const singlebetWithBonusAvailable = container === 'singlebets' && coupon.multipleBonus?.applied;
    		//const cannotChange = (container === 'systembets' && (!systemPSVAvailable || enhancedOddsItaly)) || (container !== 'systembets' && !singlebetWithBonusAvailable);
	    	const cannotChange = (container === 'systembets' && (!systemPSVAvailable || enhancedOddsItaly));
	    	const changeAvailable = !cannotChange;
	    	if(changeAvailable){
		    	coupon.selectedContainer = container;
		    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
		    	ctxs.betslipContext.loadBetOptionsIfEnabled();
	    	}
	    	else { 
	    		if(!systemPSVAvailable){
		    		ctxs.betslipContext.setCartWarning(getLabel('virtual.betslip.no_system_with_diff_sport'));	    		
	    		}
	    		else if(enhancedOddsItaly){
					ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('betslip.systembet_forbidden_with_magg'));	    			
	    		}
	    	}
	    },
	    
	    setGeneralStake : function(stake, combinationIndexToToggle, fieldTextValue){
			const coupon = ctxs.betslipContext.getCurrentCoupon();
			if(coupon.selectedContainer === 'systembets'){
				// taking total combinations selected
				if(stake == null){
					stake = coupon.amountSystem || coupon.amountMulti;
				}
				const userSystemSelections = coupon.userSystemSelections;
    			const combinations = coupon.calculatedSystemData.comb;
 				let totalCombsSelected = 0;
	            for (let ks in userSystemSelections) {
	            	if(parseInt(ks) === parseInt(combinationIndexToToggle)){
	            		 userSystemSelections[ks].selected = !userSystemSelections[ks].selected;
	            	}
	                if (userSystemSelections[ks].selected) {
	                    if (combinations[ks] != null) {
	                        totalCombsSelected += combinations[ks];
	                    }
	                }
	            } 
	            if(totalCombsSelected > 0){
	                let valuePerTuple = stake / totalCombsSelected;
	                valuePerTuple = parseInt(Math.ceil(valuePerTuple));
	                const module = valuePerTuple % ctxs.betslipContext.minimumCombAmount;
	                if (valuePerTuple < ctxs.betslipContext.minimumCombAmount ) {
	                    valuePerTuple = ctxs.betslipContext.minimumCombAmount;				   
	                } 
	                else if (module != 0) {
	                    const rest = (valuePerTuple / ctxs.betslipContext.minimumCombAmount) % 1 === 0? 0 : (valuePerTuple % ctxs.betslipContext.minimumCombAmount);
	                    valuePerTuple  = valuePerTuple - rest;
	                    valuePerTuple = parseInt(valuePerTuple);
	                    if (valuePerTuple < ctxs.betslipContext.minimumCombAmount) {
	                        valuePerTuple = ctxs.betslipContext.minimumCombAmount;
	                    }  
	                }
	                for (let ks in userSystemSelections) {
	                    if (userSystemSelections[ks].selected) {
	                        userSystemSelections[ks].printableAmount = getPrintableAmount(valuePerTuple, conf.cs.m, conf.cs.nd);
	                        userSystemSelections[ks].amount = valuePerTuple;
	                    }
	                }  	
	                // the final stake will be calculated thanks to the setBetslipData (it will do again the calcs based on the setted comb amount)            	
	            	coupon.printableAmountSystem = fieldTextValue;
	            	coupon.amountSystem = stake;
	            }  			
			}
			else {

				if(coupon.selections.length === 1 && coupon.selections[0].bets.length === 1 && !avoidSinglebets){
					coupon.selections[0].bets[0].amount = stake;
					coupon.amountSingle = stake;
				}
				else{
					coupon.amountMulti = stake;
					coupon.printableAmountMulti = fieldTextValue;				
				}

			}	    
			betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);	  
	    },
	    getSuggestedAmount : function (){
	    	const frontendType = ctxs.shopContext.enabled? ctxs.shopContext.type : 'ONLINE';
	    	if(ctxs.betslipContext.user?.logged && frontendType === 'ONLINE' &&  conf.bak.type === 'USER_SUGGESTION' && ctxs.betslipContext.user?.lastTickets.length > 0){
				return ctxs.betslipContext.user?.lastTickets[0].amount;
			}
			return 0;
	    },
	    initBetslipData : function() {
		
	    	
	    	if(ctxs.betslipContext.betInProgress || ctxs.betslipContext.transactionIdAcceptanceForProposal != null){
	    		return;
	    	}
	    	let source = localStorage.getItem(ctxs.betslipContext.localStorageKey);
	    	let betslipData = null;
	    	if(source != null){
	    		betslipData = JSON.parse(source);
	    	}
	    	if(betslipData == null){
				const suggestedAmount = ctxs.betslipContext.getSuggestedAmount();
	    		// betslip model definition
	    		betslipData = {};
                betslipData.defaultAmount = ctxs.betslipContext.defaultAmountByConfiguration || ctxs.betslipContext.minimumBetAmount;
                betslipData.defaultAmountSystem = ctxs.betslipContext.minimumBetAmountSystem;
	    		betslipData.coupons = {};
	    		let coupon = {};
	    		coupon.selections = [];
	    		coupon.totalDraws = 0;
	    		coupon.userSystemSelections = {};
	    		coupon.calculatedSystemData = {};
	    		coupon.selectedContainer = avoidSinglebets? 'multibets' : conf.bco[0];
	    		coupon.potentialWinning = 0;
	    		coupon.amountSystem = 0;
	    		coupon.amountMulti = suggestedAmount || betslipData.defaultAmount; // multibets
	    		coupon.amountSingle = 0;

	    		coupon.totalCombs = 0;
	    		coupon.betOnAll = betslipData.defaultAmountSystem;
	    		coupon.betOnAllEnabled = false;
	    		coupon.multipleBonus = null;
	    		coupon.multipleTaxedBonus = null;
	    		let oddVariation = 'NEVER';
	    		if(!window.appConfig?.TERMINAL_AGENCY && ctxs.betslipContext.user?.logged && ctxs.betslipContext.user.generalFrontendJsonConfiguration?.oddVariation){
	    			oddVariation = ctxs.betslipContext.user.generalFrontendJsonConfiguration.oddVariation;
	    		}
	    		else {
	    			if(window.appConfig?.TERMINAL_AGENCY && conf.rs.dovpo){
	    				oddVariation = "NEVER";
	    			} 
	    			else if(conf.ovs){
		    			for(let k in conf.ovs.vls){
		    				if(conf.ovs.vls[k].df){
		    					oddVariation = conf.ovs.vls[k].ty;
		    				}
		    			}
	    			}
	    		}
	    		coupon.oddVariation = oddVariation;
	    		coupon.splitAmount = 0;
	    		coupon.printableSplitAmount = 0;
	    		coupon.printableAmountMulti = getPrintableAmount(coupon.amountMulti, conf.cs.m, conf.cs.nd);
	    		coupon.printableAmountSystem = getPrintableAmount(betslipData.defaultAmountSystem, conf.cs.m, conf.cs.nd); // just on xsport_desktop_2 is read (AmountBetslipForm)
	    		coupon.printableBetOnAll = getPrintableAmount(coupon.betOnAll, conf.cs.m, conf.cs.nd);
	    		
	    		betslipData.coupons["1"] = JSON.parse(JSON.stringify(coupon));
	    		betslipData.coupons["2"] = JSON.parse(JSON.stringify(coupon));
	    		betslipData.coupons["3"] = JSON.parse(JSON.stringify(coupon));
	    		betslipData.coupons["4"] = JSON.parse(JSON.stringify(coupon));
	    		betslipData.coupons["5"] = JSON.parse(JSON.stringify(coupon));
	    		// default view
	    		betslipData.selectedCoupon = "1";
	    		betslipData.isMobile = isMobile;
                betslipData.saveBetslip = false;
               // betslipData.isPsv = ctxs.betslipContext.isVirtual;
	    		
	    	}
	    	else{
	    		if(window.appConfig?.TERMINAL_AGENCY && conf.rs.dovpo){
	    			for(let kc in betslipData.coupons){
	    				betslipData.coupons[kc].oddVariation = "NEVER";
	    			}
	    		}
	    	}
	    	betslipData.isPsv = ctxs.betslipContext.isVirtual; // I update this field in anycase
	    	ctxs.betslipContext.betslipData = betslipData;
	    	// remove the variations color if any
	    	ctxs.betslipContext.removeUpdatedInfo();

	    	// load reservations from local storage
	    	if(ctxs.betslipContext.reservations == null){
	    		ctxs.betslipContext.loadReservationsLocalStorage();
	    	}

	    	ctxs.betslipContext.setBetslipData(betslipData, true, false);

	    	// check if the reservation box has to be shown or not
	    	ctxs.betslipContext.restoreReservationBoxStatus();
	    	
	    	ctxs.betslipContext.loadScrollableProp();
	    	
	    	
	    	// check acceptance stuff
	    	let pendingTranId = ctxs.betslipContext.checkPendingAcceptance();
	    	if(pendingTranId != null && pendingTranId !== "" &&  ctxs.betslipContext.user && ctxs.betslipContext.user.logged && !ctxs.betslipContext.isVirtual){
	    		// deactivating the requested operation, without any location change
	    		ctxs.landingRequestedOpsContext.disable(true, false);
	    		ctxs.betslipContext.acceptance(pendingTranId);
	    	}
	    	else{
	    		const scheduledPurchaseParameters = localStorage.getItem('PURCHASE_TRANSACTION_SCHEDULED_DATA') != null? JSON.parse(localStorage.getItem('PURCHASE_TRANSACTION_SCHEDULED_DATA')) : null;
	    		if(scheduledPurchaseParameters && ctxs.betslipContext.user && ctxs.betslipContext.user.logged && !ctxs.betslipContext.livePollingInProgress){
		    		ctxs.betslipContext.setBetInProgress(true);
		    		if(ctxs.shopContext.enabled){
		    			ctxs.shopContext.setBusy();
		    		}
	    			scheduledPurchaseParameters.delay = 1; // start polling immediatly
	    			ctxs.betslipContext.startPurchasePolling(scheduledPurchaseParameters);
	    		}
				else if((ctxs.landingRequestedOpsContext.enabled && ctxs.landingRequestedOpsContext.betslipLandingData)){
	    			// there are operations requested by queryString; I'll perform them, and disable the landingContext
	    			// to avoid the replication at the next render
	    			const landingOps = ctxs.landingRequestedOpsContext.betslipLandingData;
	    			const playDirectlyEnabled = ctxs.betslipContext.user && ctxs.betslipContext.user.logged && (landingOps.playDirectly);
	    			if(landingOps.playDirectly == false || playDirectlyEnabled){
	    				// I will load the data from our backend in two cases:
	    				// 1) the user is logged and the request is "playDirectly"
	    				// 2) the user is not logged and the request IS NOT "playDirectly
	    				// if the user is not logged and we must purchase direclty, then the account will ask for 
	    				// a login. After that, it will location.reload with the same querystring, re-triggering this kind
	    				// of flow
	    				if(landingOps.selectionsData){
	    					// selections in queryString. Calling backend to retreive the ticket
	    					getOddsCheckerData(landingOps.selectionsData, (ticket) =>{
	    						// success
	    						const dataBetslip = getDataAndSelectionsFromBetslipTicketDTO(ticket);
	    						const selections = dataBetslip.selections;
	    						const amount = dataBetslip.amount;
	    						const systemSelections = dataBetslip.systemSelections;
	    						if(selections.length > 0 && amount > 0){
									if(landingOps?.append) {
										dataBetslip?.selections?.forEach((s) => {
											s?.bets?.forEach((bet) => {
												if(!ctxs.betslipContext.isDrawSelected(s.pal,s.avv,bet.scomSogei,bet.handicap,bet.draw)) {
													ctxs.betslipContext.toggleSelectionBetslip(
														s.pal,
														s.avv,
														s.alias,
														s.descEvent,
														s.isLive,
														bet.scomSogei,
														bet.handicap,
														bet.descBet,
														bet.draw,
														bet.descDraw,
														bet.odd,
														bet.legabile,
														s.descSport,
														s.descTournament,
														s.timestamp,
														s.sportId,
														s.tournamentId,
														null,
														null,
														s.matchData);
												}
											})
										})

									}else{
										ctxs.betslipContext.putSelections(selections, amount, systemSelections);
									}
									setBetslipEventsNumber(ctxs.betslipContext.getCouponSelectionsNum());
	    						}
	    						if(landingOps.playDirectly){
	    							ctxs.betslipContext.purchase();
	    						}
	    						else{
	    							// here it was reload = true
	    							ctxs.landingRequestedOpsContext.disable(true, false);
	    						}
	    						
	    					},
	    					() =>{
	    						//error
    							// here it was reload = true
    							ctxs.landingRequestedOpsContext.disable(true, false);
	    					});
	    					
	    				}
	    				else if(landingOps.reservationCode){
	    					// reservationCode to be reloaded. Calling backend to retreive the ticket
	    					reloadReservedTicket(landingOps.reservationCode, (data) => {
	    						if(data != null){
	    							if(data.code == 0){
	    								try{
	    									const coupon = JSON.parse(data.object);
	    									ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon] = coupon;
	    									ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);	   
											let someClosedSelection = false;
											for(let ks in coupon.selections){
												someClosedSelection = someClosedSelection || coupon.selections[ks].closed;
											}
											if(someClosedSelection){
												ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
											}
											setBetslipEventsNumber(ctxs.betslipContext.getCouponSelectionsNum()); 					
	    									if(landingOps.playDirectly){
	    										ctxs.betslipContext.purchase();
	    									}
	    									else{
	    		    							// here it was reload = true
	    		    							ctxs.landingRequestedOpsContext.disable(true, false);
	    									}
	    								}
	    								catch(e){
	    									ctxs.betslipContext.setCartError('Prenotazione non valida');
	    								}
	    							}
	    							else{
	    								ctxs.betslipContext.setCartError(data.description, data.code);
	    								ctxs.betslipContext.showModalAdviseIfProvided('error', data.description, data.code);
	    							}
	    							ctxs.betslipContext.hideReservationBox();	    				
	    						}
	    					});
	    				}
	    			}
	    		}
	    	}
	    	//ctxs.betslipContext.loadBetOptionsIfEnabled();
	    },
	    
	    changeOddVariation : function(oddVariation, storeBackend){
	    	if(window.appConfig?.TERMINAL_AGENCY && conf.rs.dovpo){
	    		oddVariation = 'NEVER';
	    	}
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(coupon.oddVariation != oddVariation){
		    	coupon.oddVariation = oddVariation;
		    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, true, false);
		    	if(ctxs.betslipContext.user?.logged && !ctxs.shopContext.enabled && storeBackend){
		    		ctxs.userContext.saveGeneralFrontendConfiguration({oddVariation});
		    	}
	    	}
	    }, 
	    
	    loadScrollableProp : function(){
	    	let scrollable = localStorage.getItem('XSP_SCROLLABLE_CART');
	    	scrollable = scrollable == null? "" + conf.bpd : scrollable;
	    	ctxs.betslipContext.setScrollableCart(scrollable === "true");
	    },
	    setScrollableCart : function(scrollable){
	    	ctxs.betslipContext.scrollable = scrollable;
	    	localStorage.setItem('XSP_SCROLLABLE_CART', scrollable + "");
    		setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			scrollable : scrollable
	    		}
	    	});
	    },
	    
	    toggleScrollable : function (){
	    	const newValue = !ctxs.betslipContext.scrollable;
	    	ctxs.betslipContext.setScrollableCart(newValue);
	    },
	    
	    isScrollable : function(){
	    	return ctxs.betslipContext.scrollable;
	    },

		setSecondScreenBetslipPurchaseRefreshTimeout : function(timeout) {
			console.debug("setSecondScreenBetslipPurchaseRefreshTimeout");
	    	ctxs.betslipContext.updateFullContext({secondScreenBetslipPurchaseRefreshTimeout : timeout});
		},
	    
	    putSelections : function(selections, amountMulti, systemSelections, betBuilderSelections){
	    	ctxs.betslipContext.disableAddAndBet();
	    	let betslipData = JSON.parse(JSON.stringify(ctxs.betslipContext.betslipData));
	    	let keyCoupon = betslipData.selectedCoupon;
	    	let coupon = betslipData.coupons[keyCoupon];
	    	let container = null;
	    	if(selections.length === 1 && conf.bco[0] === 'singlebets' && !avoidSinglebets && !betBuilderSelections){
	    		if(playableInMultiple(selections[0].bets)){
	    			container = 'multibets';
	    		}
	    		else{
	    			container = 'singlebets';
	    		}
	    	}
	    	else{
	    		container = 'multibets';
	    	}
	    	coupon.selectedContainer = container;
	    	if(systemSelections != null){
	    		coupon.selectedContainer = 'systembets';
	    		coupon.userSystemSelections = systemSelections;
	    	}
	    	
	    	let avoidLiveSelection = false;
	    	let avoidPrematchSelection = false;
	    	if(ctxs.shopContext.enabled && ctxs.shopContext.type === 'SELF-CASHIER'){
	    		const cashier = ctxs.shopContext.getShopUser();
	    		if(cashier && cashier.logged){
	    			avoidLiveSelection = !cashier.liveEnabled;
	    			avoidPrematchSelection = !cashier.prematchEnabled;	    			
	    		}
	    	}
	    	let filteredSelections = [];
	    	let totalDraws = 0;
	    	for(let k in selections){
	    		if(selections[k].isLive){
		    		if(!avoidLiveSelection){
		    			filteredSelections.push(selections[k]);
		    			for (let i = 0; i < selections[k].bets.length; i++) {
		    				const bet = selections[k].bets[i];
		    				if(!bet.isBetBuilderMarket){
			    				totalDraws ++;		    				
		    				}
		    				else {
		    					totalDraws += bet.subMarketsSet.length;
		    				}
			    		}
		    		}
	    		}
	    		else{
		    		if(!avoidPrematchSelection){
		    			filteredSelections.push(selections[k]);
		    			for (let i = 0; i < selections[k].bets.length; i++) {
		    				const bet = selections[k].bets[i];
		    				if(!bet.isBetBuilderMarket){
			    				totalDraws ++;		    				
		    				}
		    				else {
		    					totalDraws += bet.subMarketsSet.length;
		    				}		    			
			    		}
		    		}
	    		}
	    	}
	    	coupon.selections = filteredSelections;
			coupon.betBuilderSelections = betBuilderSelections;
	    	coupon.amountMulti = amountMulti;
	    	coupon.totalDraws = totalDraws;
	    	coupon.printableAmountMulti = getPrintableAmount(amountMulti, conf.cs.m, conf.cs.nd);
	    	// save the new betslip in localstorage
	    	ctxs.betslipContext.clearBetslip();
    		ctxs.betslipContext.setBetslipData(betslipData, true, false);	    		
    		// check if the reservation box has to be shown or not
    		ctxs.betslipContext.restoreReservationBoxStatus();
    		//ctxs.betslipContext.removeBetOptionsSection();
	    	ctxs.betslipContext.loadBetOptionsIfEnabled();
	    },
	    
	    manageBetslipPromo : function(){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let betslipPromo = {};
    		if(ctxs.betslipContext.user?.logged && ctxs.betslipContext.user?.betslipPromo){
    			const userPromo = ctxs.betslipContext.user.betslipPromo;
    			for(let kp in userPromo){
    				const promo = userPromo[kp];
    				if(promo.activated){
						promo.toggleable = false;
						promo.percentage = '100%';
						promo.selected = true;
					}
					else{
						const selContainer = isPromoToggleable(promo, coupon, ctxs.betslipContext.isBetBuilder());
    					promo.toggleable = selContainer.toggleable;
    					promo.percentage = selContainer.percentage;
    					promo.selected = promo.selected;
					}	
    				betslipPromo[kp] = promo;
    			}  
    		}    	
	    	ctxs.betslipContext.updateFullContext({betslipPromo});
	    },
	    
	    toggleSelectedBetslipPromo : function (sigla){
	    	const betslipPromo = ctxs.betslipContext.betslipPromo;
	    	if(betslipPromo[sigla].toggleable){
	    		if(betslipPromo[sigla].selected){
			    	betslipPromo[sigla].selected = false;	    		
	    		}
	    		else{
	    			// ne sta attivando una, tutte le altre devono essere disabilitate
	    			for(let kp in betslipPromo){
	    				if(!betslipPromo[kp].activated){
	    					// se non e' già stata attivata
			    			betslipPromo[kp].selected = false;	    				
	    				}
		    		}
		    		betslipPromo[sigla].selected = true;	 
	    		}
	    	}
	    	ctxs.betslipContext.updateFullContext({betslipPromo});
	    	ctxs.betslipContext.setRealMoney();
	    },
	    
	    disableAllBetslipPromo : function(){
	    	const betslipPromo = ctxs.betslipContext.betslipPromo;
	    	if(betslipPromo){
		    	for(let kp in betslipPromo){
		    		betslipPromo[kp].selected = false;
		    	}
	    	}
	    	ctxs.betslipContext.updateFullContext({betslipPromo});	    
	    },
	    
	    getSelectedBetslipPromos : function(){
	    	const sigle = [];
	    	const betslipPromo = ctxs.betslipContext.betslipPromo;
	    	if(betslipPromo){
		    	for(let kp in betslipPromo){
		    		if(betslipPromo[kp].selected && !betslipPromo[kp].activated){
		    			sigle.push(kp);
		    		}
		    	}
	    	}
	    	return sigle.join(";");
	    },
	    
	    getSelection : function (pal, avv){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	for(let ks in coupon.selections){
	    		const selection = coupon.selections[ks];
	    		if(selection.pal == pal && selection.avv == avv){
	    			return selection;
	    		}
	    	}
	    	return false;
	    },
	    
	    isBetBuilderOddSelectable : function (sportId, pal, avv, scomSogei, handicap, codDraw){
	    	let selectable = true;
	    	const keyScomToAdd = scomSogei + "_" + codDraw;
	    	if(window.betBuilderConfiguration && !ctxs.betslipContext.isBetBuilderDrawSelected(pal, avv, scomSogei, handicap, codDraw)){
	    		const selection = ctxs.betslipContext.getSelection(pal, avv);
	    		if(selection){
	    			// se non c'è la selezione, significa che è il primo esito di questo evento in bet builder e quindi può essere aggiunto
		    		const bbSportConf = window.betBuilderConfiguration.cpes[sportId];
		    		if(bbSportConf){
		    			for(let km in selection.bets){
		    				const bet = selection.bets[km];
		    				if(bet.isBetBuilderMarket){
		    					for(let kmb in bet.subMarketsSet){
		    						const subMarket = bet.subMarketsSet[kmb];
		    						const keyScomAdded = subMarket.scomSogei + "_" + subMarket.draw;
		    						selectable = selectable && (bbSportConf.ecmb[keyScomAdded]?.[keyScomToAdd]);
		    					}
		    				}

		    			}
		    		}	    		
	    		}		
	    	}
	    	return selectable;
	    },
	    
	    handleBetBuilderMarket : function (sportId, pal, avv, scomSogei, handicap, draw, descBet, descDraw, subMarketOdd){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(!coupon.betBuilderSelections){
	    		coupon.betBuilderSelections = {};
	    	}
	    	const keyAvv = pal + "_" + avv;
	    	
	    	if(!coupon.betBuilderSelections[keyAvv]){
	    		coupon.betBuilderSelections[keyAvv] = {
	    			pal,
	    			avv,
	    			sportId,
	    			betBuilderMarket :{
	    				subMarketsSet : [],
	    				isBetBuilderMarket : true
	    			}
	    		};
	    	}
	    	const removeEvent = scomSogei == null;
	    	if(removeEvent){
	    		delete coupon.betBuilderSelections[keyAvv];
	   			return null;
	    	}
	    	else {
	    	
	    	}
	    	const subMarketToAdd = {
	    		scomSogei,
	    		handicap,
	    		draw,
	    		descBet,
	    		descDraw,
	    		odd : subMarketOdd,
				nonReducedOdd : subMarketOdd
	    	};
	    	const selection = coupon.betBuilderSelections[keyAvv];
	    	let betBuilderMarket = selection.betBuilderMarket;

	    	let indexToRemove = null;
			for(let km in betBuilderMarket.subMarketsSet){
				const subMarket = betBuilderMarket.subMarketsSet[km];
				// riassegno le quote originali alle submarket, per far si di non ridurre di nuovo una quota già ridotta (se faccio un semplice toggle la ruota ripartirebbe)
				if(subMarket.nonReducedOdd){
					subMarket.odd = subMarket.nonReducedOdd;
				}

				if(areDrawsEquals(subMarketToAdd, subMarket)){
					indexToRemove = km;
				}
				else if(subMarket.scomSogei === scomSogei){
					// qualcosa e' andato storto: non posso aggiungere due esiti della stessa scommessa/handicap
					return null;
				}
			}
			
			if(indexToRemove != null){
				// rimuovo la selezione che e' stata tolta
				betBuilderMarket.subMarketsSet.splice(indexToRemove, 1);
			}
			else {
				betBuilderMarket.subMarketsSet.push(subMarketToAdd);
			}
			
	    	// calcolo quota totale ed eventuali sottoquote (verranno salvate direttamente in betBuilderMarket)
			calculateAndStoreBetBuilderOdds(selection, betBuilderMarket, ctxs.userContext.getUser().accountNum);   	
	    	// filtro gli eventi con 0 sottoscommesse: significa che devono essere rimossi
	    	let newList = {};
	    	for(let ks in coupon.betBuilderSelections){
	    		const bbm = coupon.betBuilderSelections[ks].betBuilderMarket;
	    		if(bbm.subMarketsSet.length > 0){
	    			newList[ks] = coupon.betBuilderSelections[ks];
	    		}
	    	}
	    	coupon.betBuilderSelections = newList;
			//aggiornamento scomSogei fittizi
			assignBetBuilderMarketIds(coupon.betBuilderSelections, coupon.selections);

			ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData);
	    	return betBuilderMarket;
	    },
	        
	    toggleSelectionBetslip : function(pal, 
	    								  avv, 
	    								  eventAlias, 
	    								  descAvv, 
	    								  isLive, 
	    								  cs, 
	    								  hand, 
	    								  descBet, 
	    								  codDraw, 
	    								  descDraw, 
	    								  odd, 
	    								  legabile, 
	    								  descSport, 
	    								  descTournament, 
	    								  timestamp, 
	    								  sportIdSource, 
	    								  tournamentId, 
	    								  minPl, 
	    								  maxPl, 
	    								  matchDataInput, 
	    								  betBuilderDraw = false){
			if(ctxs?.shopContext?.enabled){
				if(conf?.rs?.ssbprt){
					ctxs.betslipContext.setSecondScreenBetslipPurchaseRefreshTimeout(null);
				}
			}
	    	if(ctxs.betslipContext.betInProgress){
	    		return;
	    	}
	    	if(betBuilderDraw){
	    		ctxs.betslipContext.disableAddAndBet();
	    	}
	    	//TODO aggiungere i campi se necessario
	    	let matchData = null;
	    	if(matchDataInput){
	    		matchData = {
	    			urlPath : matchDataInput.urlPath,
	    			urlPathSeo : matchDataInput.urlPathSeo,
	    			urlPathSeoSettings : matchDataInput.urlPathSeoSettings,
					isLive: matchDataInput.isLive,
					sportRef: matchDataInput.sportRef,
					categoryRef: matchDataInput.categoryRef,
					tournamentRef: matchDataInput.tournamentRef,
					id: matchDataInput.id
	    		}
	    	}
	    	
	    	let sportId = sportIdSource;
	    	let psvPlatformCode = null;
	    	if((sportIdSource + "").indexOf("_") > 0){
	    		const values = sportIdSource.split("_");
	    		psvPlatformCode = window.parseInt(values[0]);
	    		sportId = window.parseInt(values[1]);
	    	}
	    	let systembetsEnabled = false;
	    	for(let k in conf.bco){
	    		if(conf.bco[k] === 'systembets'){
	    			systembetsEnabled = true;
	    		}
	    	}
	    	const systemIntegralsEnabled = conf.syie != null? conf.syie : true;
	    	
	    	let avoidLiveSelection = false;
	    	let avoidPrematchSelection = false;
	    	if(ctxs.shopContext.enabled && ctxs.shopContext.type === 'SELF-CASHIER'){
	    		const cashier = ctxs.shopContext.getShopUser();
	    		if(cashier && cashier.logged){
	    			avoidLiveSelection = !cashier.liveEnabled;
	    			avoidPrematchSelection = !cashier.prematchEnabled;	    			
	    		}
	    	}
	    	
	    	if((avoidLiveSelection && isLive) || (avoidPrematchSelection && !isLive)){
	    		// is not possible to bet with this selection
	    		return;
    		}
	    	
	    	if(ctxs.betslipContext.addAndBet){
	    		// remove all the previous bets
		    	ctxs.betslipContext.clearBetslip();
	    	}
	    	if(timestamp == null || typeof timestamp !== 'string'){
	    		console.log("TIMESTAMP NULL");
	    		timestamp = '';
	    	}
	    	
	    	let selected = false;
	    	let coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let keyCoupon = ctxs.betslipContext.betslipData.selectedCoupon;
	    	let selectedContainer = coupon.selectedContainer;
	    	let selections = coupon.selections;
			
	    	// remove all the bets for the event
	    	let removeEvent = cs == null;
	    	let selectionToBeChanged = null;
	    	let added = false;
	    	let addedWhat = '';
	    	let removed = false;
	    	
	    	let found = false;
	    	let eventBets = null;
	    	let eventSelection = null;
	    	let addedBet = null;
	    	if(conf.bbc.en && conf.bbc.type !== 'ITALIA'){ // QUANDO SARA' POSSIBILE, DOVREMO RIFERIRCI AL SOLO conf.bbc.mult == false, che indica che il betbuilder non può essere giocato in multipla
	    		// devo fare in modo che se c'è una selezione bet builder, sia l'unica
	    		
	    		// 1) se c'è gia' una selezione betbuilder, devo essere sicuro che e' la stessa che ho iniziato a comporre
	    		// 2) se ci sono gia' selezioni normali, non deve essere possibile aggiungere un esito bet builder
	    		let blockForForeignEnv = false;
	    		if(selections.length > 0){
	    			const selezioneBetBuilderPrecedente = selections[0].bets[0].isBetBuilderMarket;
	    			if(betBuilderDraw){
	    				// sto aggiungendo un esito bet builder: devo esser certo che prima ci sia il bet builder sullo stesso evento
		    			blockForForeignEnv = !selezioneBetBuilderPrecedente || (selections[0].pal !== pal || selections[0].avv !== avv);	    			
	    			}
	    			else{
	    				// sto aggiungendo un esito normale: devo esser certo che la selezione presente non sia betbuilder
	    				blockForForeignEnv = selezioneBetBuilderPrecedente;
	    			}
	    		}
	    		if(blockForForeignEnv){
						ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('betbuilder.just_one_event'));
	    				return;	    		
	    		}
	    	}
	    	const betBuilderSuContainerSistemi = betBuilderDraw && selectedContainer === 'systembets';
			if(betBuilderSuContainerSistemi){
				ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('betbuilder.systembet_forbidden'));
	    		return;
			}
	    	const betBuilderMarket = betBuilderDraw? ctxs.betslipContext.handleBetBuilderMarket(sportId, pal, avv, cs, hand, codDraw, descBet, descDraw, odd) : null;
	    	if(betBuilderDraw && !betBuilderMarket && !removeEvent){
	    		return;
	    	}
	    	
	    	if(betBuilderMarket){
	    		// riaggiorno il coupon perche' handleBetBuilderMarket ha cambiato gli id delle scommesse
	    		coupon = ctxs.betslipContext.getCurrentCoupon();
	    		selections = coupon.selections;
	    		ctxs.betslipContext.setRealMoney();
	    		// aggiungo la scommessa fittizia
	    		cs = betBuilderMarket.scomSogei;
	    		hand = betBuilderMarket.handicap;
	    		codDraw = betBuilderMarket.draw;
	    		odd = betBuilderMarket.odd;
	    	}
			const specialIncBet = specialIncreasedBets.getBet(cs, hand);
	    	for(let k in selections){
	    		let sel = selections[k];
	    		if(sel.pal == pal && sel.avv == avv){
	    			eventSelection = sel;
	    			const betBuilderSuScommessaPrecedenteNonBetBuilder = !eventSelection.bets[0].isBetBuilderMarket && betBuilderDraw;
	    			const scommessaNormaleSuScommessaPrecedenteBetBuilder =  eventSelection.bets[0].isBetBuilderMarket && !betBuilderDraw;
	    			const betBuilderSystemCheckPoint = !betBuilderSuScommessaPrecedenteNonBetBuilder && !scommessaNormaleSuScommessaPrecedenteBetBuilder;
	    			if(!betBuilderSystemCheckPoint){
	    				// non si può andare a sistema se c'è una scommessa composta con il bet builder sullo stesso evento.
	    				if(betBuilderDraw){
	    					// se ho aggiunto un esito betbuilder, annullo la selezione e  poi chiudo: 
		    				ctxs.betslipContext.handleBetBuilderMarket(sportId, pal, avv, cs, hand, codDraw, descBet, descDraw, odd);
	    				}
						ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('betbuilder.systembet_forbidden'));
	    				return;
	    			}
	    			let markets = sel.bets;
	    			for(let kb in markets){
	    				let market = markets[kb];
	    				if(!market.isBetBuilderMarket){
	    					if(!removeEvent){
	    						const isSameMarketCode = Math.abs(market.scomSogei) === Math.abs(cs);
		    					if(market.scomSogei == cs && market.handicap == hand && market.draw == codDraw){
		    						// selection exists: has to be removed
		    						found = true;
		    						eventBets = sel.bets;
		    					}
		    					else if(isSameMarketCode && market.handicap == hand && market.draw == codDraw) {
		    						selectionToBeChanged = market;
		    						eventBets = sel.bets;
		    					}
	    					}
		    				else{
		    					found = true;
		    				}
	    				}
	    				else if(betBuilderMarket?.scomSogei === market.scomSogei || removeEvent){
	    					// gestione mercato betbuilder
	    					if(removeEvent || betBuilderMarket?.subMarketsSet.length === 0){
	    						// il vettore di sotto-scommesse è vuoto: questa selezione è da rimuovere
	    						found = true;
	    						eventBets = sel.bets;
	    					}
	    					else {
	    						// da sostituire
	    						selectionToBeChanged = market;
		    					eventBets = sel.bets;
	    					}
	    				}
	    			}
	    		}
	    	}
	    	if(selectionToBeChanged){
				const newBets = [];
				for(let kb in eventBets){
					let market = eventBets[kb];
					if(market.scomSogei != selectionToBeChanged.scomSogei || market.handicap != selectionToBeChanged.handicap || market.draw != selectionToBeChanged.draw){
						newBets.push(market);
					}
				}
				eventSelection.bets = newBets;
			}		    	
	    	// remove case
	    	if(found){
	    		let newBets = [];
	    		if(!removeEvent){
	    			for(let kb in eventBets){
	    				let market = eventBets[kb];
	    				if(market.scomSogei != cs || market.handicap != hand || market.draw != codDraw){
	    					newBets.push(market);
	    				}
	    			}	    			
	    		}
	    		// if I have to delete all the bets, I set directly a void bets array
	    		eventSelection.bets = newBets;
	    		if(newBets.length === 0){
	    			// removing also the event
	    			let newSelections = [];
	    	    	for(let k in selections){
	    	    		let sel = selections[k];
	    	    		if(sel.pal != pal || sel.avv != avv){
	    	    			newSelections.push(sel);
	    	    		}
	    	    	}
	    	    	coupon.selections = newSelections;
	    	    	
	    		}
	    		removed = true;
	    		added = false;
	    	}
	    	else{
	    		addedBet = {};
	    		addedBet.scomSogei = cs;
	    		addedBet.handicap = hand;
	    		addedBet.draw = codDraw;
				addedBet.odd = odd + ""; 		
	    		if(!betBuilderMarket){
		    		addedBet.legabile = legabile;
					addedBet.combinationType = specialIncBet? specialIncBet.combinationType : 0;
		    		addedBet.amount = ctxs.betslipContext.addAndBet? ctxs.betslipContext.addAndBetAmount : ctxs.betslipContext.betslipData.defaultAmount; // for singlebet
		    		addedBet.printableAmount = getPrintableAmount(addedBet.amount, conf.cs.m, conf.cs.nd); // for singlebet
		    		addedBet.minPl = minPl;
		    		addedBet.maxPl = maxPl;	   
		    		addedBet.descBet = descBet;
	    			addedBet.descDraw = descDraw;
	    			
	    		}
	    		else{
	    			addedBet.isBetBuilderMarket = true;
	    			addedBet.odd = betBuilderMarket.odd;
	    			addedBet.subMarketsSet = betBuilderMarket.subMarketsSet; // le sottoscommesse da mostrare come se fossero sistemi
	    		}

	    		
	    		
	    		// adding to cart
	    		// this selection is not present into the betslip
	    		if(eventSelection == null){
	    			// checking the maximum event number available for this customer
	    			if(conf.meb && conf.meb > 0){
	    				if(coupon.selections.length == conf.meb){
	    					//adding event is not permitted. Max event numbers has been already reached
	    					return;
	    				}
	    				
	    			}
	    			
	    			if(specialIncBet && specialIncBet.combinationType === 1){
	    				// need to check if there is a selection with the same combination type: if yes, this one cannot be placed
	    				let found = false;
	    				for(let k in selections){
	    					const selection = selections[k];
	    					if(selection.bets[0].combinationType === 1){
	    						found = selection;
	    						break;
	    					}
	    				}
	    				if(found){	    					
	    					const error = getLabel('playability.cannot_add_selection_due_other');
	    					const descSelection = found.descEvent + " " + found.bets[0].descBet + " - " + found.bets[0].descDraw ; 
	    					const finalError = error.replaceAll('{{DESC_SELECTION}}', descSelection);
	    					ctxs.betslipContext.setCartError(finalError);
	    					ctxs.betslipContext.showModalAdviseIfProvided('error', finalError);
	    					return;
	    				}
	    			}
	    			
	    			addedWhat = 'event';
	    			eventSelection = {};
	    			eventSelection.pal = pal;
	    			eventSelection.avv = avv;
	    			eventSelection.banker = false;
	    			eventSelection.descEvent = descAvv;
	    			eventSelection.isLive = isLive;
	    			eventSelection.bets = [];
	    			eventSelection.alias = eventAlias;
	    			eventSelection.descSport = descSport;
	    			eventSelection.descTournament = descTournament;
	    			eventSelection.sportId = sportId;
	    			eventSelection.tournamentId = tournamentId;
	    			eventSelection.timestamp = timestamp;
					if(matchData){
						eventSelection.matchData = matchData;
					}
	    			if(psvPlatformCode){
	    				eventSelection.psvPlatformCode = psvPlatformCode;
	    			}
	    			coupon.selections.unshift(eventSelection);
	    		}
	    		else {
	    			if(!ctxs.betslipContext.isBetBuilder()){
		    			// check if the systembet integrals are accepted and also the systembets in general way, and if the previous bet was combinationType == 1
		    			// and if there was a system composed by non leg markets: in this case if the entered bet is leg, I've to escape it
		    			// otherwise: if the system is composed by leg markets, I can't accept the new bet
						
		    			let thereWasJustLegs = true;	    			
		    			for(let kb in eventSelection.bets) {
		    				thereWasJustLegs = thereWasJustLegs && eventSelection.bets[kb].legabile;		
		    			}
		    			const candidateBetArray = eventSelection.bets.slice();
		    			candidateBetArray.push(addedBet);
		    			const legStatusBroken = (thereWasJustLegs && !addedBet.legabile) || // broken the leg requirement
		    									(thereWasJustLegs && addedBet.legabile && !playableInMultiple(candidateBetArray)) || // bet is legabile but not accepted as legabile with the others
		    									(!thereWasJustLegs && addedBet.legabile); // an ordinary system cannot contain a legabile market
						const previousBet = eventSelection.bets[eventSelection.bets.length - 1];
		    			const isLegabileAddingOk = thereWasJustLegs && !legStatusBroken;
		    			const isSystemAddingOk = systembetsEnabled && systemIntegralsEnabled;
		    			const acceptThisSelection = (isLegabileAddingOk || isSystemAddingOk) && (!previousBet ||previousBet.combinationType !== 1);
		    			if(!acceptThisSelection){
		    				if(!systemIntegralsEnabled || previousBet.combinationType === 1){
		    					// I remove the previous selection
		    					eventSelection.bets.pop();
		    				}
		    				else { 
		    					const error = getLabel('playability.system_leg_error');
		    					ctxs.betslipContext.showModalAdviseIfProvided('error', error);
		    					return;
		    				}
		    			}
		    			addedWhat = 'draw';
	    			}
	    		}

	    		eventSelection.bets.push(addedBet);
				try {
					window.dispatchEvent(new CustomEvent('xs_addSelectionToCart', {detail: eventSelection}));
				}catch(err) {
					console.log(err);
				}
	    		
	    		selected = true;
	    		removed = false;
	    		added = true;
	    	}
	    	
	    	// take a decision on which container has to be showed
	    	let updatedSel = coupon.selections.length;
	    	let updatedContainer = selectedContainer;
	    	

	    	if(!ctxs.betslipContext.isBetBuilder()){
		    	if(selectedContainer === 'singlebets'){
		    		if(added){
		   				if(ctxs.betslipContext.mustBeSwitchedToSystemBets(eventSelection)){
	    					updatedContainer = 'systembets'; 
	    				}
		   				else{
		   					// if there is more than 1 event, or if all the bets are playable in multibets due to legabile status,
		   					// I've to switch it to multibets
		   					if(updatedSel > 1 || (eventSelection.bets.length > 1 && playableInMultiple(eventSelection.bets))){
		   						updatedContainer = 'multibets'; // go in multibets	    					
		   					}
		   					else{
		   						// do nothing: the user was in the singlebets with no selections: I keep this container		    	    				
		   					}
		   					
		   				}
		    		}
		    	}
		    	else if(selectedContainer === 'multibets'){
		    		if(added && ctxs.betslipContext.mustBeSwitchedToSystemBets(eventSelection)){
		    			updatedContainer = 'systembets'; 
		    		}
		    		else if(removed){
		    			if(!avoidSinglebets && (conf.bco[0] === 'singlebets' && updatedSel == 1 && !playableInMultiple(coupon.selections[0].bets))){
		    				// go back to singlebets
		    				updatedContainer = 'singlebets'; 
		    			}
		    		}
		    	}
		    	else if(selectedContainer === 'systembets'){
		    		if(removed && ctxs.betslipContext.mustBeSwitchedToMultiBets(selections)){
		   				// go back to singlebets
	    				updatedContainer = 'multibets'; 
		    		}
		    	}
	    	}
	    	else{
	    		updatedContainer = updatedSel > 1? 'multibets' : 'singlebets';
	    	}
	    	
	    	


	    	let psvSystemNotAvailable = false;
	    	let playabilityIssue = false;
	    	if(updatedContainer === 'systembets'){
	    		psvSystemNotAvailable = !ctxs.betslipContext.systembetsOpeningIsAvailable();
	    		if(psvSystemNotAvailable){
	    			// must remove the latest selection
	    			updatedContainer = selectedContainer;
	    			if(addedWhat === 'event'){
	    				// remove the latest event
		    			let newSelections = [];
		    	    	for(let k in selections){
		    	    		const sel = selections[k];
		    	    		if(sel.pal != pal || sel.avv != avv){
		    	    			newSelections.push(sel);
		    	    		}
		    	    	}
		    	    	coupon.selections = newSelections;	    
	    			}
	    	    	else{
	    				// remove the latest draw
		    			let selection = null;
		    	    	for(let k in selections){
		    	    		const sel = selections[k];
		    	    		if(sel.pal == pal && sel.avv == avv){
		    	    			selection = sel;
		    	    		}
		    	    	}		
		    	    	selection && selection.bets.pop();
	    	    	}
	    		}
	    		
	    		let enhancedOddsItaly = false;
	    		for(let km in eventSelection.bets){
	    			const bet = eventSelection.bets[km];
	    			enhancedOddsItaly  = enhancedOddsItaly || bet.scomSogei < 0;
	    		}
	    		if(enhancedOddsItaly){
	    			// ripristino l'array, annullo il cambio di container e mando errore
	    			updatedContainer = selectedContainer;
	    			const restoredBets = [];
	    			for(let km in eventSelection.bets){
	    				const bet = eventSelection.bets[km];
	    				if(bet.scomSogei === addedBet.scomSogei && bet.handicap == addedBet.handicap && bet.draw === addedBet.draw){
	    					if(selectionToBeChanged){
	    						restoredBets.push(selectionToBeChanged);
	    					}
	    				}
	    				else {
	    					restoredBets.push(bet);
	    				}
	    			}
	    			eventSelection.bets = restoredBets;
					ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('betslip.systembet_forbidden_with_magg'));	   
					return; 			
	    		}
	    	}
	    	else if(updatedContainer === 'multibets' && !ctxs.betslipContext.isVirtual && !betslipContext.isBetBuilder()){	
	    		// checking the observance of the playability for each selection
	    		let totalDrawsPlayableInMultiple = 0;
	    		let checkMinOddRequirementData = null;
	    		for(let k in selections){
	    			const selection = selections[k];
	    			const playableInMulti = playableInMultiple(selection.bets);
	    			for(let kb in selection.bets){
	    				if(kb == 0 || playableInMulti){
	    					totalDrawsPlayableInMultiple ++;
	    				}
	    				// reset the errors
	    				selection.bets[kb].minPlError = false;
	    				selection.bets[kb].maxPlError = false;
	    				selection.bets[kb].minOddError = null;
	    				if(!checkMinOddRequirementData){
	    					const container = window.getAggregationAndBetFromBetId(selection.bets[kb].scomSogei, selection.bets[kb].handicap);
	    					if(container && container.market && container.market.miminumOddForOtherSelections){
	    						checkMinOddRequirementData = {
	    								scomKey : selection.bets[kb].scomSogei + "_" + selection.bets[kb].handicap,
	    								oddToCheck : container.market.miminumOddForOtherSelections,
	    								betToUpdateWithError : selection.bets[kb]
	    						}
	    					}
	    				}
	    			}
	    		}
	    		
	    		let minOddError = false;
	    		for(let k in selections){
	    			const selection = selections[k];
	    			const playableInMulti = playableInMultiple(selection.bets);
	    			for(let kb in selection.bets){
	    				const bet = selection.bets[kb];
	    				if(kb == 0 || playableInMulti){
			    			if(bet.minPl){
			    				bet.minPlError = totalDrawsPlayableInMultiple < bet.minPl;
			    				playabilityIssue = bet.minPlError;
			    			}
			    			
			    			if(bet.maxPl){
			    				bet.maxPlError = totalDrawsPlayableInMultiple > bet.maxPl;
			    				playabilityIssue = bet.maxPlError;
			    			}
			    			if(checkMinOddRequirementData){
			    				const thisBetKey = bet.scomSogei + "_" + bet.handicap;
			    				if(checkMinOddRequirementData.betKey !== thisBetKey && !minOddError){
			    					minOddError = bet.odd < checkMinOddRequirementData.oddToCheck? checkMinOddRequirementData.oddToCheck : null;
			    					playabilityIssue = bet.odd < checkMinOddRequirementData.oddToCheck;
			    				}
			    			}
	    				}
	    			}
	    		}
	    		if(minOddError){
	    			checkMinOddRequirementData.betToUpdateWithError.minOddError = minOddError;
	    		}
	    		
	    	}
	    	else if(updatedContainer === 'singlebets' && !ctxs.betslipContext.isVirtual){
	    		for(let k in selections){
	    			const selection = selections[k];
	    			for(let kb in selection.bets){
	    				selection.bets[kb].minPlError = selection.bets[kb].minPl && selection.bets[kb].minPl > 1;
	    				playabilityIssue = playabilityIssue || selection.bets[kb].minPlError; 
	    			}
	    		}
	    	}
	    	coupon.playabilityIssue = playabilityIssue;
	    	coupon.selectedContainer = updatedContainer;
	       
	    	// counting the total of the selection bets
	    	let totalDraws = 0;
	    	for(let k in selections){
	    		let selection = selections[k];
	    		for (let i = 0; i < selection.bets.length; i++) {
	    			totalDraws ++;
	    		}
	    	}
	    	coupon.totalDraws = totalDraws;
	    	
	    	//ctxs.betslipContext.toggledSelection = added || removed;
	    	if(ctxs.betslipContext.addAndBet){
	    		coupon.oddVariation = 'ALWAYS';
	    	}
	    	// save the new betslip in localstorage
	    	const selectionHasBeenToggled = added || removed;
	    	// prima di salvare il nuovo carrello, rimuovo l'interval di aggiornamento quote: potrebbe ri-salvare nello storage il vecchio carrello
	    	ctxs.betslipContext.disableLiveSelectionsPolling(); 
	    	
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, selectionHasBeenToggled);
            if (isMobile && conf.cbns) {
                closeBetslipIfNoSelectionsLeft(ctxs.betslipContext.betslipData, keyCoupon);
            }
	    	
	    	// check if the reservation box has to be shown or not
	    	ctxs.betslipContext.restoreReservationBoxStatus();
	    	if(!SELECT_WAGERING_PROMO_ANYWAY || coupon.selections.length === 0){
		    	ctxs.betslipContext.removeBetOptionsSection();	    	
	    	}
	    	else{
	    		if(!ctxs.betslipContext.betOptionsSelection?.value !== 'REAL'){
	    			// reselect the same wagering promo to check again the calculation
	    			ctxs.betslipContext.setBetOptionsSelection(ctxs.betslipContext.betOptionsSelection.value, ctxs.betslipContext.betOptionsSelection.type);
	    		}
	    	}
			setBetslipEventsNumber(ctxs.betslipContext.getCouponSelectionsNum());
	    	ctxs.betslipContext.setTransactionIdAcceptanceForProposal(null);
			// bet directly without confirmation
			if(ctxs.betslipContext.addAndBet){
    			// if mobile I open the betslip
    			if(typeof window.openBetslip === 'function'){
    				window.openBetslip();
    				// waiting for betslip mounted to go on
    				window.waitBetslipInterval = window.setInterval(function(){
    					if($('#betslip-container').length == 1){
    						ctxs.betslipContext.purchase();	
    						window.clearInterval(window.waitBetslipInterval);		
    					}
    				}, 100);
    			}
				else {
					ctxs.betslipContext.purchase();			
				}
			}
			
			if(psvSystemNotAvailable){
				ctxs.betslipContext.setCartWarning(getLabel('virtual.betslip.no_system_with_diff_sport'));
			}
			
			if(onBetslipSelectionsChange){
				const coupon = ctxs?.betslipContext?.betslipData?.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
				onBetslipSelectionsChange(coupon?.selections?.length,ctxs.betslipContext.betslipData.selectedCoupon)
			}

			ctxs.betslipContext.loadBetOptionsIfEnabled();
			ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
			if(ctxs.shopContext?.type === 'TERMINAL' && coupon.selections.length === 0){
				xs_clearVipSystemData('toggleSelectionBetslip(zero selezioni)');
			}
	    	return selected;
	    },
	    
	    systembetsOpeningIsAvailable : function (){
	    	let psvSystemReqChecked = true;
	    	if(ctxs.betslipContext.isVirtual){
		    	const keyCoupon = ctxs.betslipContext.betslipData.selectedCoupon;
		    	const selections = ctxs.betslipContext.betslipData.coupons[keyCoupon].selections;
		    	let sportIdBetslip = null;
		    	let psvPlatformCode = null;
	    		// if is psv, all the events must come from the same sport in a systembet
	    		for(let k in selections){
		    		const sel = selections[k];
		    		if(sportIdBetslip == null){
		    			sportIdBetslip = sel.sportId;
		    			psvPlatformCode = sel.psvPlatformCode;
		    		}
		    		else {
		    			psvSystemReqChecked = psvSystemReqChecked && sportIdBetslip == sel.sportId && sel.psvPlatformCode == psvPlatformCode;		    			
		    		}
	    		}
	    	}
    		return psvSystemReqChecked;
	    },
	    
	
	    mustBeSwitchedToSystemBets: function(selection){
	    	if(selection != null && ctxs.betslipContext.keepContainer == false){	    		
	    		const playableInMultibets = playableInMultiple(selection.bets);
	    		let canKeepMultiple = selection.bets.length === 1 || playableInMultibets;
	    		return !canKeepMultiple;
	    	}
	    	return false;
	    },
	    
	    mustBeSwitchedToMultiBets: function(selections){
	    	// each event needs to have just one bet, or all the bets must be "legabile"
	    	let switchOn = true;
	    	for(let k in selections){
	    		if(selections[k].bets.length > 1){    			
	    			switchOn &= playableInMultiple(selections[k].bets);
	    		}
	    	}    	
	    	return switchOn && ctxs.betslipContext.keepContainer == false;
	    },	
	    saveBetslipLocalStorage : function(betslipData){
	    	localStorage.setItem(ctxs.betslipContext.localStorageKey, JSON.stringify(betslipData));
	    },
	    
	    getCurrentCoupon : function (){
	    	if(ctxs.betslipContext.betslipData){
		    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
		    	return coupon;	    	
	    	}
	    },

	    getCurrentContainer : function (){
	    	if(ctxs.betslipContext.betslipData){
		    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
		    	return coupon.selectedContainer;	    	
	    	}
	    },
	    	    
	    removeFirstSelection : function(){
	    	if(ctxs.betslipContext.betInProgress){
	    		return;
	    	}
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let selectionsDim = coupon.totalDraws;
	    	if(coupon.selections.length > 0){
	    		const event = coupon.selections[0];
	    		ctxs.betslipContext.setKeepContainer(true);
	    		// all the component has to be re-rerended
    	    	setBetslipContext(function(prev){
    	    		return {
    	    			...prev,
    	    			keepContainer : true
    	    		}
    	    	});
    	    	ctxs.betslipContext.toggleSelectionBetslip(event.pal, 
    	    											   event.avv, 
    	    											   null, 
    	    											   null, 
    	    											   null, 
    	    											   event.bets[0].scomSogei, 
    	    											   event.bets[0].handicap, 
    	    											   null, 
    	    											   event.bets[0].draw, 
    	    											   null, 
    	    											   null, 
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   null,
    	    											   event.bets[0].isBetBuilderMarket);

	        	selectionsDim --;
	    	}
	    	// check if the reservation box has to be shown or not
	    	ctxs.betslipContext.restoreReservationBoxStatus();
	    	//ctxs.betslipContext.removeBetOptionsSection();
	    	ctxs.betslipContext.loadBetOptionsIfEnabled();
	    	return selectionsDim;
	    },
	    
	    deleteAllCoupons : function(){
	    	ctxs.betslipContext.disableLiveSelectionsPolling();
	    	for(let couponIndex in ctxs.betslipContext.betslipData.coupons){
	    		ctxs.betslipContext.clearBetslip(couponIndex);
	    	}
	    	ctxs.betslipContext.changeCoupon(1);
	    },
	    
	    clearBetslip : function (couponIndex){
	    	if(ctxs.betslipContext.betInProgress){
	    		return;
	    	}
	    	ctxs.betslipContext.disableLiveSelectionsPolling();
	    	let betslipData = ctxs.betslipContext.getBetslipData();
	    	if(!couponIndex){
	    		couponIndex = betslipData.selectedCoupon;
	    	}
	    	const suggestedAmount = ctxs.betslipContext.getSuggestedAmount();
	    	betslipData.coupons[couponIndex].totalDraws = 0;	 
	    	betslipData.coupons[couponIndex].selections = [];
	    	betslipData.coupons[couponIndex].betBuilderSelections = {};
	    	betslipData.isBetBuilder = false;
	    	betslipData.coupons[couponIndex].userSystemSelections = {};
	    	betslipData.coupons[couponIndex].calculatedSystemData = {};
	    	betslipData.coupons[couponIndex].selectedContainer = avoidSinglebets? 'multibets' : conf.bco[0] ;
    		betslipData.coupons[couponIndex].potentialWinning = 0;
    		betslipData.defaultAmount = betslipData.defaultAmount || ctxs.betslipContext.defaultAmountByConfiguration || ctxs.betslipContext.minimumBetAmount;
    		let amountMulti = suggestedAmount || betslipData.defaultAmount;
    		betslipData.coupons[couponIndex].amountMulti = amountMulti;
    		betslipData.coupons[couponIndex].amountSystem = 0;
    		betslipData.coupons[couponIndex].amountSingle = 0;
    		betslipData.coupons[couponIndex].printableAmountMulti = getPrintableAmount(amountMulti, conf.cs.m, conf.cs.nd);
    		betslipData.coupons[couponIndex].betOnAll = betslipData.defaultAmount;
    		betslipData.coupons[couponIndex].betOnAllEnabled = false;
    		betslipData.coupons[couponIndex].printableBetOnAll = getPrintableAmount(betslipData.coupons[couponIndex].betOnAll, conf.cs.m, conf.cs.nd);
    		betslipData.coupons[couponIndex].totalCombs = 0;
    		betslipData.coupons[couponIndex].multipleBonus = null;

    		//betslipData.coupons[couponIndex].oddVariation = 'NEVER';
    		betslipData.selectedCoupon = couponIndex;
    		betslipData.isMobile = isMobile;
	    	ctxs.betslipContext.setKeepContainer(false);
    		ctxs.betslipContext.setBetslipData(betslipData, true);
    		ctxs.betslipContext.setTransactionIdAcceptanceForProposal(null);
	    	// check if the reservation box has to be shown or not
	    	ctxs.betslipContext.restoreReservationBoxStatus();
	    	ctxs.betslipContext.removeBetOptionsSection();
			setBetslipEventsNumber(ctxs.betslipContext.getCouponSelectionsNum());
            if (isMobile && conf.cbns) {
                closeBetslipIfNoSelectionsLeft(ctxs.betslipContext.betslipData, couponIndex);
            }
            ctxs.betslipContext.clearSelectionsStateBeforeAcceptance();
            if(ctxs.shopContext.type === 'TERMINAL'){
				xs_clearVipSystemData('clearBetslip');
			}
	    },
	    
	    setKeepContainer : function(value){
	    	ctxs.betslipContext.keepContainer = value;
    		setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			keepContainer : value
	    		}
	    	});
	    },
	    setBetslipData : function(betslipDataInput, selectRealMoneyAtTheEnd, toggledSelection) {
	    	if(!betslipDataInput){
	    		return;
	    	}
			// refreshing the reference
	    	ctxs.betslipContext.updateFullContext({betslipData : {...betslipDataInput}, toggledSelection : toggledSelection});
	    	
	    	const returnObject = ctxs.betslipContext.calcAmountsWinnings();
	    	// saving betslip in the local storage
	    	const betslipData = ctxs.betslipContext.getBetslipData();
	    	ctxs.betslipContext.saveBetslipLocalStorage(betslipData);
	    	
	    	// generating a selections map, based on the selected coupon data
	    	const keyCoupon = betslipData.selectedCoupon;
	    	const selections = betslipData.coupons[keyCoupon].selections;
	    	const betBuilderSelectionMap = {};
	    	const selectionMap = {};
	    	const selectionEventsMap = {};
	    	let isBetBuilder = false;
	    	for (let k in selections) {
	    		const pal = selections[k].pal;
	    		const avv = selections[k].avv;
	    		const keyEventsMap = pal + "_" + avv;
	    		selectionEventsMap[keyEventsMap] = true;
	    		for (let km in selections[k].bets) {
	    			const bet = selections[k].bets[km];
	    			const cs = bet.scomSogei;
	    			const hand = bet.handicap;
	    			const codDraw = bet.draw;
	    			const finalKey = `${pal}_${avv}_${cs}_${hand}_${codDraw}`;
	    			selectionMap[finalKey] = true;	
	    			if(bet.isBetBuilderMarket && bet.subMarketsSet){
	    				for(let kmb in bet.subMarketsSet){
	    					isBetBuilder = true;
			    			const subMarket = bet.subMarketsSet[kmb];
			    			const cs = subMarket.scomSogei;
			    			const hand = subMarket.handicap;
			    			const codDraw = subMarket.draw;
			    			const finalKeyBB = `${pal}_${avv}_${cs}_${hand}_${codDraw}`;	
			    			betBuilderSelectionMap[finalKeyBB] = true;   					
	    				}
	    			}
	    		}
	    	}
	    	betslipData.isBetBuilder = isBetBuilder;
	    	const betOptionsSelection = selectRealMoneyAtTheEnd? { value :'REAL', type : null} : ctxs.betslipContext.betOptionsSelection;
	    	ctxs.betslipContext.updateFullContext({
	    		betslipData,
    			selectionMap,
    			selectionEventsMap,
    			betBuilderSelectionMap,
    			betOptionsSelection,
    			buttonPlayState : 'play',
    			cartMessage: ctxs.betslipContext.keepWageringError? ctxs.betslipContext.cartMessage : returnObject.cartMessage,
    			loaderData : {type:'hideAll'}
	    	});

            const coupon = ctxs.betslipContext.betslipData.coupons[keyCoupon];
            if (coupon.selectedContainer === 'multibets' && conf.mbmw !== 0 && coupon.potentialWinning > conf.mbmw) {
                const maxWinnings = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct)
                ctxs.betslipContext.setCartWarning(`${getLabel('carrello.max_winnings_exceeded')} ${maxWinnings}`);
            } 
            else if (coupon.selectedContainer === 'systembets' && conf.sbmw !== 0 && coupon.potentialWinning > conf.sbmw) {
                const maxWinnings = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct)
                ctxs.betslipContext.setCartWarning(`${getLabel('carrello.max_winnings_exceeded')} ${maxWinnings}`);
            }		
			if (!isSecondScreen) {
                setTimeout(() => {
                    const bc = new BroadcastChannel('second-screen-betslip');
					bc.postMessage({
						type: 'setBetslipData',
						payload: {
							isVirtual:ctxs.betslipContext.isVirtual,
							bonusData: ctxs.betslipContext.bonusData
						}
					});
					bc.close();
				}, (ctxs.betslipContext.secondScreenBetslipPurchaseRefreshTimeout || 0) + 200);
            }
            if(conf.pbs){
            	ctxs.betslipContext.manageBetslipPromo();
            }
	    },
	    getBetslipData: function(){
	    	return ctxs.betslipContext.betslipData;
	    },
	    getSelectionMap: function(){
	    	return ctxs.betslipContext.selectionMap;
	    },
	    isDrawSelected : function(pal, avv, cs, h, codDraw){
	    	const key = `${pal}_${avv}_${cs}_${h}_${codDraw}`;
	    	return ctxs.betslipContext.selectionMap?.[key] != undefined;
	    },

	    isBetBuilderDrawSelected : function(pal, avv, cs, h, codDraw){
	    	const key = `${pal}_${avv}_${cs}_${h}_${codDraw}`;
	    	return ctxs.betslipContext.betBuilderSelectionMap?.[key] != undefined;
	    },
	    	    
	    isEventSelected : function(pal,avv){
	    	const key = pal + "_" + avv;
	    	return ctxs.betslipContext.selectionEventsMap[key] != undefined;
	    },
	    
	    calcAmountsWinnings : function(){
			const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const container = coupon.selectedContainer;
	    	const nDec = conf.cs.nd;
	    	const mult = conf.cs.m;
	    	const calculateTaxes = taxesEnabled();
	    	
	    	let potentialWinning = 0;
	    	let totalTaxAmount = 0;
	    	let totalOdd = 1;
	    	let minPotentialWinning = 0; // only for systembets
	    	let maxPotentialWinning = 0; // only for systembets
	    	let amountSystem = 0;
	    	let amountSingle = 0;
	    	let totalCombs = 0;
	    	let multipleBonus = null;
	    	let multipleTaxedBonus = null;
	    	
	    	// amount calculated with stake taxed import (different respect the winning tax import), if present
	    	let stakeTaxedAmountSingle = 0;
	    	let stakeTaxedAmountMulti = 0;
	    	let stakeTaxedAmountSystem = 0;
	    	let stakeTaxedPotentialWinning = 0;
	    	let stakeTaxedMinPotentialWinning = 0; // only for systembets
	    	let stakeTaxedMaxPotentialWinning = 0; // only for systembets
	    	let bankedSelNumber = 0;
	    	const returnObject = {}; // stuff container for the setBetslipData function, if it is necessary
	    	if(container === 'singlebets' && !ctxs.betslipContext.isBetBuilder()){
	    		// potential winning is the sum of all the single potential winnings
	    		for(let k in coupon.selections){
	    			let selection = coupon.selections[k];
	    			if(!selection.closed){
	    				for(let km in selection.bets){
	    					let bet = selection.bets[km];
	    					if(!bet.closed){
	    						/*let odd = bet.odd / 100;
	    						let amount = bet.amount / mult;
	    						let stakeTaxedAmount = 0;
	    						let stakeTaxedPotWin = 0;
	    						let potWin = getPotentialWinning(amount, odd, nDec);
	    						potWin = getAmountInCent(potWin, mult);
	    						let selectionTaxes = 0;
	    						*/
	    						const oddWithPrecision = convertToDecimalWithPrecision(bet.odd, 19, 6)/100;
	    						let stakeTaxedAmount = 0;
	    						let stakeTaxedPotWin = 0;
	    						let selectionTaxes = 0;
	    						//let potWin = parseInt(bet.amount * oddWithPrecision);    						
	    						let potWin = parseInt(convertToDecimalWithPrecision(oddWithPrecision * bet.amount, 19, 6));
	    						if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
	    							// calculate the winning with a reduced stake
	    							stakeTaxedAmount = getStakeTaxed(bet.amount, ctxs.betslipContext.stakeTaxConfiguration.percentage);
	    							stakeTaxedPotWin = parseInt(convertToDecimalWithPrecision(oddWithPrecision * stakeTaxedAmount, 19, 6));
	    						}
	    						
	    						if(calculateTaxes){
	    							const resultTaxes = getTaxes(bet.amount, potWin, ctxs.betslipContext.isVirtual);
	    							potWin = resultTaxes.potentialWinning;
	    							selectionTaxes = resultTaxes.taxesAmount;
	    						}
	    						else {
		    						potentialWinning = roundForCurrency(potentialWinning);
		    					}
	    						
	    						if(ctxs.betslipContext.betOptionsSelection.type === 'freebet' && ctxs.betslipContext.betOptionsSelection.isRealWagering){
	    							potWin = potWin - bet.amount;
	    						}
	    						
	    						// controllo se c'è bonus sulla singola: se sì, lo mando in automatico in multipla
	    						const isRealMoney = !ctxs.betslipContext.betOptionsSelection || ctxs.betslipContext.betOptionsSelection.value === 'REAL';
	    						const selForBonus = JSON.parse(JSON.stringify(selection));
	    						selForBonus.bets = [bet];
	    						const bonusResult = getBonusMultiple(ctxs.betslipContext.user, ctxs.betslipContext.bonusData, [selForBonus], potWin, isRealMoney, true);
	    						if(bonusResult.multipleBonus?.applied){
	    							ctxs.betslipContext.changeContainer('multibets');
	    							return returnObject;
	    						}
	    						bet.potentialWinning = potWin;
	    						potentialWinning += (potWin);
	    						amountSingle += bet.amount;
	    						bet.stakeTaxedAmount = stakeTaxedAmount;
	    						bet.stakeTaxedPotWin = stakeTaxedPotWin;
	    						stakeTaxedAmountSingle += bet.stakeTaxedAmount;
	    						stakeTaxedPotentialWinning += bet.stakeTaxedPotWin;
	    						bet.selectionTaxes = selectionTaxes;
	    						totalTaxAmount += selectionTaxes;		
	    					}
	    				}						
	    			}
	    		}
	    	}
	    	else if(container === 'multibets' || ctxs.betslipContext.isBetBuilder()){	    		
	    		// potential winning is the (odds moltiplication) * amount of the bet
	    		if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
    				stakeTaxedAmountMulti = getStakeTaxed(coupon.amountMulti, ctxs.betslipContext.stakeTaxConfiguration.percentage);
	    		}
    			totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
    			let potentialWinningWithPrecision = 0;
    			let potentialWinningWithPrecisionStakeTaxed = 0;
	    		for(let k in coupon.selections){
	    			let selection = coupon.selections[k];
	    			if(!selection.closed){
		    			if(selection.bets.length > 0){
		    				for(let km = 0; km < selection.bets.length; km ++){
		    					let bet = selection.bets[km];
		    					if(!bet.closed){
		    						if(km == 0 || (bet.legabile && playableInMultiple(selection.bets))){
		    							// turn the odd to an integer with 6 decimals in order to keep precision during
		    							// the operations
		    							const useMainOdd = !bet.isBetBuilderMarket || (bet.isBetBuilderMarket && (bet.odd == 0 || conf.bbc.type !== 'ITALIA'));
		    							if(useMainOdd){
		    								// la quota principale di una scommessa bet builder è calcolata solo per essere mostrata.
		    								// quindi entro qui solo se la quota bet builder è ancora a 0, in modo che il prodotto finale sia 0.
		    								// Oppure se la quota di betbuilder è stata calcolata dal backend
		    								// oppure, ovviamente, se la scommessa non è di tipo betbuilder
		    								totalOdd = totalOdd * convertToDecimalWithPrecision(bet.odd, 19, 6)/100;			
		    								totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
		    							}
		    							else{
		    								// se la scommessa è bet builder, la faccio partecipare al prodotto di quote finale
		    								// con tutte le sotto-quote. Altrimenti perderemmo precisione utilizzando quella principale
		    								for(let smk in bet.subMarketsSet){
		    									const subMarket = bet.subMarketsSet[smk];
		    									totalOdd = totalOdd * convertToDecimalWithPrecision(subMarket.odd, 19, 6)/100;			
		    									totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
		    								}	
		    							}
		    						}				
		    					}
		    				}
		    			}	    			
	    			}
	    		}
    			potentialWinningWithPrecision = convertToDecimalWithPrecision(totalOdd * coupon.amountMulti, 19, 6);

    			if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
					potentialWinningWithPrecisionStakeTaxed = convertToDecimalWithPrecision(totalOdd * stakeTaxedAmountMulti, 19, 6);
				}
	    		const isRealMoney = !ctxs.betslipContext.betOptionsSelection || ctxs.betslipContext.betOptionsSelection.value === 'REAL';
	    		//if(ctxs.betslipContext.bonusData) debugger;
	    		const bonusResult = getBonusMultiple(ctxs.betslipContext.user, ctxs.betslipContext.bonusData, coupon.selections, potentialWinningWithPrecision, isRealMoney);
	    		multipleBonus = bonusResult.multipleBonus;
	    		if(multipleBonus && multipleBonus.applied){
	    			// putting the info "it is ok for the multiple bonus"
	    			potentialWinning = multipleBonus.totalWinWithBonus;
	    			const mapElementBonus = {};
	    			for(let ke in multipleBonus.bonusElements){
	    				const selBonus = multipleBonus.bonusElements[ke];
	    				for(let kb in selBonus.bets){
	    					const selBetBonus = selBonus.bets[kb];
	    					const key = [selBonus.pal, selBonus.avv, selBetBonus.scomSogei, selBetBonus.handicap, selBetBonus.draw].join('_');
	    					mapElementBonus[key] = true;
	    				}
	    			}
	    			
	    			for(let ks in coupon.selections){
	    				const selection = coupon.selections[ks];
	    				for(let kb in selection.bets){
	    					const selBet = selection.bets[kb];
	    					const key = [selection.pal, selection.avv, selBet.scomSogei, selBet.handicap, selBet.draw].join('_'); 
	    					if(mapElementBonus[key]){
	    						selBet.isBonusMultiple = true;
	    					}
	    					else{
	    						selBet.isBonusMultiple = false;
	    					}
	    				}
	    			}
	    		}
	    		else{
	    			for(let ks in coupon.selections){
	    				const selection = coupon.selections[ks];
	    				for(let kb in selection.bets){
	    					const selBet = selection.bets[kb];
	    					selBet.isBonusMultiple = false;
	    				}
	    			}
    				// totalOdd is already an integer. I keep just the natural part, trashing  the decimals
	    			potentialWinning = parseInt(potentialWinningWithPrecision);
	    		}
				if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
					const stakeTaxedBonusResult = getBonusMultiple(ctxs.betslipContext.user, ctxs.betslipContext.bonusData, coupon.selections, potentialWinningWithPrecisionStakeTaxed, isRealMoney);
					multipleTaxedBonus = stakeTaxedBonusResult.multipleBonus;
					if(stakeTaxedBonusResult.multipleBonus.applied){
						stakeTaxedPotentialWinning = stakeTaxedBonusResult.multipleBonus.totalWinWithBonus;
					}
					else {
						stakeTaxedPotentialWinning = parseInt(potentialWinningWithPrecisionStakeTaxed);
					}
				}
	    		
	    		if(calculateTaxes){
	    			const resultTaxes = getTaxes((coupon.amountMulti), potentialWinning, ctxs.betslipContext.isVirtual);
	    			totalTaxAmount = resultTaxes.taxesAmount;
	    			potentialWinning = resultTaxes.potentialWinning;
	    		}
	    		else{
	    			// roundForCurrency is called into getTaxes. So If getTaxes is not called, then I call it here
	    			potentialWinning = roundForCurrency(potentialWinning);
	    		}
	    		
    			if(ctxs.betslipContext.betOptionsSelection.type === 'freebet' && ctxs.betslipContext.betOptionsSelection.isRealWagering){
    				potentialWinning = potentialWinning - coupon.amountMulti;
    			}
	    		
	    		ctxs.betslipContext.setToGetBonusAdvise(bonusResult.toGetBonus);	    		

	    	}
	    	else if(container === 'systembets'){
	    		let inputComb = [];
	    		if(coupon.userSystemSelections == null){
	    			coupon.userSystemSelections = {};
	    		}
	    		let userSystemSelections = coupon.userSystemSelections;
	    		
	    		for(let k in coupon.selections){
	    			let selection = coupon.selections[k];
	    			if(!selection.closed){
	    				for(let km in selection.bets){
	    					let bet = selection.bets[km];
	    					if(!bet.closed){
	    						inputComb.push(createStringForSystemCalc(selection, bet));	   
	    					}
	    				}	    				
	    			}
	    		}
	    		
	    		// bonus
	    		let bonusSystem = getBonusSystem(ctxs.betslipContext.user, ctxs.betslipContext.bonusData, coupon.selections);
	    		let calculatedSystemData = calculateSysData(inputComb, bonusSystem);
	    		
				if(isUKCombinationMaskEnabled()){
					setAdditionalUkTuples(calculatedSystemData, coupon.totalDraws);
				}
				
	    		// calculate the tuples section
	    		let betOnAllEnabled = coupon.betOnAllEnabled;
	    		// the function "check last system tuples" must be performed only if there was an edit on the selections list (added or removed)
	    		let checkLastSystemTuple = ctxs.betslipContext.toggledSelection && conf.cls;
	    		
	    		let minimumAmount = ctxs.betslipContext.minimumCombAmount;
	    		let maxCombinationsKey = -1;
	    		for(let kc = 0; kc < calculatedSystemData.comb.length; kc ++){
	    			let combinations = calculatedSystemData.comb[kc];
	    			if(userSystemSelections[kc] == null){
	    				userSystemSelections[kc] = {};
	    				userSystemSelections[kc].selected = false;
	    				userSystemSelections[kc].amount = minimumAmount;
	    				userSystemSelections[kc].printableAmount = getPrintableAmount(userSystemSelections[kc].amount, conf.cs.m, conf.cs.nd);
	    				userSystemSelections[kc].vMin = 0;
	    				userSystemSelections[kc].vMax = 0;
	    				if(ctxs.betslipContext.stakeTaxConfiguration.enabled){				
		    				userSystemSelections[kc].stakeTaxedVMin = 0;
		    				userSystemSelections[kc].stakeTaxedVMax = 0;
	    				}
	    			}
	    			
	    			
	    			// setting the "bet on all amount" for each combination field
	    			if(betOnAllEnabled && combinations > 0 && !checkLastSystemTuple){		
	    				userSystemSelections[kc].selected = true;
	    				userSystemSelections[kc].amount = coupon.betOnAll;
	    				userSystemSelections[kc].printableAmount = getPrintableAmount(userSystemSelections[kc].amount, conf.cs.m, conf.cs.nd);
	    			}
	    			
	    			if(ctxs.betslipContext.stakeTaxConfiguration.enabled){						
						userSystemSelections[kc].stakeTaxedAmount = getStakeTaxedTupleWithPrecision(userSystemSelections[kc].amount, ctxs.betslipContext.stakeTaxConfiguration.percentage);
	    				userSystemSelections[kc].stakeTaxedPrintableAmount = getPrintableAmount(userSystemSelections[kc].stakeTaxedAmount, conf.cs.m, conf.cs.nd);
					}
	    			
	    			if(checkLastSystemTuple){
	    				userSystemSelections[kc].selected = false;
	    			}
	    			
		            // storing the info for the "checkingLastTuples" function
	    			if(combinations > 0){
	    				maxCombinationsKey = kc;	    				
	    			}
	    			
	    			// così non riuscivo a scrivere 0.10 perchè appena cancellavo il 5, rimanendo "0", mi disattivava il box
					//if(userSystemSelections[kc].amount === 0){
						//userSystemSelections[kc].selected = false;
					//}

	    			if(userSystemSelections[kc].selected){
	    				let maxSystemWinningOdds = null;
	    				if(kc <= 30){
	    					maxSystemWinningOdds = calculatedSystemData.maxSystemWinning[kc];
	    				}
	    				else if(isUKCombinationMaskEnabled()){
	    					// create a maxSystemWinningOdds with the original tuples odds
	    					const additionalTuple = additionalUkTuplesRules[kc];
	    					if(additionalTuple){
	    						maxSystemWinningOdds = [];
	    						for(let itt in additionalTuple.indexesToTakeCombs){
	    							const indexToOriginalCombs = additionalTuple.indexesToTakeCombs[itt];
	    							if(indexToOriginalCombs !== 'all_valued'){
		    							maxSystemWinningOdds = maxSystemWinningOdds.concat(calculatedSystemData.maxSystemWinning[indexToOriginalCombs]);	    							
	    							}
	    							else{
	    								for(let i = 0; i <= 30; i++){
	    									// taking all the ordinary tuples indexes
	    									maxSystemWinningOdds = maxSystemWinningOdds.concat(calculatedSystemData.maxSystemWinning[i]);
	    								}
	    							}
	    						}
	    					}
	    				}
	    				if(maxSystemWinningOdds){
		    				let amount = userSystemSelections[kc].amount; 
		    				const taken = {};
		    				let maxOdds = 0;
				            // calculate the potential winning for this set of combinations
		    				for (let kl = 0; kl < maxSystemWinningOdds.length; kl++) {
					              let odd =  maxSystemWinningOdds[kl];
					              /*if(!taken[odd]){
					              	taken[odd] = 1;
					              	// LE STRONZATE DI VINCITU: se la rivogliono così, bisogna fargli notare che la vincita potenziale si abbassa di troppo e commercialmente l'utenza va a giocare su chi glie la spara piu alta (Anche se fingendo)
					              }*/
					              maxOdds += odd;
					        }
					        // potentialWinning = Math.trunc((amount * maxOdds) * 1.000000000000001);
		    				potentialWinning += parseInt(convertToDecimalWithPrecision(maxOdds * amount, 19, 6));

		    				amountSystem += (amount * combinations);
		    				totalCombs += combinations;
		    				
		    				if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
								// calculate the winning with a reduced stake
		    					let taxedAmount = userSystemSelections[kc].stakeTaxedAmount;
						        stakeTaxedPotentialWinning += parseInt(convertToDecimalWithPrecision(maxOdds * taxedAmount, 19, 6));
		    					const increment = (taxedAmount * combinations) / conf.cs.prsy.mult;
			    				stakeTaxedAmountSystem += increment;
							}
	    				}

	    			}	
	    		}
	    		
	    		// selecting the last checkbox if there is not a selection
	    		if(maxCombinationsKey > 0 && checkLastSystemTuple){
	    			let combinations = calculatedSystemData.comb[maxCombinationsKey];
	    			userSystemSelections[maxCombinationsKey].selected = true;
	    			let maxSystemWinningOdds = calculatedSystemData.maxSystemWinning[maxCombinationsKey];
		            let amount = userSystemSelections[maxCombinationsKey].amount;
		            const taken = {};
		    		let maxOdds = 0;
				    // calculate the potential winning for this set of combinations
    				for (let kl = 0; kl < maxSystemWinningOdds.length; kl++) {
			              let odd =  maxSystemWinningOdds[kl];
			              if(!taken[odd]){
			              	taken[odd] = 1;
			              	maxOdds += odd;
			              }
			        }
    				potentialWinning += parseInt(convertToDecimalWithPrecision(maxOdds * amount, 19, 6));
    				amountSystem += (amount * combinations);
    				totalCombs += combinations;
    				
    				if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
						// calculate the winning with a reduced stake
    					let taxedAmount = userSystemSelections[maxCombinationsKey].stakeTaxedAmount;
				        stakeTaxedPotentialWinning += parseInt(convertToDecimalWithPrecision(maxOdds * taxedAmount, 19, 6));
	    				const increment = (taxedAmount * combinations) / conf.cs.prsy.mult;
	    				stakeTaxedAmountSystem += increment;
					}
	    		}
	    		
	    		// calculate vMin and Vmax Values for all the combination tuple
	    		for(let kud in userSystemSelections){
	    			let userSystemSel = userSystemSelections[kud];
	    			if(userSystemSel.selected){
	    				const vMinsArray = calculatedSystemData.v_min;
	    		    	const vMaxArray = calculatedSystemData.v_max;
	    		    	const indexWinArrays = [];
	    		    	if(kud <= 30){
	    		    		indexWinArrays.push(kud); // just the kud index
	    		    	}
	    	    		else if(isUKCombinationMaskEnabled()){
	    					// array with the indexes that compose the added UK tuple
	    					const additionalTuple = additionalUkTuplesRules[kud];
	    					if(additionalTuple){
	    						
	    						for(let itt in additionalTuple.indexesToTakeCombs){
	    							const indexToOriginalCombs = additionalTuple.indexesToTakeCombs[itt];
	    							if(indexToOriginalCombs !== 'all_valued'){
		    							indexWinArrays.push(indexToOriginalCombs);	    							
	    							}
	    							else{
	    								for(let i = 0; i <= 30; i++){
	    									// taking all the ordinary tuples indexes
	    									indexWinArrays.push(i);
	    								}
	    							}
	    						}
	    					}
	    				}
	    				let vminFinal = 0;
	    				let vmaxFinal = 0;
	    				
	    				let vminFinalStakeTaxed = 0;
	    				let vmaxFinalStakeTaxed = 0;
	    				
	    		    	for(let iWA in indexWinArrays){
	    		    		const indexWinArray = indexWinArrays[iWA];
		    		    	let vmin = parseFloat(vMinsArray[indexWinArray]);
		    		    	let vmax = parseFloat(vMaxArray[indexWinArray]);
		    		    	let am = userSystemSel.amount / mult;
		    		    	
		    		    	vmin = vmin * am * 1.000000000000001;
		    		    	vmax = vmax * am * 1.000000000000001;
	
		    		    	vmin = parseInt(truncateDoubleTo(vmin, nDec) * mult);
		    		    	vmax = parseInt(truncateDoubleTo(vmax, nDec) * mult);
	
							vminFinal += vmin;
							vmaxFinal += vmax;
		    				if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
		    					let vminT = parseFloat(vMinsArray[kud]);
			    		    	let vmaxT = parseFloat(vMaxArray[kud]);
			    		    	let amT = userSystemSel.stakeTaxedAmount / mult;
			    		    
			    		    	vminT = vminT * amT * 1.000000000000001;
			    		    	vmaxT = vmaxT * amT * 1.000000000000001;
	
			    		    	vminT = parseInt(truncateDoubleTo(vminT, nDec) * mult);
			    		    	vmaxT = parseInt(truncateDoubleTo(vmaxT, nDec) * mult);
								vminFinalStakeTaxed += vminT;
								vmaxFinalStakeTaxed += vmaxT;
							}		    	
	    				}
	    				userSystemSel.vMin = vminFinal;
	    		    	userSystemSel.vMax = vmaxFinal;
	    		    	//minPotentialWinning += vminFinal;
	    		    	//maxPotentialWinning += vmaxFinal;	
	    		    	if(minPotentialWinning == 0 || (vminFinal > 0 && (vminFinal < minPotentialWinning))){
	    		    		minPotentialWinning = vminFinal;	    		    		
	    		    	}
	    		    	if(maxPotentialWinning == 0 || (maxPotentialWinning < vmaxFinal)){
	    		    		maxPotentialWinning = vmaxFinal;	    		    		
	    		    	}
	    		    	
	    		    	if(ctxs.betslipContext.stakeTaxConfiguration.enabled){
			    			userSystemSel.stakeTaxedVMin = vminFinalStakeTaxed;
		    		    	userSystemSel.stakeTaxedVMax = vmaxFinalStakeTaxed;
		    		    	
		    		    	/*if(stakeTaxedMinPotentialWinning == 0 || (vminFinalStakeTaxed > 0 && (vminFinalStakeTaxed < stakeTaxedMinPotentialWinning))){
		    		    		stakeTaxedMinPotentialWinning = vminFinalStakeTaxed;	    		    		
		    		    	}
		    		    	if(stakeTaxedMaxPotentialWinning == 0 || (stakeTaxedMaxPotentialWinning < vmaxFinalStakeTaxed)){
		    		    		stakeTaxedMaxPotentialWinning = vmaxFinalStakeTaxed;	    		    		
		    		    	}*/
		    		    	stakeTaxedMinPotentialWinning += vminFinalStakeTaxed;	
		    		    	stakeTaxedMaxPotentialWinning += vmaxFinalStakeTaxed;	 
		    		    }    	
	    		    }
	    		}
	    		
	    		coupon.calculatedSystemData = calculatedSystemData;
	    		const bonusSystemMinMax = calcBonusMinMaxSystem(calculatedSystemData, userSystemSelections, coupon.selections);
	    		bonusSystem.bonusMin = bonusSystemMinMax.bonusMin;
	    		bonusSystem.bonusMax = bonusSystemMinMax.bonusMax;
	    		bonusSystem.applied = bonusSystemMinMax.bonusMax > 0;
	    		coupon.bonusSystemData = bonusSystem;
	    		
	    		const bonusSystemBetsRow = calculatedSystemData.righe_basi_varianti;

	    		let indexRowSysBonus = 0;
	    	
	    		for(let i = 0; i < coupon.selections.length; i++){
	    			let selection = coupon.selections[i];
	    			if(!selection.closed){
	    				if(selection.banker){
	    					bankedSelNumber ++;
	    				}
	    				for(let k = 0; k < selection.bets.length; k++){
	    					if(!selection.bets[k].closed){
	    						let isBonus = false;
	    						if(bonusSystemBetsRow[indexRowSysBonus] != null){
	    							isBonus = bonusSystemBetsRow[indexRowSysBonus].partecipabonus;
	    						}
	    						isBonus = isBonus && bonusSystem.applied;
	    						selection.bets[k].isBonus = isBonus; 
	    						indexRowSysBonus ++;	    						
	    					}
	    				}	    				
	    			}
	    		}
	    		
	    		if(calculateTaxes){
	    			const resultTaxes = getTaxes(amountSystem, potentialWinning, ctxs.betslipContext.isVirtual);
	    			totalTaxAmount = resultTaxes.taxesAmount;
	    			potentialWinning = resultTaxes.potentialWinning;
	    		}
	    		
	    		
	    	}
	    	coupon.minPotentialWinning = minPotentialWinning;
	    	coupon.maxPotentialWinning = maxPotentialWinning;
	    	coupon.potentialWinning = potentialWinning;
	    	coupon.amountSystem = amountSystem;
	    	coupon.amountSingle = amountSingle;
	    	coupon.totalCombs = totalCombs;
	    	coupon.totalOdd = truncateDoubleTo(totalOdd, 2);
	    	coupon.multipleBonus = multipleBonus;
	    	coupon.totalTaxAmount = totalTaxAmount;
	    	coupon.bankedSelNumber = bankedSelNumber;
	    	// stake taxed stuff
	    	coupon.stakeTaxedAmountSingle = stakeTaxedAmountSingle;
	    	coupon.stakeTaxedAmountMulti = stakeTaxedAmountMulti;
	    	coupon.stakeTaxedAmountSystem = stakeTaxedAmountSystem;
	    	coupon.stakeTaxedPotentialWinning = stakeTaxedPotentialWinning;
	    	coupon.stakeTaxedMaxPotentialWinning = stakeTaxedMaxPotentialWinning; 
	    	coupon.stakeTaxedMinPotentialWinning = stakeTaxedMinPotentialWinning;
	    	coupon.multipleTaxedBonus = multipleTaxedBonus;
	    	
	    	ctxs.betslipContext.updateFullContext({betslipData : ctxs.betslipContext.betslipData});
	    	return returnObject;
	    },
	    
	    
	    toggleBanker : function(pal, avv){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let selection = null;
	    	for(let ks in coupon.selections){
	    		const selectionCandidate = coupon.selections[ks];
	    		if(selectionCandidate.pal === pal && selectionCandidate.avv === avv){
	    			selection = selectionCandidate;
	    		} 
	    	}
	    	
	    	if(selection){
	    		selection.banker = !selection.banker;
	    		if(selection.banker){
	    			// automatic deactivate the "ticket" with just the fixed selections
	    			coupon.bankedSelNumber ++;
	    			for(let uk in coupon.userSystemSelections){
	    				if(uk == coupon.bankedSelNumber){
	    					coupon.userSystemSelections[uk].selected = false;
	    					break;
	    				}
	    			}
	    			
	    		}
	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, true);
	    	}
	    	
	    },
	    switchToMultibetsIfPossible : function(){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(coupon.selectedContainer === 'systembets'){
	    		const selections = coupon.selections;
	    		let oneDrawPerSelection = true;
	    		for(let ks in selections){
	    			oneDrawPerSelection = oneDrawPerSelection && selections[ks].bets.length == 1;
	    		}
	    		if(oneDrawPerSelection){
	    			// checking if the "unary" combination set is the only one selected
	    			let userSystemSelection = null;
	    			let userSystemSelectionIndex = null;
	    			for(let kus in coupon.userSystemSelections){
	    				if(coupon.userSystemSelections[kus].selected){
	    					if(!userSystemSelection){
	    						userSystemSelection = coupon.userSystemSelections[kus];
	    						userSystemSelectionIndex = kus;
	    					}
	    					else{
	    						return false;
	    					}
	    				}
	    			}
	    			if(userSystemSelection){
	    				if(coupon.calculatedSystemData.comb[userSystemSelectionIndex] === 1){
	    					// this systembet is a multibets: I'm going to switch
	    					const conf = getConfiguration();
	    					const amountMulti = coupon.amountMulti > userSystemSelection.amount? coupon.amountMulti : userSystemSelection.amount;
	    					const printableAmountMulti = getPrintableAmount(amountMulti, conf.cs.m, conf.cs.nd); 
	    					coupon.printableAmountMulti = printableAmountMulti;
	    					coupon.amountMulti = amountMulti;
	    					coupon.selectedContainer = 'multibets';
	    					ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    					ctxs.betslipContext.setCartWarning(getLabel('betslip.must_be_multibets')); 
	    					return true;
	    				}
	    			}
	    		}    	
	    	}
	    	return false;
	    },
	    
	    setPlayButtonState : function(buttonState, fromVariationModal){
			const showLogin = window.appConfig?.HANDLERS?.['showLoginMask'];
			
	    	if(ctxs.betslipContext.betInProgress){
	    		return;	
	    	}
	    	if(ctxs.shopContext.enabled && ctxs.shopContext.busy){
	    		// try again in 100 milliseconds
	    		setTimeout(() => {
	    			ctxs.betslipContext.setPlayButtonState(buttonState, fromVariationModal);
	    		},
	    		100);
	    		return;
	    	}
	    	let coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(coupon.selections.length == 0){
	    		ctxs.betslipContext.setCartError(getLabel('carrello.error.no_selections'));
	    		ctxs.betslipContext.showModalAdviseIfProvided('warning', getLabel('carrello.error.no_selections'));
	    	}
	    	const goOn = (ctxs.betslipContext.user && ctxs.betslipContext.user.logged) || 
	    				 (ctxs.betslipContext.testAcceptanceDelay && (buttonState === 'play' || buttonState === 'again'))
	    	if(coupon.selectedContainer === 'systembets'){
	    		// check if this systembets can be played as multibets. If yes, I switch the betslip to the multibets tab
	    		const switched = ctxs.betslipContext.switchToMultibetsIfPossible();
	    		if(switched){
	    			return;
	    		}
	    	}
	    	
	    	if(goOn){
    			if(coupon.playabilityIssue){
    				let playabilityError = getLabel('playability.purchase_error');
    				ctxs.betslipContext.setCartError(playabilityError);
    				ctxs.betslipContext.showModalAdviseIfProvided('error', playabilityError);
    				ctxs.betslipContext.setBetInProgress(false);
    	    		if(ctxs.shopContext.enabled){
    	    			ctxs.shopContext.setFree();
    	    		}
	    			return;
    			}
	    		ctxs.betslipContext.removeOutdatedSelections();
	    		coupon = ctxs.betslipContext.getCurrentCoupon();
	    		if(coupon.selections.length == 0){
		    		return;
		    	}
	    		const loadPrePurchaseOptions = buttonState === 'confirm' && ! ctxs.betslipContext.isVirtual;
	    		//selections odds and status will be checked if loadPrePurchaseOptions
	    		const amountValidResult = ctxs.betslipContext.validateCoupon(loadPrePurchaseOptions);
	    		if(!amountValidResult.validated){
	    			if(amountValidResult.errorMessage){
	    				ctxs.betslipContext.setCartError(amountValidResult.errorMessage);
	    				ctxs.betslipContext.showModalAdviseIfProvided('error', amountValidResult.errorMessage);
	    			}
	    			return;
	    		}
	    			    		
	    		if(buttonState === 'confirm'){
	    			ctxs.betslipContext.disableLiveSelectionsPolling();
	    			const isLiveBetslip = isLiveBetting(coupon.selections, coupon.selectedContainer);
	    			// if the skin is setted with: aclp == false, it means that the live purchase has to be submited without
	    			// confirmation
	    			// if the skin is setted with: acpp == false, it means that the prematch purchase has to be submited without
	    			// confirmation
	    			// if we are comin' from the betslip variation modal: here I'm sure that the selections are updated, and no wagering data are loaded
	    			const playDirectly = (isLiveBetslip && !conf.aclp) || (!isLiveBetslip && !conf.acpp) || fromVariationModal;
	    			if(playDirectly){
	    				// checking the paper if it s needed
	    				const askForPaper = conf.rs && conf.rs.cfp && window.XSocket && window.setPaperCaseEmpty;
	    				if(!askForPaper){
		       				// all the component has to be re-rerended
		    				setBetslipContext(function(prev){
		    					return {
		    						...prev,
		    						buttonPlayState : buttonState
		    					}
		    				});  
		    				ctxs.betslipContext.purchase();
	    				}
	    				else{
	    					  const protocol = ctxs.betslipContext.isVirtual? 'TICKET_PSV' : 'TICKET_PSQF';
	    					  window.addBodyShadow();
	    					  window.XSocket.askForPaper(protocol, (data) => {
	    						  window.removeBodyShadow();
	    						  if(data.body === 'OK'){
	    							  window.setPaperCaseEmpty(false);
	    			       				// all the component has to be re-rerended
	    			    				setBetslipContext(function(prev){
	    			    					return {
	    			    						...prev,
	    			    						buttonPlayState : buttonState
	    			    					}
	    			    				});
	    			    				ctxs.betslipContext.purchase();
	    						  }
	    						  else {
	    							  window.setPaperCaseEmpty(true, data.body);
	    							  ctxs.betslipContext.setPlayButtonState('play');
	    						  }
	    					  });
	    				  
	    				}


	    			}
	    			else{
	    				let confirmMessage = '';
	    				const coupon = ctxs.betslipContext.getCurrentCoupon();
	    				if(coupon.selections.length === 0){
	    					return;
	    				}
	    				if(coupon.selectedContainer === 'singlebets' && !betslipContext.isBetBuilder() && coupon.totalDraws > 1){
	    					confirmMessage = getLabel('carrello.warning.placing_n_single_bets_part1') + coupon.totalDraws + getLabel('carrello.warning.placing_n_single_bets_part2');
	    				}
	    				else{
	    					confirmMessage = getLabel('carrello.warning.placing_bet');
	    				}
	    				// all the component has to be re-rerended
	    				setBetslipContext(function(prev){
	    					return {
	    						...prev,
	    						buttonPlayState : buttonState,
	    						cartMessage : {type : 'confirm', message :confirmMessage}
	    					}
	    				});  
	    			}
	    		}
	    		else if(buttonState === 'play'){
	    			// remove cart message (will reset the buttons itself)
	    			ctxs.betslipContext.removeCartMessage();
	    			ctxs.betslipContext.restoreStateBeforeAcceptance();
	    			ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
	    		}
	    		else if(buttonState === 'again'){
	    			ctxs.betslipContext.removeCartMessage();
	    			ctxs.betslipContext.restoreStateBeforeAcceptance();
	    			ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
	    			setBetslipContext(function(prev){
	    				return {
	    					...prev,
	    					buttonPlayState : buttonState
	    				}
	    			});	   
	    		}
	    	} 
	    	else if (typeof window.appConfig?.HANDLERS?.toggleLogin === 'function') {
                window.appConfig.HANDLERS.toggleLogin(true);
            }
			else if (typeof showLogin === 'function') {
                showLogin();
				if(typeof window.closeBetslip === 'function') {
					window.closeBetslip();
				}
				else if(typeof window.toggleBetslip === 'function') {
					window.toggleBetslip();
				}
            } 
	    	else {
	    		setBetslipContext(function(prev){
	    			return {
	    				...prev,
	    				buttonPlayState : 'play'
	    			}
	    		});
	    		ctxs.betslipContext.setCartError(getLabel('carrello.error.user_not_logged'));
	    		ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('carrello.error.user_not_logged'));
	    	}
	    },
	   
	    validateCoupon : function(loadPrePurchaseOptions){
	    	// checking odds and status of each selection, and also the minimum amounts
	    	const result = {
	    			validated : true,
	    			errorMessage : null
	    	};
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const betOptionSelected = ctxs.betslipContext.betOptionsSelection && ctxs.betslipContext.betOptionsSelection.value !== 'REAL';
	    	if(coupon.selectedContainer === 'singlebets' && !betslipContext.isBetBuilder()){
	    		const amount = coupon.selections[0].bets[0].amount;
	    		const minimumAmount = betOptionSelected? 1 : ctxs.betslipContext.minimumBetAmount;
	    		const amountUnit = ctxs.betslipContext.minimumUnitAmount && !betOptionSelected? ctxs.betslipContext.minimumUnitAmount : 1;
	    		const isMultiple = amount % amountUnit == 0;
	    		if(amount < minimumAmount || isMultiple == false ){
	    			result.validated = false;
	    			const minimum = getCurrencyValue(minimumAmount,conf.cs.m, conf.cs.nd, conf.cs.ct);
	    			const unit = getCurrencyValue(amountUnit,conf.cs.m, conf.cs.nd, conf.cs.ct);
                    const errorMessage = `${getLabel('carrello.error.minimum_amount_part1')} ${minimum} ${getLabel('carrello.error.minimum_amount_part2')} ${unit}`;
	    			result.errorMessage = errorMessage;
	    		}
	    	}
	    	else if((coupon.selectedContainer === 'multibets' || betslipContext.isBetBuilder())){
	    		const amount = coupon.amountMulti;
	    		const minimumAmount = betOptionSelected? 1: ctxs.betslipContext.minimumBetAmount;
	    		const amountUnit = ctxs.betslipContext.minimumUnitAmount && !betOptionSelected? ctxs.betslipContext.minimumUnitAmount : 1;
	    		const isMultiple = amount % amountUnit == 0;
	    		if(amount < minimumAmount || isMultiple == false ){
	    			result.validated = false;
	    			const minimum = getCurrencyValue(minimumAmount,conf.cs.m, conf.cs.nd, conf.cs.ct);
	    			const unit = getCurrencyValue(amountUnit,conf.cs.m, conf.cs.nd, conf.cs.ct);
                    const errorMessage = `${getLabel('carrello.error.minimum_amount_part1')} ${minimum} ${getLabel('carrello.error.minimum_amount_part2')} ${unit}`;
	    			result.errorMessage = errorMessage;
	    		}
	    	}
	    	else if(coupon.selectedContainer === 'systembets'){
	    		const amount = coupon.amountSystem;
	    		const minimumAmount = ctxs.betslipContext.minimumBetAmountSystem;
	    		const amountUnit = ctxs.betslipContext.minimumCombAmount;
	    		const isMultiple = amount % amountUnit == 0;
	    		if(amount < minimumAmount || isMultiple == false ){
	    			result.validated = false;
	    			const minimum = getCurrencyValue(minimumAmount,conf.cs.m, conf.cs.nd, conf.cs.ct);
	    			const unit = getCurrencyValue(amountUnit,conf.cs.m, conf.cs.nd, conf.cs.ct);
                    const errorMessage = `${getLabel('carrello.error.minimum_amount_part1')} ${minimum} ${getLabel('carrello.error.minimum_amount_part2')} ${unit}`;
	    			result.errorMessage = errorMessage;
	    		}
	    	}
	    	
	    	if(result.validated){
		    	// odds must be checked only if there is not a acceptance transaction id, 'cause the trader could have been changed the odds in his proposal. 
		    	//const checkOdds = loadPrePurchaseOptions && !ctxs.betslipContext.transactionIdAcceptanceForProposal && !ctxs.betslipContext.isBetBuilder;
		    	const checkOdds = loadPrePurchaseOptions && !ctxs.betslipContext.transactionIdAcceptanceForProposal && !conf.bsp;
		    	const updatedStatus = checkOdds? ctxs.betslipContext.checkForSelectionsUpdate() : 0;
		    	if(updatedStatus !== 0){
		    		result.validated = false;
		    	}	    		
	    	}
	    	
	    	return result;
	    },
	    
	    startLiveSelectionsPollingIfPossible : function(){
	    	ctxs.betslipContext.disableLiveSelectionsPolling();
	   		const conf = getConfiguration();
	   		const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(conf.bsp && !ctxs.betslipContext.selectionsPollingIntervalId && isLiveBetting(coupon.selections, coupon.selectedContainer) && ctxs.betslipContext.user?.logged){
		    	function setAgainTimeout(){
			    	const selectionsPollingIntervalId = window.setTimeout(() => {
			    		ctxs.betslipContext.checkForSelectionsUpdate(true);
			    		if(ctxs.betslipContext.liveSelectionPollingStatus !== 'disabled'){
				    		setAgainTimeout();			    		
			    		}
			    	}, conf.bsp);
			    	ctxs.betslipContext.updateFullContext({selectionsPollingIntervalId, liveSelectionPollingStatus:"enabled" });			    		
		    	}
				setAgainTimeout();	
	    	}
	    },
	    
	    disableLiveSelectionsPolling : function(){
	    	window.clearTimeout(ctxs.betslipContext.selectionsPollingIntervalId);
		    ctxs.betslipContext.updateFullContext({selectionsPollingIntervalId : null, liveSelectionPollingStatus :"disabled"});	 
	    },
	    
	    getAmountDataForModal : function (){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const conf = getConfiguration();
	    	const showTaxedStakePotentialWinning = ctxs.betslipContext.stakeTaxConfiguration.enabled && ctxs.betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
	    	let potentialWinning = getCurrencyValue(showTaxedStakePotentialWinning? coupon.stakeTaxedPotentialWinning : coupon.potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
	        
	    	if (coupon.selectedContainer === 'systembets' && conf.sbmw !== 0 && conf.mwspw) {
	        	
	    		if(showTaxedStakePotentialWinning){
	        		if (coupon.stakeTaxedPotentialWinning > conf.sbmw) {
	        			potentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
	        		}
	    		}
	    		else{
	    			if (coupon.potentialWinning > conf.sbmw) {
	    				potentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);
	    			}
	    		}
	        } 
	        else if (conf.mbmw !== 0 && conf.mwmpw) {
	        	if(showTaxedStakePotentialWinning){
	        		if (coupon.stakeTaxedPotentialWinning > conf.mbmw) {
	        			potentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
	        		}
	        	}
	        	else {
	        		if (coupon.potentialWinning > conf.mbmw) {
	        			potentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
	        		}
	        	}
        			
	        }
	    	
	    	
	    	const totalOdd = coupon.selectedContainer === 'multibets'? coupon.totalOdd : null;
	    	const bonusAmount = coupon.multipleBonus && coupon.multipleBonus.applied && coupon.selectedContainer === 'multibets'? getCurrencyValue(coupon.multipleBonus.bonusAmount, conf.cs.m, conf.cs.nd, conf.cs.ct) : null;
	    	return {
	    		potentialWinning,
	    		totalOdd,
	    		bonusAmount
	    	};
	    },
	    
	    tryAgainPurchaseFromVariationModal : function(){
	    	// set the play button to "confirm" in order to check again the odds and, if any, to reload the wagering data
	    	ctxs.betslipContext.setPlayButtonState('confirm', true);
	    },
	    
	    checkForSelectionsUpdate : function (hideModal) {

	    	if(ctxs.betslipContext.betInProgress){
	    		return -1;
	    	}
	    	const conf = getConfiguration();
	    	let finalCode = 0; // 0 means: go on
	    	if(ctxs.betslipContext.user && ctxs.betslipContext.user.logged){
	    		const shopUserData = ctxs.shopContext.enabled? ctxs.shopContext.getShopUser() : null;
	    		const sessionToken = ctxs.betslipContext.user.sessionToken;
				const frontendType = ctxs.shopContext.enabled? ctxs.shopContext.type : 'ONLINE';
				const coupon = ctxs.betslipContext.getCurrentCoupon();
				if(coupon.selections.length == 0){
					return;
				}
	    		const response = checkForSelectionsUpdate(ctxs.betslipContext.betslipData, frontendType, sessionToken, shopUserData);
	    		if(ctxs.betslipContext.betInProgress){
	    			return -1; 
	    			// dovrebbe essere impossibile che una bet sia in progress, ma abbiamo visto un caso in cui, mentre il carello era bloccato
	    			// arrivavano queste richieste al backend di continuo. Il risultato e' che allo scadere del timer, il carrello e' stato piazzato
	    			// con la quota gia' aggiornata
	    		}
	    		if(response?.returnCode?.code !== 0){
	    			let selectionsContainer = null;
	    			if(coupon.selectedContainer === 'singlebets'){
	    				selectionsContainer = response.responseSingle;
	    			}
	    			else if(coupon.selectedContainer === 'multibets'){
	    				selectionsContainer = response.responseMultiple;
	    			}
	    			else{
	    				selectionsContainer = response.responseSystems;
	    			}
	    			if(response.returnCode.code === -5085){
						// UPDATED ODDS
						const updatingResult = ctxs.betslipContext.updateOdds(selectionsContainer);
						// setting the minor timer live
						if(coupon.oddVariation !== 'NEVER' && updatingResult === 0){
    						if(coupon.oddVariation === 'INCR' && !ctxs.betslipContext.oddsAreIncreased()){
    							ctxs.betslipContext.setCartWarning(getLabel('carrello.var_quota.warning')); 
								const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled && !hideModal;
    							if(showVariationModal){
    								const selections = ctxs.betslipContext.getCurrentCoupon().selections;
    								window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
    							}
    							finalCode = -1;
    						}
						}
						else{
							ctxs.betslipContext.setCartWarning(getLabel('carrello.var_quota.warning'));
							const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled && !hideModal;
							if(showVariationModal){
								ctxs.betslipContext.disableLiveSelectionsPolling();
								const selections = ctxs.betslipContext.getCurrentCoupon().selections;
								window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
							}
							finalCode = -1;
						}
	    			}
	    			else if(response.returnCode.code == -5105){
						// bets or events are closed
	    				ctxs.betslipContext.updateSelectionsState(selectionsContainer);
	    				ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
						const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled && (!hideModal || conf.mbvc);
						if(showVariationModal){
							const selections = ctxs.betslipContext.getCurrentCoupon().selections;
							window.showBetslipVariationModal(selections, getLabel('carrello.error.expired_selections'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal(), () => { ctxs.betslipContext.removeOutdatedSelections();  ctxs.betslipContext.startLiveSelectionsPollingIfPossible();});
							ctxs.betslipContext.disableLiveSelectionsPolling();
						}
	    				finalCode = -1;
					}
	    		}
	    		else{
	    			ctxs.betslipContext.removeUpdatedInfo(true);
	    		}
	    	}
	    	else{
	    		setBetslipContext(function(prev){
	    			return {
	    				...prev,
	    				buttonPlayState :'play'
	    			}
	    		});
	    		ctxs.betslipContext.setCartError(getLabel('carrello.error.user_not_logged'));
	    		finalCode = -1;
	    	}
	    	return finalCode;
	    },
	    
	    
	    startPurchasePolling : function(scheduledPurchaseParameters){	
			ctxs.betslipContext.updateFullContext({livePollingInProgress : true});
	    	let shopUserType = null;
			if(ctxs.shopContext.enabled){
				const shopUserData = ctxs.shopContext.getShopUser();
				shopUserType = shopUserData.operator? 'operator' : 'self-cashier';
			}
			const sessionToken = ctxs.betslipContext.user.sessionToken;
			scheduledPurchaseParameters.vipSystemData = xs_getVipSystemData(false);
	    	localStorage.setItem('PURCHASE_TRANSACTION_SCHEDULED_DATA', JSON.stringify(scheduledPurchaseParameters));
	    	const livePollingHandler = conf.ldeh || 'WEOT';
	    	function action(){
			    function pollingOperation(millis){
			    	setTimeout(() => {
				    	getScheduledPurchaseTransaction(sessionToken, 
				    									shopUserType, 
				    									scheduledPurchaseParameters.transactionId,
				    									ctxs.betslipContext.getSelectedBetslipPromos(), 
				    									scheduledPurchaseParameters.vipSystemData,
				    									scheduledPurchaseParameters.live,
				    									successCallback,
				    									errorCallback);			    	
			    	}, millis);
			    }
	
			    function errorCallback(){
			    	ctxs.betslipContext.setLoaderData({type:'live_end_timer'}); // advise for the customer: bet in progress
		    		// in 1 second, retry
		    		pollingOperation(1000);
		    	}
		    	
		    	function successCallback(data){
		    		const result = data.returnCode.code;
		    		if(result == -9996){
		    			if(livePollingHandler === 'WEOT' && scheduledPurchaseParameters.live){
		    				// end of the progress bar timer
		     				ctxs.betslipContext.setLoaderData({type:'live_end_timer'}); // advise for the customer: bet in progress
		    			}
		    			pollingOperation(1000);
		    		}
		    		else if(result == -9999){
		    			// this has been converted into an acceptance transaction
		    			// start acceptance flow
		    			localStorage.removeItem('PURCHASE_TRANSACTION_SCHEDULED_DATA');
		    			ctxs.betslipContext.updateFullContext({livePollingInProgress : false});
		    			ctxs.betslipContext.acceptance(scheduledPurchaseParameters.transactionId);
		    		}
		    		else if(result == -9995 && data.returnCode.object){
		    			if(livePollingHandler === 'CSWD' && scheduledPurchaseParameters.live){
		    				ctxs.betslipContext.clearLivePollingTimeoutId();
		    			}
		    			// odds variation: updating bets and automatic purchase
		    			localStorage.removeItem('PURCHASE_TRANSACTION_SCHEDULED_DATA');
		    			ctxs.betslipContext.updateFullContext({livePollingInProgress : false});
		    			const childRequestInfo = JSON.parse(data.returnCode.object);
		    			const betResponse = data.responseSingle || data.responseMultiple || data.responseSystems;
		    			const updatingResult = ctxs.betslipContext.updateOdds(betResponse);
		    			ctxs.betslipContext.setBetInProgress(false);
						if(ctxs.shopContext.enabled){
	    	    			ctxs.shopContext.setFree();
	    	    		}
	    	    		if(updatingResult === 0){
	    	    			// se effettivamente c'è stato un update, acquisto con le nuove quote
			    			ctxs.betslipContext.purchase(childRequestInfo.fatherTransactionId);	    	    		
	    	    		}
	    	    		else{
	    	    			localStorage.removeItem('PURCHASE_TRANSACTION_SCHEDULED_DATA');
		    				ctxs.betslipContext.updateFullContext({livePollingInProgress : false});
	    	    			// fermo tutto: se il backend mi sta rispondendo con le stesse quote potrei entrare in un loop. Meglio fermarsi
	    	    		   	ctxs.betslipContext.setCartWarning(getLabel('carrello.var_quota.warning'));
							const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled;
							if(showVariationModal){
								const selections = ctxs.betslipContext.getCurrentCoupon().selections;
								window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
							}	    	    			
	    	    		}
		    			
		    		}
		    		else{
		    			if(livePollingHandler === 'CSWD' && scheduledPurchaseParameters.live){
		    				ctxs.betslipContext.clearLivePollingTimeoutId();
		    			}
		    			localStorage.removeItem('PURCHASE_TRANSACTION_SCHEDULED_DATA');
		    			ctxs.betslipContext.updateFullContext({livePollingInProgress : false});
		    			ctxs.betslipContext.purchaseResponseCallback(data);
		    		}
		    	}
	    		getScheduledPurchaseTransaction(sessionToken, 
												shopUserType, 
												scheduledPurchaseParameters.transactionId, 
												ctxs.betslipContext.getSelectedBetslipPromos(),
												scheduledPurchaseParameters.vipSystemData,
												scheduledPurchaseParameters.live,
												successCallback,
												errorCallback);		    	
	    	
	    	}
	    	
	    	if(scheduledPurchaseParameters.live){
	    		// if WEOT, then the start polling action must be done at the end of the timer, immediatly otherwise
			    if(livePollingHandler === 'WEOT'){
					ctxs.betslipContext.setBetLoader(true, false, scheduledPurchaseParameters.delay * 1000, action); 	    
			    }
			    else if(livePollingHandler === 'CSWD'){
			    	ctxs.betslipContext.setBetLoader(true, false, scheduledPurchaseParameters.delay * 1000, function(){}); 	
			    	action();
			    }	    	
	    	}
	    	else{
	    		// giocata prematch
	    		ctxs.betslipContext.setBetLoader(false, false, null, () => {});	
			    action();
	    	}

	    	
	    },
	    loadVipSystemDataOnCoupon : function(){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	coupon.vipSystemData = xs_getVipSystemData(false);
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    },
	    purchase : function(fatherTransactionId){
	    	if(ctxs.betslipContext.betInProgress){
	    		return "operationInProgress";
	    	}
	    	if(ctxs.shopContext.enabled && ctxs.shopContext.busy){
	    		// try again in 100 milliseconds
	    		console.debug("[purchase function cannot set busy app from ShopConf because of " + ctxs.shopContext.blockerFunction  + "... Retry in 100 ms]");
	    		setTimeout(() => {
	    			ctxs.betslipContext.purchase(fatherTransactionId);
	    		},
	    		100);
	    		return "operationInProgress";
	    	}
	    	

	    	
	    	if(ctxs.betslipContext.user && ctxs.betslipContext.user.logged){
		    	const coupon = ctxs.betslipContext.getCurrentCoupon();
		    	
		    	let frontendType = 'ONLINE';
				let shopUserData = null;
				if(ctxs.shopContext.enabled){
					frontendType = ctxs.shopContext.type;
					shopUserData = ctxs.shopContext.getShopUser();
				}
		    	const generateHumanPurchaseCondition = frontendType === 'ONLINE' && !isLiveBetting(coupon.selections, coupon.selectedContainer);
	    	
				humanPurchaseTokenCheckpoint(generateHumanPurchaseCondition, (humanPurchaseToken) => {
		    		ctxs.betslipContext.clearAcceptanceOfferTimeout();
		    		ctxs.betslipContext.setBetInProgress(true);
		    		if(ctxs.shopContext.enabled){
		    			ctxs.shopContext.setBusy();
		    		}
		    		
		    		
		    		if(!ctxs.betslipContext.isVirtual){
		    			ctxs.betslipContext.removeUpdatedInfo();
		    		}
		    		
		    		if(ctxs.betslipContext.isVirtual){
		    			const expiredSelections = ctxs.betslipContext.checkAndUpdateSelectionsState();
		    			if(expiredSelections){
		    				ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
		    				ctxs.betslipContext.setBetInProgress(false);
		    	    		if(ctxs.shopContext.enabled){
		    	    			ctxs.shopContext.setFree();
		    	    		}
		    				return;
		    			}
		    		}
		    		
		    		if(coupon.selections.length == 0){
		    			ctxs.betslipContext.setCartError(getLabel('carrello.error.no_selections'));
						ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.error.no_selections'));
	    				ctxs.betslipContext.setBetInProgress(false);
	    	    		if(ctxs.shopContext.enabled){
	    	    			ctxs.shopContext.setFree();
	    	    		}
		    			return;
		    		}
		    		else{
		    			if(coupon.playabilityIssue){
		    				let playabilityError = getLabel('playability.purchase_error');
		    				ctxs.betslipContext.setCartError(playabilityError);
							ctxs.betslipContext.playVocalAssistantMessage(playabilityError);
		    				ctxs.betslipContext.showModalAdviseIfProvided('error', playabilityError);
		    				ctxs.betslipContext.setBetInProgress(false);
		    	    		if(ctxs.shopContext.enabled){
		    	    			ctxs.shopContext.setFree();
		    	    		}
			    			return;
		    			}
		    		}
	
					const sessionToken = ctxs.betslipContext.user.sessionToken;
		    		
		    		ctxs.bonusContext.disablePolling();
					const cf = ctxs.shopContext.enabled? ctxs.shopContext.cfForPurchase : null;
	    			let selectedFunbonus = null;
	    			let selectedFreebet = null;
	    			if(coupon.selectedContainer !== 'systembets' && ctxs.betslipContext.betOptionsSelection.value !== 'REAL'){
	      				if(ctxs.betslipContext.betOptionsSelection.type === 'freebet'){
	      					selectedFreebet = ctxs.betslipContext.betOptionsSelection.value;
	      					selectedFreebet = selectedFreebet == null ? null : selectedFreebet + "";	    					
	    				}
	    				if(ctxs.betslipContext.betOptionsSelection.type === 'funbonus'){
	    					selectedFunbonus = ctxs.betslipContext.betOptionsSelection.value;
	    					selectedFunbonus = selectedFunbonus == null ? null : selectedFunbonus + "";	    					
	    				}
	    			}
	    			
	    			if(!selectedFunbonus && !selectedFreebet){
	    				//remove bet option panel
	    				ctxs.betslipContext.removeBetOptionsSection();
	    			}
	
	    			const idPvr = ctxs.pvrContext.pvrSectionEnabled? ctxs.pvrContext.idPvr : null;
	    			const transactionIdAcceptanceForProposal = ctxs.betslipContext.transactionIdAcceptanceForProposal;
					const provProfile = ctxs.betslipContext.provDoubleProfileValue !== null && !ctxs.betslipContext.isVirtual? ctxs.betslipContext.provDoubleProfileValue : null;
					const frontendTransactionId = generateFrontendTransactionId(ctxs.betslipContext.user);
					if(frontendTransactionId){
						saveFrontendTransactionId(frontendTransactionId, PURCHASE_RETRY);
					}
					ctxs.betslipContext.loadVipSystemDataOnCoupon();
					ctxs.betslipContext.setBetLoader(false, false, null, () => {});
					ctxs.betslipContext.disableLiveSelectionsPolling();
		    		getPurchaseResponse(ctxs.betslipContext.betslipData, 
		    							selectedFunbonus, 
		    							selectedFreebet, 
		    							idPvr, 
		    							sessionToken, 
		    							transactionIdAcceptanceForProposal, 
		    							frontendType, 
		    							shopUserData, 
		    							cf, 
		    							provProfile, 
		    							frontendTransactionId,
		    							fatherTransactionId,
		    							humanPurchaseToken,
		    							ctxs.betslipContext.getSelectedBetslipPromos(),
		    							ctxs.betslipContext.purchaseResponseCallback, 
		    							() => {
		    								ctxs.betslipContext.purchaseFailedCallback(frontendTransactionId, shopUserData, sessionToken);
		    							});				
				
				
				});
	    	}
	    	else{
	    		// sessione scaduta
	    		ctxs.betslipContext.removeBetOptionsSection();
	    		setBetslipContext(function(prev){
	    			return {
	    				...prev,
	    				buttonPlayState :'play'
	    			}
	    		});
	    		ctxs.betslipContext.setCartError(getLabel('carrello.error.user_not_logged'));
				ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.error.user_not_logged'));
		    	if(ctxs.betslipContext.addAndBet){
		    		if( isMobile && typeof window.openBetslip === 'function'){
		    			// if mobile I open the betslip to show the error
		    			window.openBetslip();
		    		}
		    		setTimeout(() => {
		    			// remove all the previous bets
		    			ctxs.betslipContext.clearBetslip();
	        			if(isMobile && typeof window.hideBetslip === 'function'){
	        				window.hideBetslip();
	        			}
		    		}, ctxs.betslipContext.timeoutErrorAddAndBet);
		    	}
				// if the purchase has been request by querystring (notification push or oddschecker)
				// I disable the current operation, and I clean the querystring without a reload, in order
				// to allow the user to take its decision
				if(ctxs.landingRequestedOpsContext.enabled){
					ctxs.landingRequestedOpsContext.disable(true, false); 
				}
				return "userUnlogged";
	    	}
	    },
	    
	    startRetryTicketFlowDueToNetworkIssue : function (frontendTransactionId){
	    	if(ctxs.betslipContext.betInProgress){
	    		return;
	    	}
	    	ctxs.betslipContext.setBetInProgress(true);
    		if(ctxs.shopContext.enabled){
    			ctxs.shopContext.setBusy();
    		}
	    	const shopUserData = ctxs.shopContext.enabled? ctxs.shopContext.getShopUser() : null;
	    	const sessionToken = ctxs.betslipContext.user.sessionToken;
	    	ctxs.betslipContext.purchaseFailedCallback(frontendTransactionId, shopUserData, sessionToken);

	    },
	    
	    purchaseResponseCallback : function (response){
    			ctxs.betslipContext.clearSelectionsStateBeforeAcceptance();
    			const code = response.returnCode.code;
    			const coupon = ctxs.betslipContext.getCurrentCoupon();
    			const couponIndex = ctxs.betslipContext.betslipData.selectedCoupon;
    			let selectedFunbonus = null;
				let selectedFreebet = null;
				if(coupon.selectedContainer !== 'systembets' && ctxs.betslipContext.betOptionsSelection.value !== 'REAL'){
      				if(ctxs.betslipContext.betOptionsSelection.type === 'freebet'){
      					selectedFreebet = ctxs.betslipContext.betOptionsSelection.value;
      					selectedFreebet = selectedFreebet == null ? null : selectedFreebet + "";	    					
    				}
    				if(ctxs.betslipContext.betOptionsSelection.type === 'funbonus'){
    					selectedFunbonus = ctxs.betslipContext.betOptionsSelection.value;
    					selectedFunbonus = selectedFunbonus == null ? null : selectedFunbonus + "";	    					
    				}
				}
	    		let shopUserData = null;
				if(ctxs.shopContext.enabled){
					shopUserData = ctxs.shopContext.getShopUser();
				}
				const sessionToken = ctxs.betslipContext.user.sessionToken;
				let frontendTransactionId = null;
				const startRetryFlow = code === -9998 || code === -104;
				const frontendTransactionIdContainer = getPendingFrontendTransactionId();
				if(frontendTransactionIdContainer && (frontendTransactionIdContainer.type === PURCHASE_RETRY || startRetryFlow)){
					frontendTransactionId = frontendTransactionIdContainer.frontendTransactionId;
	    			removeFrontendTransactionId();
				}
				let startCheckingOddsPollingAtTheEnd = true;
    			if(response != null){
    				if(ctxs.shopContext.enabled){
    					ctxs.shopContext.setCfForPurchase(null);
    				}
    				ctxs.betslipContext.setTransactionIdAcceptanceForProposal(null);
    				let betResponse = null;
    				if(coupon.selectedContainer === 'multibets' || ctxs.betslipContext.isBetBuilder()){
    					betResponse = response.responseMultiple;
    				}
    				if(!betResponse && coupon.selectedContainer === 'systembets'){
    					betResponse = response.responseSystems;
    				}
    				if(!betResponse && (coupon.selectedContainer === 'singlebets' || ctxs.betslipContext.isBetBuilder())){
    					betResponse = response.responseSingle;
    				}
    				
    				if(code == -5281){
    					//ctxs.betslipContext.removeBetOptionsSection();
    					ctxs.betslipContext.removeBetLoader();
						ctxs.betslipContext.setBetInProgress(false);
						if(ctxs.shopContext.enabled){
							ctxs.shopContext.setFree();
						}
						ctxs.betslipContext.setCartError(response.returnCode.description, response.returnCode.code);
						ctxs.betslipContext.playVocalAssistantMessage(response.returnCode.description);
						if(ctxs.shopContext.enabled && ctxs.shopContext.operator){
							ctxs.shopContext.showCfPopup(() => {
	    						ctxs.betslipContext.purchase();
	    					});
						}
    					return;
    				}
    				if(code == 1024 || code == 0){
						console.debug("purchaseResponseCallback [returnCode:"+code+"][isShopContext:"+ctxs?.shopContext?.enabled+"]");
						if(ctxs?.shopContext?.enabled){
							const timeout = conf?.rs?.ssbprt;
							ctxs.betslipContext.setSecondScreenBetslipPurchaseRefreshTimeout(timeout);
							if(ctxs.shopContext.type === 'TERMINAL'){
					    		xs_clearVipSystemData('purchaseResponseCallback');
			    			}
						}
						if(ctxs.betslipContext.provProfileEnabled){
							// switch to default
							ctxs.betslipContext.setProvSettings(props.doubleProfileDefaultChoice);
						}
    					//ctxs.betslipContext.removeBetOptionsSection();
    					ctxs.betslipContext.setBetSuccess(betResponse.ticketSogei, () =>{
							console.debug("setBetSuccess for ticket "+betResponse?.ticketSogei);
    						window.setLastTicketPurchasedOnLS((ctxs.betslipContext.isVirtual? 'PSV' : 'PSQF'), betResponse.ticketSogei, false, false, betResponse.importoScommesso, betResponse.amountWin);
							console.debug("setBetSuccess 1");
    						const amount = betResponse.importoScommesso;
    						const type = coupon.selectedContainer;
    						const realPurchase = !selectedFunbonus && !selectedFreebet;
    						pushSuccessPurchaseNotification(amount, type, realPurchase, betResponse.ticketSogei, ctxs.shopContext.enabled, betResponse.printData);
							console.debug("setBetSuccess 2");
    						if(coupon.selectedContainer === 'singlebets' && !ctxs.betslipContext.isBetBuilder()){
								console.debug("setBetSuccess 3");
    							if(ctxs.betslipContext.addAndBet){
									console.debug("setBetSuccess 4");
	    							ctxs.betslipContext.removeBetLoader();
									console.debug("setBetSuccess 5");
    								// if mobile, I close the betslip
    				        		if(isMobile){
    				        			if(typeof window.hideBetslip === 'function'){
    				        				window.hideBetslip();
    				        			}
    				        		}
    								
    								if(ctxs.shopContext.enabled){
										console.debug("setBetSuccess 6");
    									ctxs.shopContext.triggerReloadMainUser(betResponse.importoScommesso);
    								}
    								else if(ctxs.pvrContext.pvrSectionEnabled){
										console.debug("setBetSuccess 7");
    									ctxs.pvrContext.reloadUser();
    								}
    								else{
										console.debug("setBetSuccess 8");
    									ctxs.userContext.reloadUser();
    								}
    								ctxs.betslipContext.setKeepContainer(false);
									console.debug("setBetSuccess 9");
    								ctxs.bonusContext.enablePolling();
									console.debug("setBetSuccess 10");
									ctxs.betslipContext.setBetInProgress(false);
									console.debug("setBetSuccess 11");
									if(ctxs.shopContext.enabled){
										console.debug("setBetSuccess 12");
										ctxs.shopContext.setFree();
									}
									ctxs.betslipContext.clearBetslip(couponIndex);
									console.debug("setBetSuccess 13");
    							}
    							else{
    								const purchaseNext = !ctxs.shopContext.enabled && (coupon.selections.length > 1 || (coupon.selections.length > 0 && coupon.selections[0].bets.length > 1));
    								const lastOne = coupon.selections.length == 1 && coupon.selections[0].bets.length == 1;
	    							
        							if(lastOne || ctxs.shopContext.enabled){
										console.debug("setBetSuccess 15");
	    								// checking the autoprint function
        								
	    								const autoPrint = ctxs.controlPanelContext.isAutoprint() || ctxs.shopContext.enabled;
	    								if(autoPrint){
											console.debug("call printTicket: "+betResponse?.ticketSogei);
	    									ctxs.ticketPrinterContext.printTicket(betResponse.ticketSogei, false, betResponse.printData);
	    								}
	    							}
        							ctxs.betslipContext.setBetInProgress(false);
									console.debug("setBetSuccess 16");
									if(ctxs.shopContext.enabled){
										console.debug("setBetSuccess 17");
										ctxs.shopContext.setFree();
									}
    								// remove the singlebet purchased if it is not the last one, or if it is the last one and
    								// the user setted "Save betslip = false"
    								const emptyCart = !ctxs.betslipContext.betslipData.saveBetslip || ctxs.shopContext.enabled;
        							if(!lastOne || (emptyCart && lastOne)){
        								ctxs.betslipContext.removeFirstSelection();	
										console.debug("setBetSuccess 18");	        								
        							}
        							
        							
	    							if(purchaseNext){
	    								ctxs.betslipContext.purchase();
										console.debug("setBetSuccess 19");
	    							}
	    							else{	
	    								ctxs.betslipContext.removeBetLoader();
										console.debug("setBetSuccess 20");
	    								if(ctxs.shopContext.enabled){
	    									ctxs.shopContext.triggerReloadMainUser(betResponse.importoScommesso);
											console.debug("setBetSuccess 21");
	    								}
	    								else if(ctxs.pvrContext.pvrSectionEnabled){
	    									ctxs.pvrContext.reloadUser();
											console.debug("setBetSuccess 22");
	    								}
	    								else{
	    									ctxs.userContext.reloadUser();	
	    									ctxs.betslipContext.loadBetOptionsIfEnabled();	
											console.debug("setBetSuccess 23");    									
	    								}
	    								ctxs.betslipContext.setKeepContainer(false);
										console.debug("setBetSuccess 24");
	    								ctxs.bonusContext.enablePolling();
										console.debug("setBetSuccess 25");
	    								// if the purchase has been request by querystring (notification push or oddschecker)
	    								// I disable the current operation, and I reload the page without that parameters
	    								if(ctxs.landingRequestedOpsContext.enabled){
	    	    							// here it was reload = true
	    	    							ctxs.landingRequestedOpsContext.disable(true, false);
											console.debug("setBetSuccess 26");
	    								}
	    									
	    							}
    							}

    						}
    						else{
	    						ctxs.betslipContext.removeBetLoader();
    							
								console.debug("setBetSuccess 27");
								// checking the autoprint function
								const autoPrint = (ctxs.controlPanelContext.printerSettings.automaticPrint) || ctxs.shopContext.enabled;
								if(autoPrint){
									console.debug("call printTicket: "+betResponse?.ticketSogei);
									const onPrintDone = coupon?.selectedContainer === 'systembets' && ctxs.betslipContext.isPrintingSystembetsDetailEnabled() ? () => { ctxs.ticketPrinterContext?.promptPrintSystemBetDetailsTicket(betResponse.ticketSogei) } : null;
									ctxs.ticketPrinterContext.printTicket(betResponse.ticketSogei, false, betResponse.printData, onPrintDone);
								}
    							
								if(ctxs.shopContext.enabled){
									console.debug("setBetSuccess 28");
									ctxs.shopContext.triggerReloadMainUser(betResponse.importoScommesso);
								}
								else if(ctxs.pvrContext.pvrSectionEnabled){
									console.debug("setBetSuccess 29");
									ctxs.pvrContext.reloadUser();
								}
								else{
									console.debug("setBetSuccess 30");
									ctxs.userContext.reloadUser();
								}
								ctxs.betslipContext.setBetInProgress(false);
								console.debug("setBetSuccess 31");
								if(ctxs.shopContext.enabled){
									ctxs.shopContext.setFree();
									console.debug("setBetSuccess 32");
								}
    							if(!ctxs.betslipContext.betslipData.saveBetslip || ctxs.shopContext.enabled) {
	    							ctxs.betslipContext.clearBetslip(couponIndex);
									console.debug("setBetSuccess 33");
    							}
    							else{
    								ctxs.betslipContext.setPlayButtonState('again');
									console.debug("setBetSuccess 34");
    							}
								
    							ctxs.bonusContext.enablePolling();
								console.debug("setBetSuccess 35");
    							// if the purchase has been request by querystring (notification push or oddschecker)
								// I disable the current operation, and I reload the page without that parameters
								if(ctxs.landingRequestedOpsContext.enabled){
	    							// here it was reload = true
	    							ctxs.landingRequestedOpsContext.disable(true, false);
									console.debug("setBetSuccess 36");
								}
    						}	
    					});
						ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.ticket_sold'))
    				}
    				else{
    					if(startRetryFlow){
    						// connection issue between datastore and purchase application. Starting retry flow...
    						ctxs.betslipContext.purchaseFailedCallback(frontendTransactionId, shopUserData, sessionToken);
    						return;
    					}
    					
    					if(code == -9996){
    						startCheckingOddsPollingAtTheEnd = false;
    						ctxs.betslipContext.startPurchasePolling(response.returnCode.object);
    					}
    					else{
    						ctxs.betslipContext.setBetInProgress(false);
							if(ctxs.shopContext.enabled){
								ctxs.shopContext.setFree();
							}
	    					// if the purchase has been request by querystring (notification push or oddschecker)
							// I disable the current operation, and I clean the querystring without a reload, in order
	    					// to allow the user to take its decision
							if(ctxs.landingRequestedOpsContext.enabled){
								ctxs.landingRequestedOpsContext.disable(true, false); 
							}
	    					if(code == -5085){		    						
	    						// UPDATED ODDS: here there is just prematch betslip handler if the request is sent from datastore directly: the live and prematch by tailcutter ones are handled by startPurchasePolling function
		    						const updatingResult = ctxs.betslipContext.updateOdds(betResponse);
	    							//ctxs.betslipContext.removeBetOptionsSection(true);
	    							ctxs.betslipContext.removeBetLoader();
	    							ctxs.betslipContext.setCartWarning(getLabel('carrello.var_quota.warning'));
	    							const betAgain = updatingResult === 0 && (coupon.oddVariation == 'ALWAYS' || (coupon.oddVariation === 'INCR' && ctxs.betslipContext.oddsAreIncreased()));
	    							if(betAgain){
	    								ctxs.betslipContext.purchase();
	    								return;
	    							}else{
										ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.var_quota.warning'));
									}
	    							const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled;
	    							if(showVariationModal){
	    								const selections = ctxs.betslipContext.getCurrentCoupon().selections;
	    								window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
	    							}
	    							ctxs.betslipContext.loadBetOptionsIfEnabled();
	    					}
	    					else if(code == -5105){
	    						// bets or events are closed
	    						if(!ctxs.betslipContext.isVirtual){
		    						ctxs.betslipContext.updateSelectionsState(betResponse);
		    						//ctxs.betslipContext.removeBetOptionsSection();
		    						ctxs.betslipContext.removeBetLoader();
		    						ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
									ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.error.expired_selections'));
	    							const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled;
	    							if(showVariationModal){
	    								const selections = ctxs.betslipContext.getCurrentCoupon().selections;
	    								window.showBetslipVariationModal(selections, getLabel('carrello.error.expired_selections'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
	    							}
	    							ctxs.betslipContext.loadBetOptionsIfEnabled();
	    						}
	    						else {
	    							ctxs.betslipContext.setCartError(response.returnCode.description, response.returnCode.code);
	    							ctxs.betslipContext.showModalAdviseIfProvided('error', response.returnCode.description, response.returnCode.code);
	    						}
	    					} 
	    					else if(code == -9999){
	    						// acceptance
	    						startCheckingOddsPollingAtTheEnd = false;
	    						ctxs.betslipContext.setCartError(response.returnCode.description);
	    						ctxs.betslipContext.acceptance(betResponse.transactionIDString);
								ctxs.betslipContext.playVocalAssistantMessage(response.returnCode.description);
	    					}
	    					else{
	    				    	ctxs.bonusContext.enablePolling();
	    						ctxs.betslipContext.removeBetLoader();
	    						//ctxs.betslipContext.removeBetOptionsSection();	
	    						ctxs.betslipContext.setCartError(response.returnCode.description, response.returnCode.code);
	    						ctxs.betslipContext.showModalAdviseIfProvided('error', response.returnCode.description, response.returnCode.code);
								ctxs.betslipContext.playVocalAssistantMessage(response.returnCode.description);
	    				    	if(ctxs.betslipContext.addAndBet){
	    				    		if( isMobile && typeof window.openBetslip === 'function'){
	    				    			// if mobile I open the betslip to show the error
	    				    			window.openBetslip();
	    				    		}
	    				    		setTimeout(() => {
	    				    			// remove all the previous bets
	    				    			ctxs.betslipContext.clearBetslip();
					        			if(isMobile && typeof window.hideBetslip === 'function'){
					        				window.hideBetslip();
					        			}
	    				    		}, ctxs.betslipContext.timeoutErrorAddAndBet);
	    				    	}
	    				    	ctxs.betslipContext.loadBetOptionsIfEnabled();
	    					}							
    					}		
    				}
    			}
    			else{
    				ctxs.bonusContext.enablePolling();
    				ctxs.betslipContext.removeBetLoader();
    				//ctxs.betslipContext.removeBetOptionsSection();
    				ctxs.betslipContext.setCartError(getLabel('carrello.error.ticket_not_sold'));
					ctxs.betslipContext.playVocalAssistantMessage(getLabel('carrello.error.ticket_not_sold'));
					ctxs.betslipContext.setBetInProgress(false);
					if(ctxs.shopContext.enabled){
						ctxs.shopContext.setFree();
					}
			    	if(ctxs.betslipContext.addAndBet){
			    		if( isMobile && typeof window.openBetslip === 'function'){
			    			// if mobile I open the betslip to show the error
			    			window.openBetslip();
			    		}
			    		setTimeout(() => {
			    			// remove all the previous bets
			    			ctxs.betslipContext.clearBetslip();
		        			if(isMobile && typeof window.hideBetslip === 'function'){
		        				window.hideBetslip();
		        			}
			    		}, ctxs.betslipContext.timeoutErrorAddAndBet);
			    	}
					

					
					// if the purchase has been request by querystring (notification push or oddschecker)
					// I disable the current operation, and I clean the querystring without a reload, in order
					// to allow the user to take its decision
					if(ctxs.landingRequestedOpsContext.enabled){
						ctxs.landingRequestedOpsContext.disable(true, false); 
					}
			    	
    			}
    			if(startCheckingOddsPollingAtTheEnd && isLiveBetting(coupon.selections, coupon.selectedContainer) && ctxs.betslipContext.user?.logged){
					ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
				}
				ctxs.betslipContext.loadBetOptionsIfEnabled();
	    },					
				
	    
	    purchaseFailedCallback : function(frontendTransactionId, shopUserData, sessionToken){
	    	const couponIndex = ctxs.betslipContext.betslipData.selectedCoupon;
    		const coupon = ctxs.betslipContext.betslipData.coupons[couponIndex];
			const finalErrorPurchaseCallback = (errorDesc) => {
				ctxs.betslipContext.setBetInProgress(false);
	    		if(ctxs.shopContext.enabled){
	    			ctxs.shopContext.setFree();
	    		}
				ctxs.bonusContext.enablePolling();
				ctxs.betslipContext.removeBetLoader();
				//ctxs.betslipContext.removeBetOptionsSection();
				ctxs.betslipContext.setCartError(errorDesc? errorDesc : getLabel('carrello.error.ticket_not_sold'));
				ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('carrello.error.ticket_not_sold'));
				ctxs.betslipContext.playVocalAssistantMessage(errorDesc ||  getLabel('carrello.error.ticket_not_sold'))

				if(ctxs.betslipContext.addAndBet){
		    		if(isMobile && typeof window.openBetslip === 'function'){
		    			// if mobile I open the betslip to show the error
		    			window.openBetslip();
		    		}
		    		setTimeout(() => {
		    			// remove all the previous bets
		    			ctxs.betslipContext.clearBetslip();
	        			if(isMobile && typeof window.hideBetslip === 'function'){
	        				window.hideBetslip();
	        			}
		    		}, ctxs.betslipContext.timeoutErrorAddAndBet);
		    	}
				// if the purchase has been request by querystring (notification push or oddschecker)
				// I disable the current operation, and I clean the querystring without a reload, in order
				// to allow the user to take its decision
				if(ctxs.landingRequestedOpsContext.enabled){
					ctxs.landingRequestedOpsContext.disable(true, false); 
				}
				ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
			}
			
			if(frontendTransactionId){
				saveFrontendTransactionId(frontendTransactionId, PURCHASE_RETRY);
				// retry flow: what it happened to my transaction?
				const oldXSportTerminal = window.landingTerminal; // temporary check. It will be dismissed
				if(ctxs.shopContext.enabled && !oldXSportTerminal){
					$('.xshop-body').removeClass('retailShadow');
					ctxs.shopContext.showMonitorMessage('[' + frontendTransactionId + '] ' + getLabel('general.wait_for_purchase'), true);
				}
				else {
					// online distro or terminal distro with xsport terminal
					ctxs.betslipContext.setRetryTransactionLoader(frontendTransactionId);
				}
				retryCheckPurchaseTicket(frontendTransactionId,shopUserData, sessionToken,
				(ticketData)=>{
					// success callback retry
					if(ctxs.shopContext.enabled){
    					ctxs.shopContext.removeMonitorMessage();
					}
					ctxs.betslipContext.setBetSuccess(ticketData.ticketId, () => {
						window.setLastTicketPurchasedOnLS((ctxs.betslipContext.isVirtual? 'PSV' : 'PSQF'), ticketData.ticketId, false, false, ticketData.amount, ticketData.additionalData?.win);
						const amount = ticketData.amount;
						const type = coupon.selectedContainer;
						const realPurchase = true;
						pushSuccessPurchaseNotification(amount, type, realPurchase, ticketData.ticketId, ctxs.shopContext.enabled);
						
						if(ctxs.shopContext.enabled){
							console.debug("call printTicket: "+ticketData?.ticketId);
							const onPrintDone = coupon?.selectedContainer === 'systembets' && ctxs.betslipContext.isPrintingSystembetsDetailEnabled() ? () => { ctxs.ticketPrinterContext?.promptPrintSystemBetDetailsTicket(ticketData.ticketId) } : null;
							ctxs.ticketPrinterContext.printTicket(ticketData.ticketId, false, ticketData.additionalData, onPrintDone);
	    				}
						ctxs.betslipContext.setBetInProgress(false);
	    	    		if(ctxs.shopContext.enabled){
	    	    			ctxs.shopContext.setFree();
	    	    			ctxs.shopContext.triggerReloadMainUser(amount);
	    	    		}
    					const emptyCart = !ctxs.betslipContext.betslipData.saveBetslip || ctxs.shopContext.enabled;
						if(emptyCart){
							ctxs.betslipContext.clearBetslip(couponIndex);	        								
						}
	    				

	    				ctxs.bonusContext.enablePolling();
	    				ctxs.betslipContext.removeBetLoader();
	    				//ctxs.betslipContext.removeBetOptionsSection();
						ctxs.betslipContext.loadBetOptionsIfEnabled();
						ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
					});
				},
				(errorDesc) => {
					// definitive error: ticket not purchased
					if(ctxs.shopContext.enabled){
    					ctxs.shopContext.removeMonitorMessage();
					}
					finalErrorPurchaseCallback(errorDesc);
				});
			}
			else{
				if(ctxs.shopContext.enabled){
					ctxs.shopContext.removeMonitorMessage();
				}
				finalErrorPurchaseCallback();
			}
		
	    },
	    
	    setBetInProgress : function(betInProgress){
			ctxs.betslipContext.updateFullContext({betInProgress});
			if(betInProgress){
				startBetslipTransaction();
				if(ctxs?.shopContext?.enabled && ctxs?.shopContext?.isHookAllKeystrokesOnPurchaseEnabled()) {
					if(window.XSocket){
						try {
							window.XSocket.hookAllKeystrokes();
						}catch(err) {
							console.error(err);
						}
					}
				}
			}
			else{
				endBetslipTransaction();
				if(ctxs?.shopContext?.enabled && ctxs?.shopContext?.isHookAllKeystrokesOnPurchaseEnabled()) {
					if(window.XSocket){
						try {
							window.XSocket.unhookAllKeystrokes();
						}catch(err) {
							console.error(err);
						}
					}
				}
			}
	    },
	    
	    setTransactionIdAcceptance : function(transactionId){
	    	if(transactionId == null){
	    		localStorage.removeItem(ctxs.betslipContext.localStorageAcceptanceKey);
	    	}
	    	else{
	    		localStorage.setItem(ctxs.betslipContext.localStorageAcceptanceKey, transactionId);	    		
	    	}
	    	ctxs.betslipContext.updateFullContext({transactionIdAcceptance : transactionId});
	    },
	    
	    setTransactionIdAcceptanceForProposal : function(transactionId){
    		ctxs.betslipContext.updateFullContext({transactionIdAcceptanceForProposal : transactionId});	
	    },
	    
	    checkPendingAcceptance : function(){
	    	return localStorage.getItem(ctxs.betslipContext.localStorageAcceptanceKey);
	    },
	    
	    
	    acceptance : function(transactionId){
	    	ctxs.betslipContext.setTransactionIdAcceptance(transactionId);
	    	ctxs.betslipContext.setBetInProgress(true);
    		if(ctxs.shopContext.enabled){
    			ctxs.shopContext.setBusy();
    		}
	    	const couponIndex = ctxs.betslipContext.betslipData.selectedCoupon;
	    	const coupon = ctxs.betslipContext.betslipData.coupons[couponIndex];
	    	const timerAcceptance = conf.tac;
	    	ctxs.bonusContext.disablePolling();
	    	const shopUserData = ctxs.shopContext.enabled? ctxs.shopContext.getShopUser() : null;
	    	
	    	function successCallback(response){
				// ticket purchased!
				ctxs.betslipContext.hideModalAdviseIfProvided();
				if(ctxs.betslipContext.provProfileEnabled){
					// switch to default
					ctxs.betslipContext.setProvSettings(props.doubleProfileDefaultChoice);
				}
				ctxs.betslipContext.setTransactionIdAcceptance(null);
				ctxs.betslipContext.setBetInProgress(false);
				ctxs.betslipContext.setBetSuccess(response.ticketSogei, () => {
					window.setLastTicketPurchasedOnLS((ctxs.betslipContext.isVirtual? 'PSV' : 'PSQF'), response.ticketSogei, false, false, response.amountBetted, response.amountWin);			
					const amount = response.amountBetted;
					const type = coupon.selectedContainer;
					const realPurchase = true;
					pushSuccessPurchaseNotification(amount, type, realPurchase, response.ticketSogei, ctxs.shopContext.enabled);
					if(coupon.selectedContainer === 'singlebets' && !ctxs.betslipContext.isBetBuilder()){
						
						if(ctxs.betslipContext.addAndBet){
							// clear betslip directly
		    				ctxs.betslipContext.removeBetLoader();
							// if mobile, I close the betslip
			        		if(ctxs.betslipContext.addAndBet && isMobile){
			        			if(typeof window.hideBetslip === 'function'){
			        				window.hideBetslip();
			        			}
			        		}
						
							if(ctxs.shopContext.enabled){
								ctxs.shopContext.triggerReloadMainUser(response.amountBetted);
							}
							else if(ctxs.pvrContext.pvrSectionEnabled){
								ctxs.pvrContext.reloadUser();
							}
							else{
								ctxs.userContext.reloadUser();
							}
							ctxs.betslipContext.setKeepContainer(false);
							ctxs.bonusContext.enablePolling();
	
							//ctxs.betslipContext.setBetInProgress(false);
							if(ctxs.shopContext.enabled){
								ctxs.shopContext.setFree();
							}
							ctxs.betslipContext.clearBetslip(couponIndex);
						}
						else{
							const purchaseNext = coupon.selections.length > 1 || (coupon.selections.length > 0 && coupon.selections[0].bets.length > 1);
							const lastOne = coupon.selections.length == 1 && coupon.selections[0].bets.length == 1;
							
							if(lastOne || ctxs.shopContext.enabled){
								// checking the autoprint function
								const autoPrint = ctxs.controlPanelContext.printerSettings.automaticPrint || ctxs.shopContext.enabled;;
								if(autoPrint && !ctxs.betslipContext.addAndBet){
									console.debug("call printTicket: "+response?.ticketSogei);
									ctxs.ticketPrinterContext.printTicket(response.ticketSogei, false, response.printData);
								}
							}
							//ctxs.betslipContext.setBetInProgress(false);
							if(ctxs.shopContext.enabled){
								ctxs.shopContext.setFree();
							}
							// remove the singlebet purchased if it is not the last one, or if it is the last one and
							// the user setted "Save betslip = false"
							const emptyCart = !ctxs.betslipContext.betslipData.saveBetslip || ctxs.shopContext.enabled;
							if(!lastOne || (emptyCart && lastOne)){
								ctxs.betslipContext.removeFirstSelection();		        								
							}
							
							if(purchaseNext){
								ctxs.betslipContext.purchase();
							}
							else {
	    						ctxs.betslipContext.removeBetLoader();
								if(ctxs.shopContext.enabled){
									ctxs.shopContext.triggerReloadMainUser(response.amountBetted);
								}
								else if(ctxs.pvrContext.pvrSectionEnabled){
									ctxs.pvrContext.reloadUser();
								}
								else{
									ctxs.userContext.reloadUser();
								}
								ctxs.betslipContext.setKeepContainer(false);
								ctxs.bonusContext.enablePolling();
								
								//ctxs.betslipContext.setBetInProgress(false);
								if(ctxs.shopContext.enabled){
									ctxs.shopContext.setFree();
								}
							}
							
						}
					}
					else{
	    				ctxs.betslipContext.removeBetLoader();
						if(ctxs.shopContext.enabled){
							ctxs.shopContext.triggerReloadMainUser(response.amountBetted);
						}
						else if(ctxs.pvrContext.pvrSectionEnabled){
							ctxs.pvrContext.reloadUser();
						}
						else{
							ctxs.userContext.reloadUser();
						}
						
						// checking the autoprint function
						const autoPrint = ctxs.controlPanelContext.printerSettings.automaticPrint || ctxs.shopContext.enabled;
						if(autoPrint){
							console.debug("call printTicket: "+response?.ticketSogei);
							const onPrintDone = coupon?.selectedContainer === 'systembets' && ctxs.betslipContext.isPrintingSystembetsDetailEnabled() ? () => { ctxs.ticketPrinterContext?.promptPrintSystemBetDetailsTicket(response.ticketSogei) } : null;
							ctxs.ticketPrinterContext.printTicket(response.ticketSogei, false, response.printData, onPrintDone);
						}
						
						ctxs.bonusContext.enablePolling();
						
						//ctxs.betslipContext.setBetInProgress(false);
						if(ctxs.shopContext.enabled){
							ctxs.shopContext.setFree();
						}
						if(!ctxs.betslipContext.betslipData.saveBetslip || ctxs.shopContext.enabled) {
							ctxs.betslipContext.clearBetslip(couponIndex);										
						}
						else{
							ctxs.betslipContext.setPlayButtonState('again');
						}
					} 
				});
	    	}
	    	
	    	function errorCallback(response){
				// error
				ctxs.betslipContext.setBetInProgress(false);
	    		if(ctxs.shopContext.enabled){
	    			ctxs.shopContext.setFree();
	    		}
				ctxs.bonusContext.enablePolling();
				ctxs.betslipContext.setTransactionIdAcceptance(null);
				ctxs.betslipContext.removeBetLoader();
				ctxs.betslipContext.setCartError(response.returnCode.description, response.returnCode.code);
				ctxs.betslipContext.showModalAdviseIfProvided('error', response.returnCode.description, response.returnCode.code);
				if(ctxs.betslipContext.addAndBet){
		    		setTimeout(() => {
		    			// remove all the previous bets
		    			ctxs.betslipContext.clearBetslip();
	        			if(isMobile && typeof window.hideBetslip === 'function'){
	        				window.hideBetslip();
	        			}
		    		}, ctxs.betslipContext.timeoutErrorAddAndBet);
		    	}	    	 	
	    	}
	    	// apro la betslip del desktop a prescindere, per mostrare l'animazione di successo eventuale (se aggiorniamo la pagina in accettazione e c'e' il carrello togglable, riatterriamo chiusi)
	    	if(window.showDesktopBetslip){
	    		window.showDesktopBetslip();
	    	}
	    	ctxs.betslipContext.showModalAdviseIfProvided('acceptance', getLabel('carrello.approval_pending'));
    		ctxs.betslipContext.setBetLoader(false, true, timerAcceptance, () => {
    			checkAcceptance(ctxs.betslipContext.transactionIdAcceptance, shopUserData, ctxs.betslipContext.user.sessionToken, xs_getVipSystemData(false), ctxs.betslipContext.getSelectedBetslipPromos(), (response) => {
	    			if(response != null){
	    				const code = response.returnCode.code;
	    				if(code == -9999){
	    					// still in acceptance
	    					ctxs.betslipContext.acceptance(ctxs.betslipContext.transactionIdAcceptance);
	    					//ctxs.betslipContext.removeBetLoader();
	    				}
	    				else if(code == 0 || code == 1024){
							successCallback(response);
	    				}
	    				else if(code == -5346){
	    					// trader sent a new amount proposal for this ticket
	    					ctxs.betslipContext.hideModalAdviseIfProvided();
	    					ctxs.betslipContext.setBetInProgress(false);
		    	    		if(ctxs.shopContext.enabled){
		    	    			ctxs.shopContext.setFree();
		    	    		}	    					
	    					ctxs.betslipContext.setTraderAcceptanceProposal(response);
	    				}
	    				else if(code == -9998){
							const frontendTransactionIdContainer = getPendingFrontendTransactionId();
							removeFrontendTransactionId();
							if(frontendTransactionIdContainer && frontendTransactionIdContainer.type === PURCHASE_RETRY){
								const sessionToken = ctxs.betslipContext.user.sessionToken;
		    					retryCheckPurchaseTicket(frontendTransactionIdContainer.frontendTransactionId, 
		    										shopUserData, 
		    										sessionToken,
		    										successCallback,
		    										errorCallback);
		    												
							}
							else {
								errorCallback(response);
							}	 

	    				
	    				}
	    				else{
							errorCallback(response);
	    				}
	    			}
    			}
				,(response) => {
					console.log(response);
					// still in acceptance
					setTimeout(() => {
						ctxs.betslipContext.acceptance(ctxs.betslipContext.transactionIdAcceptance);
					}, 500);
					//ctxs.betslipContext.removeBetLoader();
				});
    		});
    		
	    	
	    },
	    removeOutdatedSelections : function(){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	let selectionsNew = [];
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		if(selection.closed == false || selection.closed == null){
	    			let betsNew = [];
	    			for(let km in selection.bets){
	    				const bet = selection.bets[km];
	    				if(bet.isBetBuilderMarket){
	    					const subMarketsNew = [];
	    					for(let ksm in bet.subMarketsSet){
	    						const subMarket = bet.subMarketsSet[ksm];
	    						if(subMarket.closed == false || subMarket.closed == null){
		    						subMarketsNew.push(subMarket);
		    					}
	    					}
	    					if(subMarketsNew.length > 0){
	    						bet.subMarketsSet = subMarketsNew;
	    						betsNew.push(bet);
	    					}
	    				}
	    				else {
		    				if(bet.closed == false || bet.closed == null){
		    					betsNew.push(bet);
		    				}
	    				}
	    			}
	    			selection.bets = betsNew;
	    			if(selection.bets.length > 0){
	    				selectionsNew.push(selection);	    				
	    			}
	    		}
	    	}
	    	coupon.selections = selectionsNew;
    		if(coupon.selections.length === 0){
    			ctxs.betslipContext.setCartError(getLabel('carrello.error.no_selections'));
    			setTimeout(()=>{
    				ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);    
    			}, 1000);
    		}
    		else{
    			ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);    			
    		}
	    },
	    checkAndUpdateSelectionsState : function (){
	    	let result = false;
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	const dateNow = new Date();
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		const dateEvent = getDateFromTimestamp(selection.timestamp);
	    		const compared = compare2Dates(dateEvent, dateNow);
	    		if(compared !== 1){
	    			selection.closed = true;
	    			result = true;
	    		}	
	    	}
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    	return result;
	    },
	    updateSelectionsState : function(betResponse){
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	const eventsLookup = {};
	    	
	    	if(coupon.selectedContainer === 'multibets' || coupon.selectedContainer === 'singlebets'){
		    	for(let k in betResponse.betCoupons){
		    		const bc = betResponse.betCoupons[k];
		    		const key = bc.codPal + "_" + bc.codEvent + "_" + bc.codBet + "_"  + bc.handicap + "_" + bc.codDraw;
		    		eventsLookup[key] = bc;
		    	}
	    	}
	    	else if(coupon.selectedContainer === 'systembets'){
		    	for(let k in betResponse.systemEvent){
		    		const se = betResponse.systemEvent[k];
		    		const pal = se.codPal;
		    		const avv = se.codEvent;
		    		for(let kb in se.systemBet){
		    			const sb = se.systemBet[kb];
		    			const codBet = sb.codBet;
		    			const handicap = sb.handicap;
		    			for(let kd in sb.systemDraw){
		    				const draw = sb.systemDraw[kd];
		    				const codDraw = draw.codDraw;
		    				const key = pal + "_" + avv + "_" + codBet + "_"  + handicap + "_" + codDraw;
		    				eventsLookup[key] = { statusEvent : se.statusEvent, statusBet : sb.statusBet };
		    			}
		    		}
		    	}
	    	}
	    	
	    	function updateBets(selection, bets){
	    		for(let km in bets){
	    			const bet = bets[km];
	    			if(bet.isBetBuilderMarket){
	    				//richiamo la funzione di aggiornamento con il vettore dei mercati che compongono questa scommessa
	    				updateBets(selection, bet.subMarketsSet);	
	    			}
	    			else {
		    			let keyLK = selection.pal + "_" + selection.avv + "_" + bet.scomSogei + "_"  + bet.handicap + "_" + bet.draw;
		    			let varData = eventsLookup[keyLK];
		    			if(varData == null && bet.handicap > 0){
		    				// the "main" parametric market could be closed. I check the variation for the main one (handicap = 0)
		    				keyLK = selection.pal + "_" + selection.avv + "_" + bet.scomSogei + "_"  + 0 + "_" + bet.draw;
		    				varData = eventsLookup[keyLK];
		    			}
		    			if(varData != null){		 
		    				// event is closed!
		    				selection.closed = varData.statusEvent != 2;
		    				bet.closed = varData.statusBet != 2 || varData.odd <= 100;
		    				bet.updated = null;
		    			}	    				
	    			}
	    		}    	
	    	}
	    	
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		updateBets(selection, selection.bets);
	    	}
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    },
	    
	    updateOdds : function (betResponse){
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const eventsLookup = {};
	    	let result = -1; // this means: something has been updated, you can bet again
	    	if(coupon.selectedContainer === 'multibets' || coupon.selectedContainer === 'singlebets' || ctxs.betslipContext.isBetBuilder()){
		    	if(betResponse.betCoupons){
		    		for(let k in betResponse.betCoupons){
		    			const bc = betResponse.betCoupons[k];
		    			const key = bc.codPal + "_" + bc.codEvent + "_" + bc.codBet + "_"  + bc.handicap + "_" + bc.codDraw;
		    			eventsLookup[key] = bc;
		    		}
		    	}

	    	}
	    	else if(coupon.selectedContainer === 'systembets'){
		    	for(let k in betResponse.systemEvent){
		    		const se = betResponse.systemEvent[k];
		    		const pal = se.codPal;
		    		const avv = se.codEvent;
		    		for(let kb in se.systemBet){
		    			const sb = se.systemBet[kb];
		    			const codBet = sb.codBet;
		    			const handicap = sb.handicap;
		    			for(let kd in sb.systemDraw){
		    				const draw = sb.systemDraw[kd];
		    				const codDraw = draw.codDraw;
		    				const odd = draw.odd;
		    				const key = pal + "_" + avv + "_" + codBet + "_"  + handicap + "_" + codDraw;
		    				eventsLookup[key] = { 
		    					odd : odd,
		    					statusBet : sb.statusBet
		    				};
		    			}
		    		}
		    	}
	    	}
	    	

	    	function handleBetVariations(selection, bet){
    		    let keyLK = selection.pal + "_" +selection.avv + "_" + bet.scomSogei + "_"  + bet.handicap + "_" + bet.draw;
    			let varData = eventsLookup[keyLK];
    			if(varData == null && bet.handicap > 0){
    				// the "main" parametric market could be closed. I check the variation for the main one (handicap = 0)
    				keyLK = selection.pal + "_" +selection.avv + "_" + bet.scomSogei + "_"  + 0 + "_" + bet.draw;
    				varData = eventsLookup[keyLK];
    			}
    			if(varData != null){	
    				if(varData.odd != bet.odd){
    					if(varData.statusBet != 2 || varData.odd <= 100){
    						bet.closed = true;
    					}
    					else{
    						bet.closed = false;
    						bet.updated = varData.odd > bet.odd? 'increased':'decreased';
    						bet.oldOdd = bet.odd;
    						bet.odd = varData.odd;
    						result = 0;
    					}
    				}
    			}
	    	}
	    	
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		for(let km in selection.bets){
	    			const bet = selection.bets[km];
	    			if(bet.subMarketsSet){
	    				for(let kms in bet.subMarketsSet){
	    					const subMarket = bet.subMarketsSet[kms];
	    					handleBetVariations(selection, subMarket);
	    					subMarket.nonReducedOdd = subMarket.odd; // il backend mi risponde con le quote ORIGINALI aggiornate
	    				}
	    				// aggiornate tutte le sottoquote, ricalcolo la quota totale e le eventuali sottoquote ridotte
	    				calculateAndStoreBetBuilderOdds(selection, bet, ctxs.userContext.getUser().accountNum);   	
	    			}
	    			else{
	    				handleBetVariations(selection, bet);
	    			}
	    		}
	    	}
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    	return result;
	    },
	    
	    oddsAreIncreased : function(){
	    	let allIncr = true;
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		for(let km in selection.bets){
	    			const bet = selection.bets[km];
	    			if(bet.isBetBuilderMarket){
	    				for(let ksm in bet.subMarketsSet){
	    					const subMarket = bet.subMarketsSet[ksm];
	    					allIncr = allIncr && subMarket.updated === 'increased' && !subMarket.closed;
	    				}
	    			}
	    			else{
	    				if(bet.updated != undefined ){
	    					allIncr = allIncr && bet.updated === 'increased' && !bet.closed;
	    				}
	    			}

	    		}
	    	}
	    	return allIncr;
	    },
	    removeUpdatedInfo : function(removeAlsoClosedState){
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	for(let k in coupon.selections){
	    		const selection = coupon.selections[k];
	    		if(removeAlsoClosedState){
		    		selection.closed = null;	    		
	    		}
	    		for(let km in selection.bets){
	    			const bet = selection.bets[km];
	    			bet.updated = null;
	    			if(removeAlsoClosedState){
		    			bet.closed = null;
	    			}
	    		}
	    	}
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    },
	    
	    
	    getPlayButtonState : function(){
	    	return ctxs.betslipContext.buttonPlayState;
	    },
	    
	    
	    setLoaderData : function(loaderData){
	    	ctxs.betslipContext.updateFullContext({loaderData});
	    },
	    getLoaderData : function(){
	    	return ctxs.betslipContext.loaderData;
	    },
	    setCartError : function(message, errorCode){
    		// all the component has to be re-rerended
	    	if(errorCode != null){
	    		message = message + "  (" + errorCode +")"
	    	}
    		ctxs.betslipContext.updateFullContext({buttonPlayState : "play", cartMessage : {type : 'error', message :message}}); 
    		
	    },
	    
	    setCartWarning : function(message){
    		ctxs.betslipContext.updateFullContext({buttonPlayState : "play", cartMessage : {type : 'confirm', message :message}}); 
	    },
	    setCartSuccess : function(message){
    		ctxs.betslipContext.updateFullContext({buttonPlayState : "play", cartMessage : {type : 'success', message :message}, keepWageringError : false}); 
	    },
	    removeCartMessage : function(){
    		ctxs.betslipContext.updateFullContext({buttonPlayState : "play", cartMessage : null, keepWageringError : false});
	    },
	    
	    getCartMessage : function (){
	    	return ctxs.betslipContext.cartMessage;
	    },
	    
	    showModalAdviseIfProvided : function(type, message, errorCode){
	    	if(window.showModalPurchaseMessage && messageOnModalsEnabled){
	    		if(type === 'error' && errorCode){
	    			message = message + "  (" + errorCode +")"
	    		}
	    		window.showModalPurchaseMessage(message, type);
	    	}
	    },
	    hideModalAdviseIfProvided : function(){
	    	if(window.hideModalPurchaseMessage && messageOnModalsEnabled){
	    		window.hideModalPurchaseMessage();
	    	}
	    },
		showLivePurchaseProgressBarIfProvided : function(percentRange,message){
	    	if(window.showLivePurchaseProgressBar && conf.lppb){
	    		window.showLivePurchaseProgressBar(percentRange, message);
	    	}
	    },
	    hideLivePurchaseProgressBarIfProvided : function(){
	    	if(window.hideLivePurchaseProgressBar && conf.lppb){
	    		window.hideLivePurchaseProgressBar();
	    	}
	    },
	    clearLivePollingTimeoutId : function(){
	    	if(ctxs.betslipContext.livePollingTimeoutId){
	    		window.clearTimeout(ctxs.betslipContext.livePollingTimeoutId);
	    		ctxs.betslipContext.updateFullContext({livePollingTimeoutId : null});		
	    	}	    
	    },
	    setBetLoader : function (isLiveBetting, isAcceptance, timer, functionToExecute){
	    	ctxs.betslipContext.clearLivePollingTimeoutId()
	    	const isPrematch = !isLiveBetting && !isAcceptance;
	    	if(isPrematch){
	    		ctxs.betslipContext.setLoaderData({type:'prematch'});
	    		
	    		if(typeof functionToExecute === 'function'){
	    			functionToExecute();
	    		}
	    		else{
	    			ctxs.betslipContext.removeBetLoader();
	    		}
	    	}
	    	else {
	    		const type = isLiveBetting? 'live': 'acceptance';
	    		ctxs.betslipContext.setLoaderData({type:type, remainingSeconds : timer/1000 });
	    		if(isLiveBetting){
			 		ctxs.betslipContext.showLivePurchaseProgressBarIfProvided(timer+3500, getLabel('carrello.bet_in_progress'));
				}
	    		const livePollingTimeoutId = setTimeout(() =>{
		    		if(typeof functionToExecute === 'function'){
		    			if(isLiveBetting){
	    					ctxs.betslipContext.setLoaderData({type:'live_end_timer'}); // advise for the customer: bet in progress
	    				}
		    			functionToExecute();
		     		}
		  			else{
		    			ctxs.betslipContext.removeBetLoader();
		     		}	
	    		}, timer);    	
	    		ctxs.betslipContext.updateFullContext({livePollingTimeoutId});		
	    	}
	    },
	    
	    setBetSuccess : function (idTicket, callback){
			console.debug("setBetSuccess "+idTicket);
			let callbackForExitButton = null;
			if(TICKET_PURCHASED_CUSTOM_POPUP){
				callbackForExitButton = callback;
				ctxs.betslipContext.hideLivePurchaseProgressBarIfProvided(); // anyway
				removeBodyShadow();
			}
			else{
				if (callback) {
	                const millis = ctxs.shopContext?.enabled? 50 : 2500;
					setTimeout(() => {
		                console.debug("BetslipConf setTimeout at "+getFormattedFullTimestamp());
						callback();
					}, millis);
				}
			}
	    	ctxs.betslipContext.setLoaderData({type:'success', idTicket : idTicket, callbackForExitButton});
	    },
	    
	    setRetryTransactionLoader : function (frontendTransactionId, callback){
	    	ctxs.betslipContext.setLoaderData({type:'retry-status-transaction', frontendTransactionId, successCallback : callback});
	    },
	    
	    removeBetLoader : function(){
	    	ctxs.betslipContext.setLoaderData({type:'hideAll'});
			ctxs.betslipContext.hideLivePurchaseProgressBarIfProvided();
	    },  
	    reserveTicket : function(successCallback){
	    	ctxs.betslipContext.removeCartMessage();
	    	ctxs.betslipContext.loadVipSystemDataOnCoupon();
	    	// saving the current coupon
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(coupon.selections.length == 0){
    			ctxs.betslipContext.setCartError(getLabel('carrello.error.no_selections'));
    			ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('carrello.error.no_selections'));

    			return;
    		}
	    	const duplicatedCoupon = JSON.parse(JSON.stringify(coupon));
	    	duplicatedCoupon.playabilityIssue = false;
	    	/*
	    	for(let ks in duplicatedCoupon.selections){
	    		for(let km in duplicatedCoupon.selections[ks].bets){
	    			const bet = duplicatedCoupon.selections[ks].bets[km];
    				// reset the errors
	    			bet.minPlError = false;
	    			bet.maxPlError = false;
	    			bet.minOddError = null;
	    			bet.minPl = null;
	    			bet.maxPl = null;
	    		}
	    	}*/
	    	reserveTicket(duplicatedCoupon, ctxs.betslipContext.user.sessionToken, null, (data) =>{
	    		if(data != null){
	    			if(data.code == 0){
	    				const reservationCode = data.description;	    				
	    				ctxs.betslipContext.addReservation(reservationCode, data.object?.dateIn, data.object?.expirationDays);
	    				let message = getLabel('carrello.reservation_success') + data.description;
	    				if (conf.cbab || window.appConfig.SHOP_BOOKER) {
	    					ctxs.betslipContext.clearBetslip();
	    				}
	    				ctxs.betslipContext.setCartSuccess(message);
	    				ctxs.betslipContext.showReservationBox();
	    				if(successCallback){
	    					successCallback(reservationCode);
	    				}
	    			}
	    		}
	    	});
    	

	    },
	    addReservation : function(reservationCode, dateIn, expirationDays){
	    	const dateReservation = dateIn? getDateFromTimestamp(dateIn) : new Date();
	    	const reservationObj = {
	    		code : 	reservationCode,
	    		timestamp : dateReservation.getTime(),
	    		expirationDays : expirationDays? expirationDays : conf.rps.edr
	    	};
	    	const reservations = ctxs.betslipContext.reservations;
	    	reservations.push(reservationObj);
	    	ctxs.betslipContext.saveReservationList(reservations);

	    },
	    saveReservationList : function(reservations){
	    	reservations.sort((resA, resB) =>{
	    		if(resA.timestamp > resB.timestamp) return -1;
	    		if(resA.timestamp < resB.timestamp) return 1;
	    		return 0;
	    	});
	    	ctxs.betslipContext.saveReservationsLocalStorage(reservations);
	    	ctxs.betslipContext.updateFullContext({reservations});
	    	
	    },
	    
	    saveReservationsLocalStorage : function(reservations){
	    	localStorage.setItem('XSP_RESERVATIONS', JSON.stringify(reservations));
	    },
	    
	    loadReservationsLocalStorage : function(){
	    	let reservationStorage = localStorage.getItem('XSP_RESERVATIONS');
	    	if(reservationStorage == null){
	    		ctxs.betslipContext.saveReservationsLocalStorage([]);
	    		ctxs.betslipContext.loadReservationsLocalStorage();
	    	}
	    	else{
	    		let storedReservations = JSON.parse(reservationStorage);
	    		const reservationMap = {};
	    		for(let k in storedReservations){
	    			const reservation = storedReservations[k];
	    			if(!reservation.expirationDays){
	    				reservation.expirationDays = conf.rps.edr;
	    			}
	    			reservationMap[reservation.code] = reservation;
	    		}
	    		// merging with the logged user one
	    		if(!ctxs.shopContext.enabled && ctxs.betslipContext.user?.reservations){
	    			for(let k in ctxs.betslipContext.user.reservations){
	    				const userReservation = ctxs.betslipContext.user.reservations[k];
	    				reservationMap[userReservation.reservationCode] = {
	    					code: userReservation.reservationCode,
	    					timestamp : getDateFromTimestamp(userReservation.dateIn).getTime(),
	    					expirationDays : userReservation.expirationDays,
	    					storedInAccountHistory :true
	    				}
	    			}
	    		}
	    		
	    		let reservations = [];
	    		const nowTime = new Date();
	    		// popping out the outdated reservations
	    		for(let k in reservationMap){
	    			const res = reservationMap[k];
	    			let reservationDate = new Date();
	    			reservationDate.setTime(res.timestamp);
	    			const checker = nowTime - reservationDate;
	    			if(checker > (res.expirationDays * 86400000)){
	    				// expirationDays * milliseconds in a day. Reservation expired!
	    			}
	    			else{
	    				reservations.push(res);
	    			}
	    		}
	    		ctxs.betslipContext.saveReservationList(reservations);
	    	}
	    },
	    removeReservation : function (code){
	    	if(ctxs.betslipContext.reservations != null){
	    		const newReservations = [];
	    		let reservationDeleted = null;
	    		for(let k in ctxs.betslipContext.reservations){
	    			if(ctxs.betslipContext.reservations[k].code != code){
	    				newReservations.push(ctxs.betslipContext.reservations[k]);
	    			}
	    			else {
	    				reservationDeleted = ctxs.betslipContext.reservations[k];
	    			}
	    		}
	    		ctxs.betslipContext.saveReservationList(newReservations);
	    		if(reservationDeleted){
	    			if((reservationDeleted.storedInAccountHistory && ctxs.betslipContext.user?.logged)){
		    			deleteReservation(reservationDeleted.code, ctxs.betslipContext.user?.sessionToken, reservationDeleted.storedInAccountHistory);	    			
	    			}
	    			if(newReservations.length === 0 && window.disassociateVipSystemUser && xs_getVipSystemData(false)){
	    				window.disassociateVipSystemUser();
	    			}
	    		}
	    	}
	    },
	    reloadReservedTicket : function(reservationCode, reservationData){
	    	
	    	function putInBetslip(data){
				try{
    				const settedOddVariation = ctxs.betslipContext.getCurrentCoupon().oddVariation;
    				const coupon = JSON.parse(data.object);
    				coupon.oddVariation = settedOddVariation;
					
    				const selections = coupon.selections;
    				const filteredSelections = [];
					let avoidLiveSelection = false;
			    	let avoidPrematchSelection = false;
			    	let totalDraws = 0;
			    	let amountMulti = coupon.amountMulti;
			    	let someClosedSelection = false;
			    	if(ctxs.shopContext.enabled){
			    		if(ctxs.shopContext.type === 'SELF-CASHIER'){
			    		const cashier = ctxs.shopContext.getShopUser();
				    		if(cashier && cashier.logged){
	    			    		avoidLiveSelection = !cashier.liveEnabled;
	    			    		avoidPrematchSelection = !cashier.prematchEnabled;
				    		}
				    		if(coupon.vipSystemData){
				    			xs_setVipSystemData(coupon.vipSystemData);
				    		}
			    		}
			    		else if(ctxs.shopContext.type === 'TERMINAL'){
			    			if(coupon.vipSystemData){
				    			xs_setVipSystemData(coupon.vipSystemData);
				    		}
			    		}
			    	}
			    	// riassegno gli id poichè l'algoritmo precedente non garantiva lo stesso ordine delle selezioni (che assegna in base alla posizione l'id bb0, bbn)
			    	if(coupon.betBuilderSelections){
			    		assignBetBuilderMarketIds(coupon.betBuilderSelections, selections);
			    	}
			    	for(let k in selections){
			    		let added = false;
			    		if(selections[k].isLive){
				    		if(!avoidLiveSelection){
				    			filteredSelections.push(selections[k]);
				    			added = true;
				    			for (let i = 0; i < selections[k].bets.length; i++) {
				    				totalDraws ++;			    			
					    		}
				    		}
			    		}
			    		else{
				    		if(!avoidPrematchSelection){
				    			filteredSelections.push(selections[k]);
				    			added = true;
				    			for (let i = 0; i < selections[k].bets.length; i++) {
				    				totalDraws ++;			    			
					    		}
				    		}
			    		}
			    		if(added){
			    			someClosedSelection = someClosedSelection || selections[k].closed;
			    		}
			    	}
			    	coupon.selections = filteredSelections;
			    	coupon.amountMulti = amountMulti;
			    	coupon.totalDraws = totalDraws;
			    	coupon.printableAmountMulti = getPrintableAmount(amountMulti, conf.cs.m, conf.cs.nd);


					ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon] = coupon;
                    ctxs.betslipContext.showReservationDetail = false;
                    ctxs.betslipContext.reservationDetailCode = null;
					ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
					ctxs.betslipContext.loadBetOptionsIfEnabled();
					if(someClosedSelection){
    					ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
    					const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled;
						if(showVariationModal){
							const selections = ctxs.betslipContext.getCurrentCoupon().selections;
							window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
						}	    					
					}
					}
					catch(e){
						console.log(e);
						ctxs.betslipContext.setCartError('Prenotazione non valida');
					}
	    	}
	    	
	    	if (reservationData) {
	    		putInBetslip(reservationData);
	    	} else {
		    	reloadReservedTicket(reservationCode, (data) => {
		    		if (data?.code == 0) {
						putInBetslip(data);		    		
						ctxs.betslipContext.hideReservationBox();	 
		    		} else {
						if (isBetsson()) {
							window.dispatchEvent(new CustomEvent('xs_reservedTickedError', {detail: {data}}));
						} else {
							ctxs.betslipContext.setCartError(data.description, data.code);
							ctxs.betslipContext.showModalAdviseIfProvided('error', data.description, data.code);
							ctxs.betslipContext.hideReservationBox();	 
						}
	    			}
		    	});	    	
	    	}
	    },
	    openReservationDetail(reservationCode) {
            ctxs.betslipContext.showReservationDetail = true;
            ctxs.betslipContext.reservationDetailCode = reservationCode;
            ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
        },
        toggleReservationDetail() {
            setBetslipContext((prev) => {
                return {
                    ...prev,
                    showReservationDetail: !prev.showReservationBox,
                };
            });
        },
	    getReservations : function(){
	    	return ctxs.betslipContext.reservations;
	    },
        clearReservations: function() {
        	const oldList = ctxs.betslipContext.reservations;
        	ctxs.betslipContext.saveReservationList([]);
        	if(window.disassociateVipSystemUser && xs_getVipSystemData(false)){
        		window.disassociateVipSystemUser();
        	}
        	deleteReservationBatch(ctxs.betslipContext.user?.sessionToken, oldList);	
        },
	    toggleReservationBox : function(){
	    	const newValue = !ctxs.betslipContext.showedReservationBox;
	    	if(newValue){
	    		ctxs.betslipContext.showReservationBox();
	    	}
	    	else{
	    		ctxs.betslipContext.hideReservationBox();
	    	}
	    },
	    showReservationBox : function(){
	    	ctxs.betslipContext.showedReservationBox = true;
    		setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			showedReservationBox : true
	    		}
	    	});
	    },
	    
	    hideReservationBox : function(){
    		ctxs.betslipContext.showedReservationBox = false;
	    	setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			showedReservationBox : false
	    		}
	    	});
	    },
	    
	    isReservationBoxShown : function(){
	    	return ctxs.betslipContext.showedReservationBox;
	    },
	    
	    restoreReservationBoxStatus : function(){
			const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
			const hideBox = coupon.selections.length === 0;
			if(hideBox){
				ctxs.betslipContext.showReservationBox();
			}
			else{
				ctxs.betslipContext.hideReservationBox();
			}
	    },
	    
	    betOptionsSectionMustBeShown : function(){
	    	return ctxs.betslipContext.betOptionsSectionHasToBeShowed;
	    },
	    getBetOptionsData : function(){
	    	return ctxs.betslipContext.betOptionsData;
	    },
	    
	    isWageringPromoSelectable : function(promo){
	    	const selectionsWrong = {
	    		'maxDateIssue' : [],
	    		'liveIssue' : [],
	    		'prematchIssue' : [],
	    		'twoWayMarketIssue' : [],
	    		'minOddIssue' : [],
	    		'marketsExcludedIssue' : []
	    	};
	    	
	    	let maxDateOk = true;
	    	let liveOk = true;
	    	let prematchOk = true;
	    	let minOdd = 0;
			let twoWayMarketOk = true;
			let marketsOk = true;
			const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	const selections = coupon.selections;
	    	const isSinglebet = coupon.selectedContainer === 'singlebets';
			for(let ks in selections){
				const selection = selections[ks];
				if(promo.data_fine_raccolta){
					const datePromo = getDateFromTimestamp(promo.data_fine_raccolta);
					const dateSelection = getDateFromTimestamp(selection.timestamp);
					const compared = compare2Dates(datePromo, dateSelection);
					const selectionIsOk = compared === 1;
					maxDateOk = maxDateOk && compared === 1;
					if(!selectionIsOk){
						selectionsWrong['maxDateIssue'].push(selection);
					}
				}

				if(selection.isLive){
					if(!promo.json_raccolta.sport.live){
						liveOk = false;
						selectionsWrong['liveIssue'].push(selection);
					}
				}
				else {
					if(!promo.json_raccolta.sport.prematch){
						prematchOk = false;
						selectionsWrong['prematchIssue'].push(selection);
					}
				}
				const bets = selection.bets;
				const minOddSelection = parseInt(bets.length > 0? bets[0].odd : 0);
				if(minOdd == 0){
					minOdd = minOddSelection;
				}
				else {
					if(minOddSelection < minOdd){
						minOdd = minOddSelection;
					}
				}
				if(minOddSelection < parseInt(promo.json_raccolta.sport.min_odd)){
					selectionsWrong['minOddIssue'].push(selection);
				}
				if(!promo.json_raccolta.sport.two_way_market){
					const bet = bets[0];
					if(bet){
						const scomSogei = bet.scomSogei;
						const handicap = bet.handicap;
						const aggMarketContainer = getAggregationAndBetFromBetIdAndSportId(selection.sportId, scomSogei, handicap);
						if(aggMarketContainer?.market){
							if(aggMarketContainer.market.nativeOddsLength === 2){
								twoWayMarketOk = false;
								selectionsWrong['twoWayMarketIssue'].push({selection, market : aggMarketContainer.market });
							}
						}	
					}
				}
				if(promo.json_raccolta.sport.markets_excluded){
					const bet = bets[0];
					if(bet){
						const scomSogei = bet.scomSogei;
						const handicap = bet.handicap;
						for(let km in promo.json_raccolta.sport.markets_excluded){
							if(promo.json_raccolta.sport.markets_excluded[km].scommessa == scomSogei){
								marketsOk = false;
								const aggMarketContainer = getAggregationAndBetFromBetIdAndSportId(selection.sportId, scomSogei, handicap);
								if(aggMarketContainer?.market){
									selectionsWrong['marketsExcludedIssue'].push({selection, market : aggMarketContainer?.market });
								}
							}
						}
					}
				
				}
				if(isSinglebet){
					break;
				}
			}
	    	const minOddOk = minOdd >= parseInt(promo.json_raccolta.sport.min_odd);
	    	const totalOddBetslip = isSinglebet? parseInt(selections[0].bets[0].odd) : parseInt((coupon.totalOdd + "").replaceAll(".", "").replaceAll(",", ""));
	    	const minTotalOk = totalOddBetslip >= parseInt(promo.json_raccolta.sport.tot_odd);
	    	let numSelections = 0;
	    	for(let ks in selections){
	    		const selection = selections[ks];
	    	
	    		const playableInMulti = playableInMultiple(selection.bets);
	    		for(let kb in selection.bets){
	    			if(kb == 0 || playableInMulti){
	    				numSelections ++;
	    			}
	    		}
	    	}
	    	let minEvsOk = true;
	    	if(promo.json_raccolta.sport.min_eve != undefined){
	    		minEvsOk = numSelections >= promo.json_raccolta.sport.min_eve;
	    	}
	    	let maxEvsOk = true;
	    	if(promo.json_raccolta.sport.max_eve != undefined && promo.json_raccolta.sport.max_eve > 0){
	    		maxEvsOk = numSelections <= promo.json_raccolta.sport.max_eve;
	    	}
	    	const selectable = maxDateOk && liveOk && prematchOk && minEvsOk && maxEvsOk && minOddOk && minTotalOk && twoWayMarketOk && marketsOk;
	    	let failureLabel = '';
	    	if(!selectable){
	    		failureLabel = getLabel('wagering.promo_not_selectable');
	    		const space = ' ';
	    		failureLabel += space;
	    		if(!maxDateOk){
	    			failureLabel += space;
	    			const maxDateLabel = getLabel('wagering.max_date_error');
	    			failureLabel += maxDateLabel.replaceAll('{{DATE}}', formatDate(promo.data_fine_raccolta).formatted);
	    			failureLabel += space;
	    			let removeSelectionsLabel = getLabel('wagering.remove_selections') || 'Rimuovere quindi: {{SELECTIONS}}.'
	    			let selectionsDesc = '';
	    			for(let ks = 0; ks < selectionsWrong['maxDateIssue'].length; ks ++ ){
	    				const desc = selectionsWrong['maxDateIssue'][ks].descEvent;
	    				selectionsDesc += desc;
	    				if(ks + 1 < selectionsWrong['maxDateIssue'].length){
	    					selectionsDesc += ("," + space);
	    				}
	    			}
	    			removeSelectionsLabel = removeSelectionsLabel.replaceAll('{{SELECTIONS}}', selectionsDesc);
	    			failureLabel += removeSelectionsLabel;	
	    			failureLabel += space;
	    		}
	    		if(!liveOk){
	    			failureLabel += getLabel('wagering.live_not_permitted');
	    			failureLabel += space;
	    		}
	    		if(!prematchOk){
	    			failureLabel += getLabel('wagering.prematch_not_permitted');
	    			failureLabel += space;
	    		}
	    		if(!minEvsOk){
	    			const fewDrawsLabel = getLabel('wagering.few_draws');
	    			failureLabel += fewDrawsLabel.replaceAll('{{NUM}}', promo.json_raccolta.sport.min_eve);
	    			failureLabel += space;
	    		}
	    		if(!maxEvsOk){
	    			const fewDrawsLabel = getLabel('wagering.too_much_draws');
	    			failureLabel += fewDrawsLabel.replaceAll('{{NUM}}', promo.json_raccolta.sport.max_eve);
	    			failureLabel += space;	    		
	    		}
	    		if(!minOddOk){
	    			let printableMinOdd = promo.json_raccolta.sport.min_odd / 100.0;
			    	printableMinOdd = printableMinOdd * 1.000000000000001;
			    	const minOddLabel = getLabel('wagering.min_odd_draw');
	    			failureLabel += minOddLabel.replaceAll('{{ODD}}', truncateDoubleTo(printableMinOdd, 2));
	    			failureLabel += space;
	    		}
	    		if(!minTotalOk){
	    			let printableMinOdd = promo.json_raccolta.sport.tot_odd / 100.0;
			    	printableMinOdd = printableMinOdd * 1.000000000000001;
			    	const totOddLabel = getLabel('wagering.min_odd_total');
	    			failureLabel += totOddLabel.replaceAll('{{ODD}}', truncateDoubleTo(printableMinOdd, 2));
	    			failureLabel += space;
	    		}	
	    		if(!twoWayMarketOk || !marketsOk){
	    			const marketsLabel = getLabel('wagering.markets_wrong');
	    			let marketsDesc = '';
	    			const marketArray = selectionsWrong['twoWayMarketIssue'].length > 0? selectionsWrong['twoWayMarketIssue'] : selectionsWrong['marketsExcludedIssue'];
	    			for(let ks = 0; ks < marketArray.length; ks ++){
	    				const desc = marketArray[ks].selection.bets[0]?.descBet;
	    				marketsDesc += ( "[" + marketArray[ks].selection.descEvent + "] " + desc );
	    				if(ks + 1 < marketArray.length){
	    					marketsDesc += ("," + space);
	    				}
	    			}
	    			
	    			failureLabel += marketsLabel.replaceAll('{{MARKETS}}', marketsDesc);
	    		}    	
	    	}
	    	return {
	    		selectable,
	    		failureLabel,
	    		selectionsWrong
	    	}
	    },
	   
	    isRealMoney : function(){
	    return !(ctxs.betslipContext.getBetOptionsSelection()?.value !== 'REAL');
	    },
	    
	    setRealMoney : function(){
	    	ctxs.betslipContext.setBetOptionsSelection('REAL', null);    
	    },  
	    setBetOptionsSelection : function(value, type){
			console.debug("setBetOptionsSelection");
	    	const data = {
	    		value,
	    		type,
	    		selectableData : null
	    	};
	    	let failureError = null;
	    	ctxs.betslipContext.removeCartMessage();
	    	if(value === 'REAL'){
	    		const redoCalcs = ctxs.betslipContext.betOptionsSelection.type === 'freebet' && ctxs.betslipContext.betOptionsSelection.isRealWagering;
				ctxs.betslipContext.updateFullContext({betOptionsSelection : data});
				if(redoCalcs){
					ctxs.betslipContext.calcAmountsWinnings();				
				}
				return;
			}
	    	if(ctxs.betslipContext.betOptionsData != null){
	    		ctxs.betslipContext.disableAllBetslipPromo();
	    		const coupon = ctxs.betslipContext.getCurrentCoupon();
	    		const originalAmount = coupon.selectedContainer === 'multibets'? coupon.amountMulti : coupon.selections[0].bets[0].amount;
				let wageringAmount = originalAmount;

	 			if(type === 'freebet'){
		    		// taking the choosen freebet amount and redo the calcs	
		    		const freebets = ctxs.betslipContext.betOptionsData.freebets;
		    		let choosenFreebet = null;
		    		for(let k in freebets){
		    			if(freebets[k].id_bonus == value){
		    				wageringAmount = freebets[k].importo;
		    				choosenFreebet = freebets[k];
		    				data.isRealWagering = choosenFreebet.is_real;
		    				break;
		    			}
		    		}
		    		if(choosenFreebet){
		    			const selectableData = ctxs.betslipContext.isWageringPromoSelectable(choosenFreebet);
		    			data.selectableData = selectableData;
		    			if(selectableData.selectable || SELECT_WAGERING_PROMO_ANYWAY){
		    				ctxs.betslipContext.updateFullContext({betOptionsSelection : data, keepWageringError : SELECT_WAGERING_PROMO_ANYWAY});
		    				if(!selectableData.selectable){
		    					// show why
		    					failureError = selectableData.failureLabel;	
		    				}
		    			}
		    			else{
		    				// show why
		    				failureError = selectableData.failureLabel;
		    			}
		    		}
		    	}
		    	else if(type === 'funbonus'){
			    	const isFunbonusForbidden = conf.fb.wfieb && ctxs.betslipContext.user.sportBalance >= conf.cs.imqf;
	
		    		if(isFunbonusForbidden){
		    			ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('general.errors.wagering_not_allowed'));
		    			return;
		    		}
		    		// checking if the betslip amount is available for the selected funbonus. If not, I change it
		    		const funbonuses = ctxs.betslipContext.betOptionsData.funbonuses;
		    		let choosenFunbonus = null;
		    		for(let k in funbonuses){
		    			if(funbonuses[k].id_bonus == value){
		    				choosenFunbonus = funbonuses[k];
		    				data.isRealWagering = choosenFunbonus.is_real;
		    				break;
		    			}
		    		}
		    		if(choosenFunbonus){
		    			// checking the validity of this promotion with the current betslip
		
		    			const selectableData = ctxs.betslipContext.isWageringPromoSelectable(choosenFunbonus);
		    			data.selectableData = selectableData;
		    			if(selectableData.selectable || SELECT_WAGERING_PROMO_ANYWAY){
		    				if(!selectableData.selectable){
		    					// show why
		    					failureError = selectableData.failureLabel;	
		    				}
		    				ctxs.betslipContext.updateFullContext({betOptionsSelection : data, keepWageringError : SELECT_WAGERING_PROMO_ANYWAY});
			    			// if the betslip amount is in the funbonus range (gt min_bet and lt remaining balance) I don't change it
			    			// else:
			    			if(originalAmount < choosenFunbonus.min_bet){
			    				//changing the betslip amount with the min bet of the selected funbonus
			    				wageringAmount = choosenFunbonus.min_bet;		    				
			    			}
			    			else{
			    				if(choosenFunbonus.importo > choosenFunbonus.max_bet){
			    					// the left balance cannot bet spent all at once because is higher than the max_bet accepted
			    					
			    					// if the choosen amount is higher than the max accepted amount
			    					if(originalAmount > choosenFunbonus.max_bet){
			    						// changing the choosen amount to the max_bet acceptable
			    						wageringAmount = choosenFunbonus.max_bet;
			    					}
			    				}
			    				else {
			    					// the left balance could be spent all at once because is lt the max_bet
			    					
			    					//if the choosen amount is higher thant the left balance
			    					if(originalAmount > choosenFunbonus.importo){
					    				// changing the betslip amount with the remaining balance of the selected funbonus
					    				wageringAmount = choosenFunbonus.importo;
			    					}
			    				}
			    			}
		    			}
		    			else{
		    				// show why
		    				failureError = selectableData.failureLabel;	
		    			}
		    		

		    		}		    		
		    	}
	    		if(wageringAmount != 0){
	    			if(coupon.selectedContainer === 'multibets'){
		        		coupon.amountMulti = wageringAmount; // multibets
		        		coupon.printableAmountMulti = getPrintableAmount(wageringAmount, conf.cs.m, conf.cs.nd);
	    			}
	        		else if(coupon.selectedContainer === 'singlebets'){	
	        			const bet = coupon.selections[0].bets[0];
	        			bet.amount = wageringAmount;
	        			bet.printableAmount = getPrintableAmount(bet.amount, conf.cs.m, conf.cs.nd);
	        		}
	    		}

	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    		if(failureError){
	    			if(!SELECT_WAGERING_PROMO_ANYWAY){
		    			ctxs.betslipContext.showModalAdviseIfProvided('error', failureError);	    			
	    			}
	    			ctxs.betslipContext.setCartError(failureError);
	    		}
	    	}
			console.debug("setBetOptionsSelection "+value+" "+type);
	    },
	    
	    getBetOptionsSelection : function(){
	    	return ctxs.betslipContext.betOptionsSelection;
	    },
	    
	    showBetOptions : function(){
	    	ctxs.betslipContext.updateFullContext({betOptionsSectionHasToBeShowed:true});	
	    },
	    hideBetOptions : function(){
			console.debug("hideBetOptions");
			ctxs.betslipContext.updateFullContext({betOptionsSectionHasToBeShowed:false});	
	    },
	    
	    loadBetOptionsIfEnabled : function(){
			// load funbonus / freebet stuff
			const conf = getConfiguration();
			const coupon = ctxs.betslipContext.getCurrentCoupon();
			const correctContainer = (coupon?.selectedContainer === 'multibets'  && coupon.selections.length > 0) || ( coupon?.selectedContainer === 'singlebets' && coupon.selections.length == 1 && coupon.selections[0].bets.length == 1);
		    const funbonusEnabled = conf.fb && conf.fb.en;
		    const isEnabledForThisSkin = (funbonusEnabled || conf.frbe);
		    const isEnabledForThisUser =  ctxs.betslipContext.user && ctxs.betslipContext.user.logged && !ctxs.shopContext.enabled && (ctxs.betslipContext.user.freebetCount || ctxs.betslipContext.user.funbonusCount);
			if(isEnabledForThisSkin && correctContainer && isEnabledForThisUser && !ctxs.betslipContext.isBetBuilder()){		
				const funbonusData = ctxs.betslipContext.user.funbonuses;
	       		const freebetData = ctxs.betslipContext.user.freebets;
	       		const freebets = [];
		       	const funbonuses = [];
		       	const amount  = coupon.amountMulti;
		       	// controllo mostrabilita' sulla lista dei funbonus
		       	if(freebetData?.length > 0){
		    		// e' mostrabile se c'e' almeno un freebet con importo > 0
		    		for(let key in freebetData){
		    			let fb = freebetData[key];
		    			if(fb.importo > 0){	
		    				fb.type = 'freebet';
		    				freebets.push(fb);
		    			}
		    		}
		        }    
		       	// controllo mostrabilita' sulla lista dei funbonus
		       	if(funbonusData?.length > 0){
		    		// e' mostrabile se c'e' almeno un funbonus con importo > 0
		    		for(let key in funbonusData){
		    			let fb = funbonusData[key];
		    			let accepted = fb.importo > 0;
		    			if(conf.fb.sfbo){
		    				// check also the amount validity
		    				accepted = accepted && (amount >= fb.min_bet && amount <= fb.max_bet);
		    			}
		    			if(accepted){	
		    				fb.type = 'funbonus';
		    				funbonuses.push(fb);
		    			}
		    		}
		        }
				if(funbonuses.length > 0 || freebets.length > 0){
			    	// search if the previous selected funbonus/freebet is still available. If not, I select the real money as defalt
			    	let resetSelection = false;
			    	const previousSelection = ctxs.betslipContext.betOptionsSelection;
			    	if(previousSelection && previousSelection.value !== 'REAL'){
			    		resetSelection = true;
			    		for(let kf in funbonuses){
			    			if(funbonuses[kf].id_bonus == previousSelection.value){
			    				resetSelection = false;
			    			}
			    		}
			    		for(let kf in freebets){
			    			if(freebets[kf].id_bonus == previousSelection.value){
			    				resetSelection = false;
			    			}
			    		}
			    	}
			    	if(resetSelection){
			    		ctxs.betslipContext.removeBetOptionsSection();	
			    	}
			    	ctxs.betslipContext.setBetOptionsData({freebets, funbonuses, realMoneyAmount : amount});
			    	ctxs.betslipContext.showBetOptions();
				}
				else{
			    	const previousSelection = ctxs.betslipContext.betOptionsSelection;
			    	ctxs.betslipContext.removeBetOptionsSection();
			    	if(previousSelection && previousSelection.value !== 'REAL'){
			    		const adviseLabel = previousSelection.type === 'funbonus'? getLabel('bet_options.prev_fun_unav') : getLabel('bet_options.prev_free_unav');
			    		ctxs.betslipContext.setCartWarning(adviseLabel);
			    	}
				}
				if(ctxs.betslipContext.betOptionsData != null && (ctxs.betslipContext.betOptionsData.funbonuses.length > 0 || ctxs.betslipContext.betOptionsData.freebets.length > 0)){
					// there is a list of available funbonuses/freebets: each import > 0 is ok!
					let amount = 0;
					if(coupon.selectedContainer === 'singlebets'){
						amount = coupon.selections[0].bets[0].amount;
					}
					else{
						amount = coupon.amountMulti;
					}
					if(amount <= 0){
						ctxs.betslipContext.removeBetOptionsSection();
						ctxs.betslipContext.setCartError(getLabel('carrello.error.empty_amount'));
					}
				}								
			}
	    },
	    setBetOptionsData : function(betOptionsData){
			console.debug("setBetOptionsData "+betOptionsData)
    		ctxs.betslipContext.updateFullContext({betOptionsData});
	    },
	    
	    removeBetOptionsSection : function(keepSelection){
		   console.debug("removeBetOptionsSection keepSelection is"+keepSelection);
	       if(!keepSelection){
	       	ctxs.betslipContext.setBetOptionsSelection('REAL', null);
	       }
    	   ctxs.betslipContext.setBetOptionsData(null);
    	   ctxs.betslipContext.hideBetOptions();
	    },
	    
	    setLoadInProgress : function(value){
	    	if(value){
	    		$('.betslipEffectiveContainer').addClass('blurBetslip');
	    	}
	    	else{
	    		$('.betslipEffectiveContainer').removeClass('blurBetslip');
	    	}
	    },
	    
	    getCouponDrawsNum : function(){
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	return coupon.totalDraws;
	    },
	    getCouponSelectionsNum : function(){
            if (ctxs.betslipContext.betslipData == null) {
                return 0;
            }
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	return coupon.selections.length;
	    },
	    getSelectedCoupon : function (){
	    	return ctxs.betslipContext.betslipData.selectedCoupon;
	    },
	    getPotentialWin : function(){
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	let win = 0;
	    	if(ctxs.betslipContext.stakeTaxConfiguration.enabled && ctxs.betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase'){
	    		win = getCurrencyValue(coupon.stakeTaxedPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);	   
	    	}
	    	else {
	    		win = getCurrencyValue(coupon.potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);	    		
	    	}
	    	return win;
	    },
	    getAppliedBonus : function(){
	    	const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	if(coupon.selectedContainer === 'multibets'){
	    		const bonusDataMulti = coupon.multipleBonus;
	        	if(bonusDataMulti != null && bonusDataMulti.applied){
	        		const bonusWinMulti = getCurrencyValue(bonusDataMulti.bonusAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	        		const description = bonusDataMulti.description;
	        		return {
	        			applied : true,
	        			description,
	        			amount : bonusWinMulti
	        		}
	        	}
	    	}
	    	return{ applied: false};
	    },
        setDefaultAmount : function (defaultAmount) {
            ctxs.betslipContext.betslipData.defaultAmount = defaultAmount >= ctxs.betslipContext.minimumBetAmount ? defaultAmount : ctxs.betslipContext.betslipData.defaultAmount;
            const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
    		coupon.amountMulti = ctxs.betslipContext.betslipData.defaultAmount; // multibets
    		coupon.betOnAll = ctxs.betslipContext.betslipData.defaultAmount;
    		coupon.printableAmountMulti = getPrintableAmount(coupon.amountMulti, conf.cs.m, conf.cs.nd);
    		coupon.printableBetOnAll = getPrintableAmount(coupon.betOnAll, conf.cs.m, conf.cs.nd);
    		for(let ks in coupon.selections){
    			const selection = coupon.selections[ks];
    			for(let kb in selection.bets){
    				const bet = selection.bets[kb];
    				bet.amount = ctxs.betslipContext.betslipData.defaultAmount; // for singlebet
    				bet.printableAmount = getPrintableAmount(bet.amount, conf.cs.m, conf.cs.nd); // for singlebet
    			}
    		}
            ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
        },
	    
	    setKeypadShown : function(value){
	    	ctxs.betslipContext.keypadShown = value;
	    	setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			keypadShown : value
	    		}
	    	});
	    },
	    isKeypadShown : function(){
	    	return ctxs.betslipContext.keypadShown;
	    },
	    
	    enableAddAndBet :function(amount){
    		ctxs.betslipContext.addAndBet = true;
    		ctxs.betslipContext.addAndBetAmount = amount == null? ctxs.betslipContext.betslipData.defaultAmount: amount;
    		const addNBetStorageParams = {
    				amount : ctxs.betslipContext.addAndBetAmount,
    				enabled : ctxs.betslipContext.addAndBet,
    				userToken : ctxs.betslipContext.user? ctxs.betslipContext.user.sessionToken : null
    		}
    		localStorage.setItem('xs_add_n_bet_params', JSON.stringify(addNBetStorageParams));
    		setBetslipContext(function(prev){
    			return {
    				...prev,
    				addAndBet : true,
    				addAndBetAmount : amount,
    				addAndBetToken : addNBetStorageParams.userToken
    			}
    		});
    		ctxs.betslipContext.clearBetslip();
    		ctxs.betslipContext.switchToContainer('singlebets');
	    },
	    disableAddAndBet : function (){
	    	ctxs.betslipContext.addAndBet = false;
	    	ctxs.betslipContext.addAndBetAmount = 0;
	    	ctxs.betslipContext.addAndBetToken = null;
	    	const addNBetSessionStorage = {
	    			amount : 0,
	    			enabled : false,
	    			userToken : null	
	    	};
	    	localStorage.setItem('xs_add_n_bet_params', JSON.stringify(addNBetSessionStorage));
	    	setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			addAndBet : false,
	    			addAndBetAmount : 0,
	    			addAndBetToken : null
	    		}
	    	});
	    },
	    isAddAndBetEnabled : function(){
	    	return ctxs.betslipContext.addAndBet;
	    },
	    switchToContainer(container){
	    	const keyCoupon = ctxs.betslipContext.betslipData.selectedCoupon;
	    	const coupon = ctxs.betslipContext.betslipData.coupons[keyCoupon];
	    	coupon.selectedContainer = container;
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    },
	    toggleSaveBetslipAfterPurchase : function (){
	    	const newValue = !ctxs.betslipContext.betslipData.saveBetslip;
	    	ctxs.betslipContext.betslipData.saveBetslip = newValue;
	    	ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    },
	    isSaveBetslipAfterPurchaseEnabled : function(){
	    	return ctxs.betslipContext.betslipData.saveBetslip;
	    },
	    
	    setTraderAcceptanceProposal : function(acceptanceResponse){
	    	ctxs.betslipContext.saveSelectionsState();
	    	if(acceptanceResponse.oddsChanged){
	    		ctxs.betslipContext.updateOdds(acceptanceResponse);
	    	}
	    	const conf = getConfiguration();
	    	//const coupon = ctxs.betslipContext.betslipData.coupons[ctxs.betslipContext.betslipData.selectedCoupon];
	    	const coupon = ctxs.betslipContext.getCurrentCoupon();
	    	if(coupon.selectedContainer === 'singlebets'){
	    		const firstSelection = coupon.selections[0];
	    		firstSelection.bets[0].amount = acceptanceResponse.proposal;
	    		firstSelection.bets[0].printableAmount = getPrintableAmount(acceptanceResponse.proposal, conf.cs.m, conf.cs.nd);
	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false); // redo calcs
	    	}
	    	else if(coupon.selectedContainer === 'multibets'){
	    		coupon.amountMulti = acceptanceResponse.proposal;
	    		coupon.printableAmountMulti = getPrintableAmount(acceptanceResponse.proposal, conf.cs.m, conf.cs.nd);
	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false); // redo calcs    		
	    	}
	    	
	    	let acceptanceResponseMessage = '';
	    	
	    	const mult = conf.cs.m;
	    	const nDec = conf.cs.nd;
	    	const currency = conf.cs.ct;
			const amC = getCurrencyValue(acceptanceResponse.proposal, mult, nDec, currency);
			if(acceptanceResponse.stakeChanged && acceptanceResponse.oddsChanged){
				// changed both stake and odds
				acceptanceResponseMessage = getLabel('carrello.new_amount_proposal_odds_part1') + amC + getLabel('carrello.new_amount_proposal_part2');
			}
			else if(acceptanceResponse.stakeChanged && !acceptanceResponse.oddsChanged){
				// changed just the stake
				acceptanceResponseMessage = getLabel('carrello.new_amount_proposal_part1') + amC + getLabel('carrello.new_amount_proposal_part2');
			}
			else if(!acceptanceResponse.stakeChanged && acceptanceResponse.oddsChanged){
				acceptanceResponseMessage = getLabel('carrello.proposal_new_odds_part1') + getLabel('carrello.new_amount_proposal_part2');
			}
			
    		setBetslipContext(function(prev){
    			return {
    				...prev,
    				buttonPlayState :'confirm',
    				testAcceptanceDelay : acceptanceResponse.test,
    				cartMessage : {type : 'confirm', message : acceptanceResponseMessage, acceptanceOfferExpirationSeconds : acceptanceResponse.secondsExpiring}
    			}
    		});
    		if(acceptanceResponse.secondsExpiring){
    			const acceptanceOfferTimeout = setTimeout(() => {
    				if(acceptanceResponse.cleanBetslipAtTimeout){
    					ctxs.betslipContext.clearBetslip();
    				}
    				else{
    					ctxs.betslipContext.restoreStateBeforeAcceptance();
    				}
    			}, acceptanceResponse.secondsExpiring * 1000);
    			
    			setBetslipContext(function(prev){
	    			return {
	    				...prev,
	    				acceptanceOfferTimeout : acceptanceOfferTimeout
	    			}
    			});
    		}
    		
    		ctxs.betslipContext.removeBetLoader();
    		ctxs.betslipContext.setTransactionIdAcceptanceForProposal(ctxs.betslipContext.transactionIdAcceptance);
    		ctxs.betslipContext.setTransactionIdAcceptance(null);
	    },
	    
	    clearAcceptanceOfferTimeout : function() {
  			clearTimeout(ctxs.betslipContext.acceptanceOfferTimeout);
  			setBetslipContext(function(prev){
    			return {
    				...prev,
    				acceptanceOfferTimeout : null,
    				testAcceptanceDelay : null
    			}
			});
	    },
	    
	    saveSelectionsState : function(){
			const coupon = ctxs.betslipContext.getCurrentCoupon();
			const selectionsBeforeProposal = JSON.parse(JSON.stringify(coupon.selections));
			const amountMultiBeforeProposal = coupon.amountMulti;
	    	const printableAmountMultiBeforeProposal = coupon.printableAmountMulti;
			setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			selectionsBeforeProposal,
	    			amountMultiBeforeProposal,
	    			printableAmountMultiBeforeProposal
                }
            });
	    },
	    restoreStateBeforeAcceptance : function(){
	    	ctxs.betslipContext.clearAcceptanceOfferTimeout();
	    	if(ctxs.betslipContext.selectionsBeforeProposal || ctxs.betslipContext.amountMultiBeforeProposal){
	    		const coupon = ctxs.betslipContext.getCurrentCoupon();
	    		coupon.selections = ctxs.betslipContext.selectionsBeforeProposal;
	    		coupon.amountMulti = ctxs.betslipContext.amountMultiBeforeProposal;
	    		coupon.printableAmountMulti = ctxs.betslipContext.printableAmountMultiBeforeProposal;
	    		ctxs.betslipContext.setBetslipData(ctxs.betslipContext.betslipData, false, false);
	    	}
	    	ctxs.betslipContext.clearSelectionsStateBeforeAcceptance();
	    },
	    
	    clearSelectionsStateBeforeAcceptance : function(){
	    	ctxs.betslipContext.clearAcceptanceOfferTimeout();
	    	ctxs.betslipContext.setTransactionIdAcceptanceForProposal(null);
	    	setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			selectionsBeforeProposal : null,
	    			amountMultiBeforeProposal : null,
	    			printableAmountMultiBeforeProposal : null,
	    			testAcceptanceDelay : null
                }
            });
	    },
	    
	    switchFocusOnTheFirstAmountField : function (){
	    	if(!isMobile){
	    		const selectedCoupon = ctxs.betslipContext.betslipData.selectedCoupon;
	    		const coupon = ctxs.betslipContext.betslipData.coupons[selectedCoupon];
	    		const selectedContainer = coupon.selectedContainer;
	    		let amountField = $('.amount-field-coupon-' + selectedCoupon + '-container-' + selectedContainer)[0];
	    		if(amountField != null){		
	    			amountField.focus();
	    			amountField.select();
	    		}	    		
	    	}
	    },
        toggleCustomAliases() {
            if (ctxs.betslipContext.enableCustomAliases === true) {
                localStorage.removeItem('xs_custom_aliases_enabled');
            } else {
                localStorage.setItem('xs_custom_aliases_enabled', 'true');
            }
            setBetslipContext(function(prev) {
	    		return {
	    			...prev,
	    			enableCustomAliases: !prev.enableCustomAliases,
	    		};
	    	});
        },
        setToGetBonusAdvise : function (toGetBonus){
	    	ctxs.betslipContext.toGetBonusAdvise = toGetBonus;
        	setBetslipContext(function(prev){
	    		return {
	    			...prev,
	    			toGetBonusAdvise : toGetBonus
                }
            });
        },
        reloadTicket: function(ticketId, playDirectly) {
     	   getTicketData(ticketId, null, xs_sessionToken, (ticket) => {
     	   	   const dataBetslip = getDataAndSelectionsFromBetslipTicketDTO(ticket);
     		   const selections = dataBetslip.selections;
     		   const betBuilderSelections = dataBetslip.betBuilderSelections;
     		   const amount = dataBetslip.amount;
     		   const systemSelections = dataBetslip.systemSelections;
     		   if (selections.length > 0 && amount > 0) {
     			   ctxs.betslipContext.putSelections(selections, amount, systemSelections, betBuilderSelections);
     		   }
			   let someClosedSelection = false;
			   for(let ks in selections){
			   		someClosedSelection = someClosedSelection || selections[ks].closed;
			   }
			   if(someClosedSelection){
			   		ctxs.betslipContext.setCartWarning(getLabel('carrello.error.expired_selections'));
			   		const showVariationModal = window.showBetslipVariationModal && messageOnModalsEnabled;
					if(showVariationModal){
						const selections = ctxs.betslipContext.getCurrentCoupon().selections;
						window.showBetslipVariationModal(selections, getLabel('carrello.var_quota.warning'), () => { ctxs.betslipContext.tryAgainPurchaseFromVariationModal() }, ctxs.betslipContext.getAmountDataForModal())
					}	
			   }
     		   if(playDirectly){
     			   ctxs.betslipContext.purchase();
     		   }
    	   }, () => {});
        },
		playVocalAssistantMessage: function(message) {
			if(ctxs.landingRequestedOpsContext?.vocalAssistant && window.startVocalMessage && message) {
				window.startVocalMessage(message);

				setTimeout(() => {
					if(window.cg_CLIENT_IP_ADDRESS == '89.97.180.13') {
						window.startVocalMessage("Gioco tutti i giorni");
					}
				}, 3000);
			}
		},
		getJsonBetslipForLogiSimulate : function(callback){
			ctxs.betslipContext.hideModalAdviseIfProvided();
			getLogiSimulateSelections(ctxs.betslipContext.betslipData, 'ONLINE', (data) => {
				callback(data);
			},
			() => {
				ctxs.betslipContext.showModalAdviseIfProvided('error', getLabel('general.error_fetching_data'), null);
			});
		}
    });

	ctxs.betslipContext = betslipContext;

	function setSecondScreenBetslip(isVirtual,bonusData){
		ctxs.betslipContext.setVirtual(isVirtual);
		ctxs.betslipContext.setBonusData(bonusData);
		ctxs.betslipContext.calculateLocalStorageKey();
		ctxs.betslipContext.initBetslipData();
	}
    
    useEffect(() =>{
    	if(!props.freezeThisBetslip && ctxs.bonusContext.bonusData){
			const protocol = props.protocolRendered || ( window.getProtocolFromUrl? window.getProtocolFromUrl():null);
        	const isVirtual = protocol === 'PSV';
        	ctxs.betslipContext.calculateLocalStorageKey();
        	ctxs.betslipContext.setVirtual(isVirtual);
        	ctxs.betslipContext.initBetslipData();
        	ctxs.betslipContext.setUser(ctxs.userContext.getUser());
        	ctxs.betslipContext.setBonusData(ctxs.bonusContext.bonusData);
        	ctxs.betslipContext.startLiveSelectionsPollingIfPossible();
        	window.switchFocusOnTheFirstAmountField = function(){
        		ctxs.betslipContext.switchFocusOnTheFirstAmountField();
        	}
        	
          	const windowReloadFunctionCode = function(ticketId, playDirectly){
            	ctxs.betslipContext.reloadTicket(ticketId, playDirectly);
            };
            
        	const reloadTicketFunctionClass = window.reloadTicketFunctionClass? window.reloadTicketFunctionClass : {};
        	
        	window.reloadTicket = windowReloadFunctionCode; // for the old terminal
        	if(props.self){
        		reloadTicketFunctionClass.reloadTicketBetslipSelf = windowReloadFunctionCode;	
        	}
        	else{
        		reloadTicketFunctionClass.reloadTicketBetslipOnlineSportbook = windowReloadFunctionCode;
        	}
        	
        	window.reloadTicketFunctionClass = reloadTicketFunctionClass;
        	
        	
    		// checking if there is a pending transaction in the storage
    		const pendingTransactionData = getPendingFrontendTransactionId();

    		if(pendingTransactionData && pendingTransactionData.type === PURCHASE_RETRY && ctxs.userContext.getUser().logged){	
    			ctxs.betslipContext.startRetryTicketFlowDueToNetworkIssue(pendingTransactionData.frontendTransactionId);
    		}
    		else{
                const lastTicket = window.getLastTicketPurchasedOnLS();
                // checking also if it is a playDirectly operation: if yes, I will do this after the user validation
                if(lastTicket && lastTicket.loadInCartOnRerender && !lastTicket.playDirectly){
                	const protocolOk = (lastTicket.protocol === 'PSV' && isVirtual) || (lastTicket.protocol === 'PSQF' && !isVirtual);
                	if(protocolOk){
                		// void the reload ticket info
                		window.setLastTicketPurchasedOnLS(lastTicket.protocol, lastTicket.id, false, false, lastTicket.amount, lastTicket.win);
                		ctxs.betslipContext.reloadTicket(lastTicket.id, false);
                	}
                }
    		}
    		
    	}
    	else{
    		if(props.freezeThisBetslip){
	    		console.log("This BetslipContext has been freezed: there will be another one later");    	
    		}
    	}
    

    }, [ctxs.bonusContext.hashIntegrity, 
    	ctxs.userContext.getUser(),
    	ctxs.landingRequestedOpsContext.betslipLandingData, 
    	ctxs.shopContext.operator,
    	ctxs.shopContext.selfCashier,
    	ctxs.shopContext.shopBooker,
    	ctxs.controlPanelContext.printerSettings,
    	props.protocolRendered,
    	props.freezeThisBetslip]);

    
    useEffect(() =>{
    	const isPropValued = props.doubleProfileDefaultChoice !== null && props.doubleProfileDefaultChoice !== undefined; // it could be 0
    	if(!ctxs.betslipContext.provDoubleProfileValue && isPropValued){
    		ctxs.betslipContext.setProvSettings(props.doubleProfileDefaultChoice);        	
    	}
    },[props.doubleProfileDefaultChoice]);

	//exporting a testing function for the chrome debugger
	window.setTraderAcceptanceProposal = function(proposal){
		betslipContext.setTraderAcceptanceProposal(proposal);
	};
	window.testTraderAcceptanceProposal = function(){
		betslipContext.setTraderAcceptanceProposal({test: true, proposal:100, cleanBetslipAtTimeout:false, secondsExpiring:10, stakeChanged :true});
	}
    
	window.setBonusPolling = function(value){
		if(value){
			ctxs.bonusContext.enablePolling();			
		}
		else{
			ctxs.bonusContext.disablePolling();	
		}
	};
	window.simulateAcceptance = function(tranId){
		betslipContext.acceptance(tranId)
	}
	window.simulateBetSuccess = function(ticketId, timeoutClose){
		ctxs.bonusContext.disablePolling();
		if(typeof window.openBetslip === 'function'){
	    	window.openBetslip();
	    }
	    window.addBodyShadow();
		betslipContext.setBetSuccess(ticketId, ()=>{});
		if(timeoutClose){
			setTimeout(() => {
				ctxs.betslipContext.removeBetLoader();
				window.removeBodyShadow();
			}, timeoutClose * 1000);
		}

		
	}
	
	useEffect(()=>{
		if(!window.simulateVariationsModal && !props.freezeThisBetslip){
			window.simulateVariationsModal = function(){
				const coupon = ctxs.betslipContext.getCurrentCoupon();
				for(let ks in coupon.selections){
					if(ks == 0){
						coupon.selections[ks].closed = true;
					}
					else if(ks == 1){
						coupon.selections[ks].bets[0].oldOdd = coupon.selections[ks].bets[0].odd;
						coupon.selections[ks].bets[0].odd =	parseInt(coupon.selections[ks].bets[0].odd) + 10;
						coupon.selections[ks].bets[0].updated = 'increased';
					}
					else{
						coupon.selections[ks].bets[0].oldOdd = coupon.selections[ks].bets[0].odd;
						coupon.selections[ks].bets[0].odd =	parseInt(coupon.selections[ks].bets[0].odd) - 10;
						coupon.selections[ks].bets[0].updated = 'decreased';
					}
				}
				window.showBetslipVariationModal(coupon.selections, getLabel('carrello.var_quota.warning'), function(){}, ctxs.betslipContext.getAmountDataForModal());

			}
		}
		window.getJsonBetslipForLogiSimulate = function(callback){
			ctxs.betslipContext.getJsonBetslipForLogiSimulate(callback);
		}

		window.testSimulateLogi = function(){
			ctxs.betslipContext.getJsonBetslipForLogiSimulate((data) => {
				console.log(data);
				if(data?.length > 0){
					window.LOGI_DATA_TO_CONSUME = data;
				}
			});
		}
		//Handling post message for ticket reload when called from mybets popup window
		try {
			window.onmessage = (event) => {
				if (event?.data?.type === 'reloadTicket') {
					if (window.reloadTicket) {
						window.reloadTicket(event.data?.payload?.ticketId);
					}
				}
			  }
		}catch(err) {
			console.error(err);
		}

	},[ctxs.betslipContext.betslipData])
	
	useEffect(()=>{
		if(!window.simulateLiveTimer){
			window.simulateLiveTimer = function(timer){
				ctxs.betslipContext.setBetLoader(true, false, timer, null);
			}
		}
		if(!window.simulatePrematchTimer){
			window.simulatePrematchTimer = function(){
				ctxs.betslipContext.setBetLoader(false, false, null, () => {});
			}
		}
	},[])

	
    return (
    	<BetslipContext.Provider value={betslipContext}>
    	    {props.children}
    	</BetslipContext.Provider>
    );
}

export default BetslipConf;
